import { FormInstance } from "antd/es/form";
import _ from "lodash";
import React from "react";
import { IUserInfoDto } from "../../models/dto/user-info.dto";
import { IValidationData } from "../../models/dto/validation-data";
import { UserService } from "../../services/user-service";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { CWTypeScript } from "../../shared/utilty/js-actions/CWTypeScript";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface ITarimsalSulamaOnSurecler_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface ITarimsalSulamaOnSurecler_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  GoBack: any;
  GoBack_dummy: any;
  GetUserByUsername: any[];
  GetUserByUsername_dummy: any[];
  AktifSirketGetir: any[];
  AktifSirketGetir_dummy: any[];
  GET_ON_SUREC_OZET_GETIR: any[];
  GET_ON_SUREC_OZET_GETIR_dummy: any[];
  GetProjeAsamalari: any[];
  GetProjeAsamalari_dummy: any[];
  GET_SATIS_TEMSILCISI: any[];
  GET_SATIS_TEMSILCISI_dummy: any[];
  GET_PROJE_ON_SUREC: any[];
  GET_PROJE_ON_SUREC_dummy: any[];
  GET_NETSIS_STOK_LISTESI: any[];
  GET_NETSIS_STOK_LISTESI_dummy: any[];
  CATI_GES_ON_KESIF_GETIR: any[];
  CATI_GES_ON_KESIF_GETIR_dummy: any[];
  PROJE_DOSYLARI_GETIR: any[];
  PROJE_DOSYLARI_GETIR_dummy: any[];
  DosyalariDBdenYukle: any[];
  DosyalariDBdenYukle_dummy: any[];
  DosyalariGetir: any[];
  DosyalariGetir_dummy: any[];
  ON_KESIF_KALEMLER_GETIR: any[];
  ON_KESIF_KALEMLER_GETIR_dummy: any[];
  KalemleriDBdenYukle: any[];
  KalemleriDBdenYukle_dummy: any[];
  KalemleriGetir: any[];
  KalemleriGetir_dummy: any[];
  ChangeVisibilityOf: string;
  ChangeVisibilityOf_dummy: string;
  SetValueOf: any;
  SetValueOf_dummy: any;
  KalemSil: any[];
  KalemSil_dummy: any[];
  Notify: boolean;
  Notify_dummy: boolean;
  Multiply: number;
  Multiply_dummy: number;
  KalemEkle: any[];
  KalemEkle_dummy: any[];
  UploadFile: any[];
  UploadFile_dummy: any[];
  DosyaEkle: any[];
  DosyaEkle_dummy: any[];
  ForEach1: UploadFileResponse;
  ForEach1_dummy: UploadFileResponse;
  DownloadFile: any;
  DownloadFile_dummy: any;
  DosyaSil: any[];
  DosyaSil_dummy: any[];
  KaydetHazirla: string;
  KaydetHazirla_dummy: string;
  ON_SUREC_TARIMSAL_SULAMA_KAYDET: any[];
  ON_SUREC_TARIMSAL_SULAMA_KAYDET_dummy: any[];
  PROFORMA_GENEL_BILGILERI_GETIR: any[];
  PROFORMA_GENEL_BILGILERI_GETIR_dummy: any[];
  PROFORMA_KALEMLERI_GETIR: any[];
  PROFORMA_KALEMLERI_GETIR_dummy: any[];
  ForEach2: UploadFileResponse;
  ForEach2_dummy: UploadFileResponse;
  DosyalariKaydetHazirla: string;
  DosyalariKaydetHazirla_dummy: string;
  TopluDosyaKaydet: any[];
  TopluDosyaKaydet_dummy: any[];
  ON_KESIF_PROFORMA_KAYDET: any[];
  ON_KESIF_PROFORMA_KAYDET_dummy: any[];
  NET_KESIF_CATI_GETIR: any[];
  NET_KESIF_CATI_GETIR_dummy: any[];
  GET_PROJEYONETICI_USERS: any[];
  GET_PROJEYONETICI_USERS_dummy: any[];
  ON_SUREC_PM_GERI_AL: any[];
  ON_SUREC_PM_GERI_AL_dummy: any[];
  ON_SUREC_PM_ONAYLA: any[];
  ON_SUREC_PM_ONAYLA_dummy: any[];
  ON_SUREC_UY_ONAY_GERIAL: any[];
  ON_SUREC_UY_ONAY_GERIAL_dummy: any[];
  ON_SUREC_UY_ONAYLA: any[];
  ON_SUREC_UY_ONAYLA_dummy: any[];
  isComp379455Visible: "visible" | "hidden";
  isComp321509Visible: "visible" | "hidden";
  isComp930685Visible: "visible" | "hidden";
  isComp200548Visible: "visible" | "hidden";
  isComp38139Visible: "visible" | "hidden";
  isComp230193Visible: "visible" | "hidden";
  isComp108416Visible: "visible" | "hidden";
  isComp167824Visible: "visible" | "hidden";
  isComp995070Visible: "visible" | "hidden";
  isComp606562Visible: "visible" | "hidden";
  isComp777039Visible: "visible" | "hidden";
  isComp682157Visible: "visible" | "hidden";
  isComp457735Visible: "visible" | "hidden";
  isComp724523Visible: "visible" | "hidden";
  isComp867312Visible: "visible" | "hidden";
  isComp970414Visible: "visible" | "hidden";
  isComp987888Visible: "visible" | "hidden";
  isComp564425Visible: "visible" | "hidden";
  isComp98381Visible: "visible" | "hidden";
  isComp825089Visible: "visible" | "hidden";
  isComp340333Visible: "visible" | "hidden";
  isComp589579Visible: "visible" | "hidden";
  isComp278838Visible: "visible" | "hidden";
  isComp788639Visible: "visible" | "hidden";
  isComp557821Visible: "visible" | "hidden";
  isComp171830Visible: "visible" | "hidden";
  isComp485928Visible: "visible" | "hidden";
  isComp429832Visible: "visible" | "hidden";
  isComp384588Visible: "visible" | "hidden";
  isComp814465Visible: "visible" | "hidden";
  isComp831693Visible: "visible" | "hidden";
  isComp551404Visible: "visible" | "hidden";
  isComp687126Visible: "visible" | "hidden";
  isComp759553Visible: "visible" | "hidden";
  isComp52540Visible: "visible" | "hidden";
  isComp647527Visible: "visible" | "hidden";
  isComp371141Visible: "visible" | "hidden";
  isComp583734Visible: "visible" | "hidden";
  isComp3461Visible: "visible" | "hidden";
  isComp848368Visible: "visible" | "hidden";
  isComp135945Visible: "visible" | "hidden";
  isComp289590Visible: "visible" | "hidden";
  isComp432583Visible: "visible" | "hidden";
  isComp781192Visible: "visible" | "hidden";
  isComp465589Visible: "visible" | "hidden";
  isComp848477Visible: "visible" | "hidden";
  isComp500544Visible: "visible" | "hidden";
  isComp233488Visible: "visible" | "hidden";
  isComp320489Visible: "visible" | "hidden";
  isComp480487Enabled: "enabled" | "disabled";
  isComp353063Enabled: "enabled" | "disabled";
  isComp570640Enabled: "enabled" | "disabled";
  isComp759553Enabled: "enabled" | "disabled";
  isComp451651Enabled: "enabled" | "disabled";
  isComptarimsalsulamaonsurecler_261399AuthorizationVisible:
    | "visible"
    | "hidden";
  isComptarimsalsulamaonsurecler_367991AuthorizationVisible:
    | "visible"
    | "hidden";
  isComptarimsalsulamaonsurecler_832682AuthorizationVisible:
    | "visible"
    | "hidden";
  isComptarimsalsulamaonsurecler_899938AuthorizationVisible:
    | "visible"
    | "hidden";
  isComptarimsalsulamaonsurecler_442005AuthorizationVisible:
    | "visible"
    | "hidden";
  isComptarimsalsulamaonsurecler_494735AuthorizationVisible:
    | "visible"
    | "hidden";
  isComptarimsalsulamaonsurecler_135945AuthorizationVisible:
    | "visible"
    | "hidden";
}

export class TarimsalSulamaOnSurecler_ScreenBase extends React.PureComponent<
  ITarimsalSulamaOnSurecler_ScreenProps,
  any
> {
  tarimsalsulamaonsurecler_913183_value_kuikaDateRef: React.RefObject<any>;
  tarimsalsulamaonsurecler_234840_value_kuikaSelectBoxRef: React.RefObject<any>;
  tarimsalsulamaonsurecler_707377_value_kuikaSelectBoxRef: React.RefObject<any>;
  tarimsalsulamaonsurecler_166467_value_kuikaSelectBoxRef: React.RefObject<any>;
  tarimsalsulamaonsurecler_149112_value_kuikaSelectBoxRef: React.RefObject<any>;
  tarimsalsulamaonsurecler_380385_value_kuikaSelectBoxRef: React.RefObject<any>;
  tarimsalsulamaonsurecler_628425_value_kuikaSelectBoxRef: React.RefObject<any>;
  tarimsalsulamaonsurecler_681014_value_kuikaSelectBoxRef: React.RefObject<any>;
  tarimsalsulamaonsurecler_321509_value_kuikaSelectBoxRef: React.RefObject<any>;
  tarimsalsulamaonsurecler_174079_value_kuikaSelectBoxRef: React.RefObject<any>;
  tarimsalsulamaonsurecler_118876_value_kuikaSelectBoxRef: React.RefObject<any>;
  tarimsalsulamaonsurecler_900878_value_kuikaSelectBoxRef: React.RefObject<any>;
  tarimsalsulamaonsurecler_753684_value_kuikaSelectBoxRef: React.RefObject<any>;
  tarimsalsulamaonsurecler_648547_value_kuikaSelectBoxRef: React.RefObject<any>;
  tarimsalsulamaonsurecler_546366_value_kuikaSelectBoxRef: React.RefObject<any>;
  tarimsalsulamaonsurecler_124355_value_kuikaSelectBoxRef: React.RefObject<any>;
  tarimsalsulamaonsurecler_994578_value_kuikaSelectBoxRef: React.RefObject<any>;
  tarimsalsulamaonsurecler_478263_value_kuikaTableRef: React.RefObject<any>;
  tarimsalsulamaonsurecler_393036_value_kuikaAutoCompleteRef: React.RefObject<any>;
  tarimsalsulamaonsurecler_801362_value_kuikaTableRef: React.RefObject<any>;
  tarimsalsulamaonsurecler_200053_value_kuikaTableRef: React.RefObject<any>;
  tarimsalsulamaonsurecler_266261_value_kuikaTableRef: React.RefObject<any>;
  tarimsalsulamaonsurecler_88388_value_kuikaDateRef: React.RefObject<any>;
  tarimsalsulamaonsurecler_390590_value_kuikaSelectBoxRef: React.RefObject<any>;
  tarimsalsulamaonsurecler_428549_value_kuikaSelectBoxRef: React.RefObject<any>;
  tarimsalsulamaonsurecler_301315_value_kuikaSelectBoxRef: React.RefObject<any>;
  tarimsalsulamaonsurecler_347190_value_kuikaSelectBoxRef: React.RefObject<any>;
  tarimsalsulamaonsurecler_248435_value_kuikaSelectBoxRef: React.RefObject<any>;
  tarimsalsulamaonsurecler_54683_value_kuikaSelectBoxRef: React.RefObject<any>;
  tarimsalsulamaonsurecler_726812_value_kuikaSelectBoxRef: React.RefObject<any>;
  tarimsalsulamaonsurecler_320807_value_kuikaSelectBoxRef: React.RefObject<any>;
  tarimsalsulamaonsurecler_716982_value_kuikaSelectBoxRef: React.RefObject<any>;
  tarimsalsulamaonsurecler_407044_value_kuikaSelectBoxRef: React.RefObject<any>;
  tarimsalsulamaonsurecler_232820_value_kuikaSelectBoxRef: React.RefObject<any>;
  tarimsalsulamaonsurecler_822795_value_kuikaTableRef: React.RefObject<any>;
  tarimsalsulamaonsurecler_508933_value_kuikaTableRef: React.RefObject<any>;
  ml = [
    {
      Id: "08e1cb20-24ad-e190-d46b-beded98dd4ae",
      Name: "tr_TR",
      ShortName: "Turkish",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "4106607f-9ae3-47ff-8d8a-3ced44ab92c6",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [],
    },
    {
      Id: "56c30d65-32bd-4138-a8e8-51e307562822",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 547809, PropertyName: "value", Value: "·" },
        { Id: 114330, PropertyName: "value", Value: "- Proje Detayları" },
        { Id: 19253, PropertyName: "value", Value: "|" },
        { Id: 551015, PropertyName: "value", Value: "|" },
        { Id: 321188, PropertyName: "value", Value: "→" },
        { Id: 490554, PropertyName: "tab", Value: "📋 Özet" },
        { Id: 370812, PropertyName: "value", Value: "PROJE BİLGİLERİ" },
        { Id: 873090, PropertyName: "value", Value: "Kategori:" },
        { Id: 707335, PropertyName: "value", Value: "Netsis Kodu:" },
        { Id: 692080, PropertyName: "value", Value: "Müşteri:" },
        { Id: 756078, PropertyName: "value", Value: "İletişim:" },
        { Id: 300522, PropertyName: "value", Value: "Telefon:" },
        { Id: 652581, PropertyName: "value", Value: "ÖN SÜRECİN ÖZETİ" },
        { Id: 695712, PropertyName: "value", Value: "Ön Keşif:" },
        { Id: 189120, PropertyName: "value", Value: "-" },
        { Id: 682190, PropertyName: "value", Value: "Bekliyor" },
        { Id: 942475, PropertyName: "value", Value: "Proforma:" },
        { Id: 125778, PropertyName: "value", Value: "-" },
        { Id: 50774, PropertyName: "value", Value: "Bekliyor" },
        { Id: 569873, PropertyName: "value", Value: "Net Keşif:" },
        { Id: 398768, PropertyName: "value", Value: "-" },
        { Id: 245857, PropertyName: "value", Value: "Bekliyor" },
        { Id: 66815, PropertyName: "value", Value: "PM Onayı:" },
        { Id: 501661, PropertyName: "value", Value: "-" },
        { Id: 928750, PropertyName: "value", Value: "Bekliyor" },
        { Id: 954260, PropertyName: "value", Value: "Yönetim:" },
        { Id: 964154, PropertyName: "value", Value: "-" },
        { Id: 311614, PropertyName: "value", Value: "Bekliyor" },
        { Id: 644014, PropertyName: "value", Value: "KEŞİF TEKNİK ÖZET" },
        { Id: 921297, PropertyName: "value", Value: "kWp Güç" },
        { Id: 892535, PropertyName: "value", Value: "m² Alan" },
        { Id: 210361, PropertyName: "value", Value: "Çatı Tipi" },
        { Id: 416312, PropertyName: "value", Value: "Tahmini Maliyet" },
        { Id: 367991, PropertyName: "tab", Value: "🔍 Ön Keşif" },
        {
          Id: 503808,
          PropertyName: "value",
          Value: "📋 GENEL PROJE VE MÜŞTERİ BİLGİLERİ",
        },
        { Id: 824192, PropertyName: "value", Value: "Proje Adı / Müşteri" },
        {
          Id: 203346,
          PropertyName: "placeholder",
          Value: "Proje Adı / Müşteri",
        },
        { Id: 440869, PropertyName: "value", Value: "Keşif Tarihi" },
        { Id: 913183, PropertyName: "placeholder", Value: "Tarih Seçin..." },
        { Id: 906806, PropertyName: "value", Value: "Konum (İl/İlçe/Köy)" },
        {
          Id: 558557,
          PropertyName: "placeholder",
          Value: "Konum (İl/İlçe/Köy)",
        },
        { Id: 697421, PropertyName: "value", Value: "Kullanıcı Seçiniz" },
        {
          Id: 234840,
          PropertyName: "placeholder",
          Value: "Kullanıcı Seçiniz ...",
        },
        {
          Id: 319997,
          PropertyName: "value",
          Value: "⚡ KUYU VE SU KAYNAĞI BİLGİLERİ",
        },
        {
          Id: 813625,
          PropertyName: "value",
          Value: "Kuyu Toplam Derinliği (m)",
        },
        { Id: 14467, PropertyName: "placeholder", Value: "Sözleşme Gücü (kW)" },
        {
          Id: 716896,
          PropertyName: "value",
          Value: "Statik Seviye (Durgun) (m)",
        },
        { Id: 766200, PropertyName: "placeholder", Value: "Trafo Gücü (kVA)" },
        {
          Id: 398710,
          PropertyName: "value",
          Value: "Dinamik Seviye (Çalışırken) (m)",
        },
        {
          Id: 145387,
          PropertyName: "placeholder",
          Value: "Ana Şalter Akımı (A)",
        },
        { Id: 588963, PropertyName: "value", Value: "Su Kaynağı Tipi" },
        { Id: 707377, PropertyName: "placeholder", Value: "Su Kaynağı Tipi" },
        {
          Id: 152274,
          PropertyName: "value",
          Value: "Kuyu Verimi (Debi) (m3/saat)",
        },
        { Id: 743336, PropertyName: "placeholder", Value: "Pano Mesafesi (m)" },
        {
          Id: 340500,
          PropertyName: "value",
          Value: "🏗   MEVCUT POMPA VE MOTOR TEKNİK VERİLERİ",
        },
        { Id: 66394, PropertyName: "value", Value: "Pompa Tipi" },
        { Id: 166467, PropertyName: "placeholder", Value: "Pompa Tipi" },
        { Id: 333518, PropertyName: "value", Value: "Motor Gücü" },
        { Id: 724523, PropertyName: "placeholder", Value: "Eğim (°)" },
        { Id: 867312, PropertyName: "placeholder", Value: "Eğim (°)" },
        { Id: 149112, PropertyName: "placeholder", Value: "Birimi" },
        { Id: 287977, PropertyName: "value", Value: "Çalışma Gerilimi" },
        { Id: 380385, PropertyName: "placeholder", Value: "Çalışma Gerilimi" },
        { Id: 595525, PropertyName: "value", Value: "Nominal Akım (A)" },
        {
          Id: 886075,
          PropertyName: "placeholder",
          Value: "Kullanılabilir Alan (m²)",
        },
        { Id: 386476, PropertyName: "value", Value: "Pompa Marka/Model" },
        { Id: 186956, PropertyName: "placeholder", Value: "Ada / Parsel" },
        { Id: 517137, PropertyName: "value", Value: "Mevcut Sürücü/Pano" },
        {
          Id: 628425,
          PropertyName: "placeholder",
          Value: "Mevcut Sürücü/Pano",
        },
        {
          Id: 536916,
          PropertyName: "value",
          Value: "SAHA VE PANEL YERLEŞİM BİLGİLERİ",
        },
        { Id: 442969, PropertyName: "value", Value: "Kurulum Alanı" },
        { Id: 681014, PropertyName: "placeholder", Value: "Kurulum Alanı" },
        { Id: 8453, PropertyName: "value", Value: "Zemin Yapısı" },
        { Id: 321509, PropertyName: "placeholder", Value: "Zemin Yapısı" },
        { Id: 310926, PropertyName: "placeholder", Value: "Ada / Parsel" },
        { Id: 763866, PropertyName: "value", Value: "Gölgeleme Analizi" },
        { Id: 174079, PropertyName: "placeholder", Value: "Gölgeleme Analizi" },
        {
          Id: 763120,
          PropertyName: "value",
          Value: "Tahmini Kullanılabilir Alan (m2)",
        },
        { Id: 107465, PropertyName: "placeholder", Value: "Eğim (°)" },
        {
          Id: 744692,
          PropertyName: "value",
          Value: "İnverter - Panel Alanı Arası Mesafe",
        },
        {
          Id: 542990,
          PropertyName: "placeholder",
          Value: "İnverter - Panel Alanı Arası Mesafe",
        },
        {
          Id: 479419,
          PropertyName: "value",
          Value: "İnverter - Pano Alanı Arası Mesafe",
        },
        {
          Id: 195553,
          PropertyName: "placeholder",
          Value: "İnverter - Pano Alanı Arası Mesafe",
        },
        {
          Id: 927333,
          PropertyName: "value",
          Value: "SİSTEM TİPİ VE ELEKTRİK ALTYAPISI",
        },
        { Id: 893765, PropertyName: "value", Value: "Sistem Modeli" },
        { Id: 118876, PropertyName: "placeholder", Value: "Sistem Modeli" },
        { Id: 185287, PropertyName: "value", Value: "Trafo Bilgisi (m)" },
        {
          Id: 80062,
          PropertyName: "placeholder",
          Value: "İnverter - Panel Alanı Arası Mesafe",
        },
        { Id: 621953, PropertyName: "value", Value: "Kablo Yolu Durumu" },
        { Id: 900878, PropertyName: "placeholder", Value: "Kablo Yolu Durumu" },
        {
          Id: 15095,
          PropertyName: "value",
          Value: "SULAMA REJİMİ VE İHTİYAÇLAR",
        },
        { Id: 525118, PropertyName: "value", Value: "Günlük Su İhtiyacı (m3)" },
        {
          Id: 928420,
          PropertyName: "placeholder",
          Value: "İnverter - Panel Alanı Arası Mesafe",
        },
        { Id: 139215, PropertyName: "value", Value: "Sulama Dönemi" },
        { Id: 753684, PropertyName: "placeholder", Value: "Sulama Dönemi" },
        { Id: 715451, PropertyName: "value", Value: "Sulama Yöntemi" },
        { Id: 648547, PropertyName: "placeholder", Value: "Sulama Yöntemi" },
        { Id: 478175, PropertyName: "value", Value: "LOJİSTİK VE GÜVENLİK" },
        { Id: 331452, PropertyName: "value", Value: "Saha Ulaşımı" },
        { Id: 546366, PropertyName: "placeholder", Value: "Saha Ulaşımı" },
        { Id: 544294, PropertyName: "value", Value: "Güvenlik" },
        { Id: 124355, PropertyName: "placeholder", Value: "Güvenlik" },
        { Id: 984406, PropertyName: "value", Value: "Topraklama Alanı" },
        { Id: 994578, PropertyName: "placeholder", Value: "Topraklama Alanı" },
        { Id: 777770, PropertyName: "value", Value: "📦 Malzeme Kalemleri" },
        { Id: 686210, PropertyName: "title", Value: "Title" },
        { Id: 796619, PropertyName: "value", Value: "[datafield:stokkodu]" },
        { Id: 43044, PropertyName: "value", Value: "[datafield:stokadi]" },
        { Id: 717414, PropertyName: "value", Value: "[datafield:birimfiyat]" },
        { Id: 976519, PropertyName: "value", Value: "[datafield:miktar]" },
        { Id: 183286, PropertyName: "value", Value: "[datafield:satırtoplam]" },
        { Id: 611509, PropertyName: "value", Value: "Stok Seçiniz" },
        { Id: 393036, PropertyName: "placeholder", Value: "Stok Seçiniz..." },
        { Id: 335749, PropertyName: "value", Value: "Miktar Giriniz" },
        { Id: 207266, PropertyName: "placeholder", Value: "Miktar Giriniz" },
        { Id: 345017, PropertyName: "value", Value: "Birim" },
        { Id: 480487, PropertyName: "placeholder", Value: "Kablo Yolu" },
        { Id: 464718, PropertyName: "value", Value: "Fiyat" },
        { Id: 542792, PropertyName: "value", Value: "Toplam Fiyat" },
        { Id: 570640, PropertyName: "placeholder", Value: "Miktar Giriniz" },
        { Id: 740127, PropertyName: "label", Value: "Ekle" },
        { Id: 282201, PropertyName: "value", Value: "📝 Açıklamalar" },
        { Id: 581913, PropertyName: "value", Value: "Açıklama 1" },
        {
          Id: 225026,
          PropertyName: "placeholder",
          Value: "İyi durumda, ek güçlendirme gerekmez.",
        },
        { Id: 36234, PropertyName: "value", Value: "Açıklama 2" },
        {
          Id: 26200,
          PropertyName: "placeholder",
          Value: "İyi durumda, ek güçlendirme gerekmez.",
        },
        { Id: 141893, PropertyName: "value", Value: "Açıklama 3" },
        {
          Id: 122352,
          PropertyName: "placeholder",
          Value: "İyi durumda, ek güçlendirme gerekmez.",
        },
        { Id: 673720, PropertyName: "value", Value: "📎 Dosyalar" },
        { Id: 923782, PropertyName: "value", Value: "Mevcut Dosyalar" },
        { Id: 261776, PropertyName: "label", Value: "Dosya Seç" },
        { Id: 850690, PropertyName: "title", Value: "Title" },
        { Id: 650738, PropertyName: "value", Value: "[datafield:dosyaadi]" },
        {
          Id: 338419,
          PropertyName: "value",
          Value: "💰 Ön Keşif Tahmini Maliyet",
        },
        { Id: 970414, PropertyName: "label", Value: "Kaydet" },
        { Id: 832682, PropertyName: "tab", Value: "📄 Proforma" },
        { Id: 520939, PropertyName: "value", Value: "Proje Kalemleri" },
        { Id: 997817, PropertyName: "value", Value: "Fİş No" },
        { Id: 82573, PropertyName: "value", Value: "Stok Kodu" },
        { Id: 928284, PropertyName: "value", Value: "Stok Adı" },
        { Id: 154932, PropertyName: "value", Value: "Miktar" },
        { Id: 326943, PropertyName: "value", Value: "DovFiyat" },
        { Id: 122991, PropertyName: "value", Value: "Para Birimi" },
        { Id: 627546, PropertyName: "value", Value: "Net Fiyat" },
        { Id: 701124, PropertyName: "value", Value: "İskonto 1" },
        { Id: 226622, PropertyName: "value", Value: "İskonto2" },
        { Id: 146773, PropertyName: "value", Value: "DovTutar" },
        { Id: 356033, PropertyName: "title", Value: "Title" },
        { Id: 636206, PropertyName: "value", Value: "[datafield:fisno]" },
        { Id: 677195, PropertyName: "value", Value: "[datafield:stok_kodu]" },
        { Id: 510154, PropertyName: "value", Value: "[datafield:stok_adi]" },
        { Id: 527337, PropertyName: "value", Value: "[datafield:sthar_gcmik]" },
        {
          Id: 558229,
          PropertyName: "value",
          Value: "[datafield:sthar_dovfiat]",
        },
        { Id: 167227, PropertyName: "value", Value: "[datafield:para_birimi]" },
        { Id: 302205, PropertyName: "value", Value: "[datafield:sthar_nf]" },
        { Id: 603208, PropertyName: "value", Value: "[datafield:isk1]" },
        { Id: 499387, PropertyName: "value", Value: "[datafield:isk2]" },
        { Id: 324527, PropertyName: "value", Value: "[datafield:doviztut]" },
        { Id: 746410, PropertyName: "value", Value: "💰 Net Keşif Maliyet" },
        { Id: 927461, PropertyName: "value", Value: "📎 Dosyalar" },
        { Id: 194557, PropertyName: "value", Value: "Mevcut Dosyalar" },
        { Id: 410008, PropertyName: "label", Value: "Dosya Seç" },
        { Id: 319112, PropertyName: "title", Value: "Title" },
        { Id: 172441, PropertyName: "value", Value: "[datafield:dosyaadi]" },
        { Id: 673242, PropertyName: "value", Value: "📋 Genel Bilgiler" },
        { Id: 700575, PropertyName: "value", Value: "Proforma Tutar" },
        { Id: 95182, PropertyName: "value", Value: "Proforma Notu" },
        { Id: 169821, PropertyName: "placeholder", Value: "Proforma Notu" },
        { Id: 641491, PropertyName: "label", Value: "Kaydet" },
        { Id: 899938, PropertyName: "tab", Value: "📐 Net Keşif" },
        {
          Id: 60218,
          PropertyName: "value",
          Value: "📋 GENEL PROJE VE MÜŞTERİ BİLGİLERİ",
        },
        { Id: 805819, PropertyName: "value", Value: "Proje Adı / Müşteri" },
        {
          Id: 964792,
          PropertyName: "placeholder",
          Value: "Proje Adı / Müşteri",
        },
        { Id: 142482, PropertyName: "value", Value: "Keşif Tarihi" },
        { Id: 88388, PropertyName: "placeholder", Value: "Tarih Seçin..." },
        { Id: 67810, PropertyName: "value", Value: "Konum (İl/İlçe/Köy)" },
        {
          Id: 715365,
          PropertyName: "placeholder",
          Value: "Konum (İl/İlçe/Köy)",
        },
        { Id: 900250, PropertyName: "value", Value: "Kullanıcı Seçiniz" },
        {
          Id: 390590,
          PropertyName: "placeholder",
          Value: "Kullanıcı Seçiniz ...",
        },
        {
          Id: 103855,
          PropertyName: "value",
          Value: "⚡ KUYU VE SU KAYNAĞI BİLGİLERİ",
        },
        {
          Id: 949229,
          PropertyName: "value",
          Value: "Kuyu Toplam Derinliği (m)",
        },
        {
          Id: 606165,
          PropertyName: "placeholder",
          Value: "Sözleşme Gücü (kW)",
        },
        {
          Id: 987311,
          PropertyName: "value",
          Value: "Statik Seviye (Durgun) (m)",
        },
        { Id: 205697, PropertyName: "placeholder", Value: "Trafo Gücü (kVA)" },
        {
          Id: 349548,
          PropertyName: "value",
          Value: "Dinamik Seviye (Çalışırken) (m)",
        },
        {
          Id: 137398,
          PropertyName: "placeholder",
          Value: "Ana Şalter Akımı (A)",
        },
        { Id: 95966, PropertyName: "value", Value: "Su Kaynağı Tipi" },
        { Id: 428549, PropertyName: "placeholder", Value: "Su Kaynağı Tipi" },
        {
          Id: 562513,
          PropertyName: "value",
          Value: "Kuyu Verimi (Debi) (m3/saat)",
        },
        { Id: 299122, PropertyName: "placeholder", Value: "Pano Mesafesi (m)" },
        {
          Id: 910300,
          PropertyName: "value",
          Value: "🏗   MEVCUT POMPA VE MOTOR TEKNİK VERİLERİ",
        },
        { Id: 447392, PropertyName: "value", Value: "Pompa Tipi" },
        { Id: 301315, PropertyName: "placeholder", Value: "Pompa Tipi" },
        { Id: 148824, PropertyName: "value", Value: "Motor Gücü" },
        { Id: 987888, PropertyName: "placeholder", Value: "Eğim (°)" },
        { Id: 564425, PropertyName: "placeholder", Value: "Eğim (°)" },
        { Id: 347190, PropertyName: "placeholder", Value: "Birimi" },
        { Id: 994987, PropertyName: "value", Value: "Çalışma Gerilimi" },
        { Id: 248435, PropertyName: "placeholder", Value: "Çalışma Gerilimi" },
        { Id: 186955, PropertyName: "value", Value: "Nominal Akım (A)" },
        {
          Id: 527428,
          PropertyName: "placeholder",
          Value: "Kullanılabilir Alan (m²)",
        },
        { Id: 121908, PropertyName: "value", Value: "Pompa Marka/Model" },
        { Id: 363152, PropertyName: "placeholder", Value: "Ada / Parsel" },
        { Id: 754054, PropertyName: "value", Value: "Mevcut Sürücü/Pano" },
        { Id: 54683, PropertyName: "placeholder", Value: "Mevcut Sürücü/Pano" },
        {
          Id: 947535,
          PropertyName: "value",
          Value: "SAHA VE PANEL YERLEŞİM BİLGİLERİ",
        },
        { Id: 897320, PropertyName: "value", Value: "Kurulum Alanı" },
        { Id: 726812, PropertyName: "placeholder", Value: "Kurulum Alanı" },
        { Id: 369632, PropertyName: "value", Value: "Zemin Yapısı" },
        { Id: 320807, PropertyName: "placeholder", Value: "Zemin Yapısı" },
        { Id: 530736, PropertyName: "placeholder", Value: "Ada / Parsel" },
        { Id: 10475, PropertyName: "value", Value: "Gölgeleme Analizi" },
        { Id: 716982, PropertyName: "placeholder", Value: "Gölgeleme Analizi" },
        {
          Id: 326886,
          PropertyName: "value",
          Value: "Tahmini Kullanılabilir Alan (m2)",
        },
        { Id: 39609, PropertyName: "placeholder", Value: "Eğim (°)" },
        {
          Id: 909105,
          PropertyName: "value",
          Value: "İnverter - Panel Alanı Arası Mesafe",
        },
        {
          Id: 468368,
          PropertyName: "placeholder",
          Value: "İnverter - Panel Alanı Arası Mesafe",
        },
        {
          Id: 703267,
          PropertyName: "value",
          Value: "İnverter - Pano Alanı Arası Mesafe",
        },
        {
          Id: 732086,
          PropertyName: "placeholder",
          Value: "İnverter - Pano Alanı Arası Mesafe",
        },
        {
          Id: 621102,
          PropertyName: "value",
          Value: "SİSTEM TİPİ VE ELEKTRİK ALTYAPISI",
        },
        { Id: 295762, PropertyName: "value", Value: "Sistem Modeli" },
        { Id: 407044, PropertyName: "placeholder", Value: "Sistem Modeli" },
        { Id: 632611, PropertyName: "value", Value: "Trafo Bilgisi (m)" },
        {
          Id: 39980,
          PropertyName: "placeholder",
          Value: "İnverter - Panel Alanı Arası Mesafe",
        },
        { Id: 632893, PropertyName: "value", Value: "Kablo Yolu Durumu" },
        { Id: 232820, PropertyName: "placeholder", Value: "Kablo Yolu Durumu" },
        { Id: 442005, PropertyName: "tab", Value: "👔 PY Onayı" },
        { Id: 940673, PropertyName: "value", Value: "Proje Kalemleri" },
        { Id: 514036, PropertyName: "value", Value: "Fİş No" },
        { Id: 41543, PropertyName: "value", Value: "Stok Kodu" },
        { Id: 351835, PropertyName: "value", Value: "Stok Adı" },
        { Id: 660333, PropertyName: "value", Value: "Miktar" },
        { Id: 508214, PropertyName: "value", Value: "DovFiyat" },
        { Id: 575850, PropertyName: "value", Value: "Para Birimi" },
        { Id: 328602, PropertyName: "value", Value: "Net Fiyat" },
        { Id: 542611, PropertyName: "value", Value: "İskonto 1" },
        { Id: 637662, PropertyName: "value", Value: "İskonto2" },
        { Id: 12003, PropertyName: "value", Value: "DovTutar" },
        { Id: 353882, PropertyName: "title", Value: "Title" },
        { Id: 984907, PropertyName: "value", Value: "[datafield:fisno]" },
        { Id: 338368, PropertyName: "value", Value: "[datafield:stok_kodu]" },
        { Id: 991485, PropertyName: "value", Value: "[datafield:stok_adi]" },
        { Id: 125528, PropertyName: "value", Value: "[datafield:sthar_gcmik]" },
        {
          Id: 587266,
          PropertyName: "value",
          Value: "[datafield:sthar_dovfiat]",
        },
        { Id: 552037, PropertyName: "value", Value: "[datafield:para_birimi]" },
        { Id: 770495, PropertyName: "value", Value: "[datafield:sthar_nf]" },
        { Id: 816457, PropertyName: "value", Value: "[datafield:isk1]" },
        { Id: 499930, PropertyName: "value", Value: "[datafield:isk2]" },
        { Id: 124691, PropertyName: "value", Value: "[datafield:doviztut]" },
        { Id: 171631, PropertyName: "value", Value: "💰 Net Keşif Maliyet" },
        { Id: 377392, PropertyName: "value", Value: "PROJE BİLGİLERİ" },
        { Id: 36005, PropertyName: "value", Value: "Kategori:" },
        { Id: 467975, PropertyName: "value", Value: "Netsis Kodu:" },
        { Id: 343483, PropertyName: "value", Value: "Müşteri:" },
        { Id: 390610, PropertyName: "value", Value: "İletişim:" },
        { Id: 391696, PropertyName: "value", Value: "Telefon:" },
        { Id: 359594, PropertyName: "value", Value: "ÖN SÜRECİN ÖZETİ" },
        { Id: 724741, PropertyName: "value", Value: "Ön Keşif:" },
        { Id: 769315, PropertyName: "value", Value: "-" },
        { Id: 283877, PropertyName: "value", Value: "Bekliyor" },
        { Id: 697210, PropertyName: "value", Value: "Proforma:" },
        { Id: 979155, PropertyName: "value", Value: "-" },
        { Id: 904529, PropertyName: "value", Value: "Bekliyor" },
        { Id: 653453, PropertyName: "value", Value: "Net Keşif:" },
        { Id: 785953, PropertyName: "value", Value: "-" },
        { Id: 789758, PropertyName: "value", Value: "Bekliyor" },
        { Id: 115413, PropertyName: "value", Value: "PM Onayı:" },
        { Id: 265953, PropertyName: "value", Value: "-" },
        { Id: 478901, PropertyName: "value", Value: "Bekliyor" },
        { Id: 893975, PropertyName: "value", Value: "Yönetim:" },
        { Id: 536017, PropertyName: "value", Value: "-" },
        { Id: 286761, PropertyName: "value", Value: "Bekliyor" },
        { Id: 523429, PropertyName: "value", Value: "KEŞİF TEKNİK ÖZET" },
        { Id: 242331, PropertyName: "value", Value: "kWp Güç" },
        { Id: 874933, PropertyName: "value", Value: "m² Alan" },
        { Id: 456282, PropertyName: "value", Value: "Çatı Tipi" },
        { Id: 813761, PropertyName: "value", Value: "Tahmini Maliyet" },
        { Id: 477730, PropertyName: "value", Value: "Onay Notu" },
        {
          Id: 858665,
          PropertyName: "placeholder",
          Value: "Onay Notu Yazınız...",
        },
        { Id: 551404, PropertyName: "label", Value: "Onayı geri al" },
        { Id: 687126, PropertyName: "label", Value: "Onayla" },
        { Id: 494735, PropertyName: "tab", Value: "👑 Yönetim Onayı" },
        { Id: 285558, PropertyName: "value", Value: "📦 Malzeme Kalemleri" },
        { Id: 401386, PropertyName: "title", Value: "Title" },
        { Id: 443264, PropertyName: "value", Value: "[datafield:stokkodu]" },
        { Id: 338854, PropertyName: "value", Value: "[datafield:stokadi]" },
        { Id: 457170, PropertyName: "value", Value: "[datafield:birimfiyat]" },
        { Id: 768995, PropertyName: "value", Value: "[datafield:miktar]" },
        { Id: 951966, PropertyName: "value", Value: "[datafield:satırtoplam]" },
        { Id: 27727, PropertyName: "value", Value: "PROJE BİLGİLERİ" },
        { Id: 774444, PropertyName: "value", Value: "Kategori:" },
        { Id: 407484, PropertyName: "value", Value: "Netsis Kodu:" },
        { Id: 742812, PropertyName: "value", Value: "Müşteri:" },
        { Id: 838137, PropertyName: "value", Value: "İletişim:" },
        { Id: 205169, PropertyName: "value", Value: "Telefon:" },
        { Id: 130983, PropertyName: "value", Value: "ÖN SÜRECİN ÖZETİ" },
        { Id: 947754, PropertyName: "value", Value: "Ön Keşif:" },
        { Id: 123188, PropertyName: "value", Value: "-" },
        { Id: 808976, PropertyName: "value", Value: "Bekliyor" },
        { Id: 947009, PropertyName: "value", Value: "Proforma:" },
        { Id: 586632, PropertyName: "value", Value: "-" },
        { Id: 202005, PropertyName: "value", Value: "Bekliyor" },
        { Id: 81396, PropertyName: "value", Value: "Net Keşif:" },
        { Id: 720867, PropertyName: "value", Value: "-" },
        { Id: 870616, PropertyName: "value", Value: "Bekliyor" },
        { Id: 526165, PropertyName: "value", Value: "PM Onayı:" },
        { Id: 632457, PropertyName: "value", Value: "-" },
        { Id: 994923, PropertyName: "value", Value: "Bekliyor" },
        { Id: 642939, PropertyName: "value", Value: "Yönetim:" },
        { Id: 563960, PropertyName: "value", Value: "-" },
        { Id: 285720, PropertyName: "value", Value: "Bekliyor" },
        { Id: 317578, PropertyName: "value", Value: "KEŞİF TEKNİK ÖZET" },
        { Id: 501317, PropertyName: "value", Value: "kWp Güç" },
        { Id: 585488, PropertyName: "value", Value: "m² Alan" },
        { Id: 172700, PropertyName: "value", Value: "Çatı Tipi" },
        { Id: 290895, PropertyName: "value", Value: "Tahmini Maliyet" },
        { Id: 87740, PropertyName: "value", Value: "Onay Notu" },
        {
          Id: 961677,
          PropertyName: "placeholder",
          Value: "Onay Notu Yazınız...",
        },
        { Id: 233488, PropertyName: "label", Value: "Onayı geri al" },
        { Id: 320489, PropertyName: "label", Value: "Onayla" },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  ForEach1: any[];
  ForEach2: any[];

  constructor(props) {
    super(props);
    this.tarimsalsulamaonsurecler_203346_value_kuikaTextInputRef =
      React.createRef();
    this.tarimsalsulamaonsurecler_913183_value_kuikaDateRef = React.createRef();
    this.tarimsalsulamaonsurecler_558557_value_kuikaTextInputRef =
      React.createRef();
    this.tarimsalsulamaonsurecler_234840_value_kuikaSelectBoxRef =
      React.createRef();
    this.tarimsalsulamaonsurecler_707377_value_kuikaSelectBoxRef =
      React.createRef();
    this.tarimsalsulamaonsurecler_166467_value_kuikaSelectBoxRef =
      React.createRef();
    this.tarimsalsulamaonsurecler_149112_value_kuikaSelectBoxRef =
      React.createRef();
    this.tarimsalsulamaonsurecler_380385_value_kuikaSelectBoxRef =
      React.createRef();
    this.tarimsalsulamaonsurecler_186956_value_kuikaTextInputRef =
      React.createRef();
    this.tarimsalsulamaonsurecler_628425_value_kuikaSelectBoxRef =
      React.createRef();
    this.tarimsalsulamaonsurecler_681014_value_kuikaSelectBoxRef =
      React.createRef();
    this.tarimsalsulamaonsurecler_321509_value_kuikaSelectBoxRef =
      React.createRef();
    this.tarimsalsulamaonsurecler_310926_value_kuikaTextInputRef =
      React.createRef();
    this.tarimsalsulamaonsurecler_174079_value_kuikaSelectBoxRef =
      React.createRef();
    this.tarimsalsulamaonsurecler_118876_value_kuikaSelectBoxRef =
      React.createRef();
    this.tarimsalsulamaonsurecler_900878_value_kuikaSelectBoxRef =
      React.createRef();
    this.tarimsalsulamaonsurecler_753684_value_kuikaSelectBoxRef =
      React.createRef();
    this.tarimsalsulamaonsurecler_648547_value_kuikaSelectBoxRef =
      React.createRef();
    this.tarimsalsulamaonsurecler_546366_value_kuikaSelectBoxRef =
      React.createRef();
    this.tarimsalsulamaonsurecler_124355_value_kuikaSelectBoxRef =
      React.createRef();
    this.tarimsalsulamaonsurecler_994578_value_kuikaSelectBoxRef =
      React.createRef();
    this.tarimsalsulamaonsurecler_478263_value_kuikaTableRef =
      React.createRef();
    this.tarimsalsulamaonsurecler_393036_value_kuikaAutoCompleteRef =
      React.createRef();
    this.tarimsalsulamaonsurecler_480487_value_kuikaTextInputRef =
      React.createRef();
    this.tarimsalsulamaonsurecler_801362_value_kuikaTableRef =
      React.createRef();
    this.tarimsalsulamaonsurecler_200053_value_kuikaTableRef =
      React.createRef();
    this.tarimsalsulamaonsurecler_266261_value_kuikaTableRef =
      React.createRef();
    this.tarimsalsulamaonsurecler_964792_value_kuikaTextInputRef =
      React.createRef();
    this.tarimsalsulamaonsurecler_88388_value_kuikaDateRef = React.createRef();
    this.tarimsalsulamaonsurecler_715365_value_kuikaTextInputRef =
      React.createRef();
    this.tarimsalsulamaonsurecler_390590_value_kuikaSelectBoxRef =
      React.createRef();
    this.tarimsalsulamaonsurecler_428549_value_kuikaSelectBoxRef =
      React.createRef();
    this.tarimsalsulamaonsurecler_301315_value_kuikaSelectBoxRef =
      React.createRef();
    this.tarimsalsulamaonsurecler_347190_value_kuikaSelectBoxRef =
      React.createRef();
    this.tarimsalsulamaonsurecler_248435_value_kuikaSelectBoxRef =
      React.createRef();
    this.tarimsalsulamaonsurecler_363152_value_kuikaTextInputRef =
      React.createRef();
    this.tarimsalsulamaonsurecler_54683_value_kuikaSelectBoxRef =
      React.createRef();
    this.tarimsalsulamaonsurecler_726812_value_kuikaSelectBoxRef =
      React.createRef();
    this.tarimsalsulamaonsurecler_320807_value_kuikaSelectBoxRef =
      React.createRef();
    this.tarimsalsulamaonsurecler_530736_value_kuikaTextInputRef =
      React.createRef();
    this.tarimsalsulamaonsurecler_716982_value_kuikaSelectBoxRef =
      React.createRef();
    this.tarimsalsulamaonsurecler_407044_value_kuikaSelectBoxRef =
      React.createRef();
    this.tarimsalsulamaonsurecler_232820_value_kuikaSelectBoxRef =
      React.createRef();
    this.tarimsalsulamaonsurecler_822795_value_kuikaTableRef =
      React.createRef();
    this.tarimsalsulamaonsurecler_508933_value_kuikaTableRef =
      React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      GoBack: "",
      GetUserByUsername: [],
      AktifSirketGetir: [],
      GET_ON_SUREC_OZET_GETIR: [],
      GetProjeAsamalari: [],
      GET_SATIS_TEMSILCISI: [],
      GET_PROJE_ON_SUREC: [],
      GET_NETSIS_STOK_LISTESI: [],
      CATI_GES_ON_KESIF_GETIR: [],
      PROJE_DOSYLARI_GETIR: [],
      DosyalariDBdenYukle: [],
      DosyalariGetir: [],
      ON_KESIF_KALEMLER_GETIR: [],
      KalemleriDBdenYukle: [],
      KalemleriGetir: [],
      ChangeVisibilityOf: "",
      SetValueOf: "",
      KalemSil: [],
      Notify: false,
      Multiply: 0,
      KalemEkle: [],
      UploadFile: [],
      ForEach: false,
      DownloadFile: "",
      DosyaSil: [],
      KaydetHazirla: "",
      ON_SUREC_TARIMSAL_SULAMA_KAYDET: [],
      PROFORMA_GENEL_BILGILERI_GETIR: [],
      PROFORMA_KALEMLERI_GETIR: [],
      DosyalariKaydetHazirla: "",
      TopluDosyaKaydet: [],
      ON_KESIF_PROFORMA_KAYDET: [],
      NET_KESIF_CATI_GETIR: [],
      GET_PROJEYONETICI_USERS: [],
      ON_SUREC_PM_GERI_AL: [],
      ON_SUREC_PM_ONAYLA: [],
      ON_SUREC_UY_ONAY_GERIAL: [],
      ON_SUREC_UY_ONAYLA: [],
      dataSource_707377: [
        { key: "Derin Kuyu", text: "Derin Kuyu" },
        { key: "Akarsu/Göl", text: "Akarsu/Göl" },
        { key: "Havuz/Depo", text: "Havuz/Depo" },
      ],
      dataSource_166467: [
        { key: "Dalgıç Pompa", text: "Dalgıç Pompa" },
        { key: "Yüzey Pompası", text: "Yüzey Pompası" },
      ],
      dataSource_149112: [
        { key: "HP", text: "HP" },
        { key: "kW", text: "kW" },
      ],
      dataSource_380385: [
        { key: "Monofaze (220V)", text: "Monofaze (220V)" },
        { key: "Trifaze (380V)", text: "Trifaze (380V)" },
      ],
      dataSource_628425: [
        { key: "Var", text: "Var" },
        { key: "Yok", text: "Yok" },
      ],
      dataSource_681014: [
        { key: "Boş Arazi", text: "Boş Arazi" },
        { key: "Çatı", text: "Çatı" },
        { key: "Tracker", text: "Tracker" },
      ],
      dataSource_321509: [
        { key: "Toprak", text: "Toprak" },
        { key: "Kayalık", text: "Kayalık" },
        { key: "Beton", text: "Beton" },
        { key: "Diğer", text: "Diğer" },
      ],
      dataSource_174079: [
        { key: "Sorun Yok", text: "Sorun Yok" },
        { key: "Riskli", text: "Riskli" },
      ],
      dataSource_118876: [
        { key: "Off-Grid", text: "Off-Grid" },
        { key: "Hibrit", text: "Hibrit" },
        { key: "On-Grid", text: "On-Grid" },
      ],
      dataSource_900878: [
        { key: "Kazı Gerekli", text: "Kazı Gerekli" },
        { key: "Mevcut Kanal Uygun", text: "Mevcut Kanal Uygun" },
      ],
      dataSource_753684: [
        { key: "İlkbahar", text: "İlkbahar" },
        { key: "Yaz", text: "Yaz" },
        { key: "Sonbahar", text: "Sonbahar" },
      ],
      dataSource_648547: [
        { key: "Damlama", text: "Damlama" },
        { key: "Yağmurlama", text: "Yağmurlama" },
        { key: "Salma", text: "Salma" },
      ],
      dataSource_546366: [
        { key: "Uygun", text: "Ugun" },
        { key: "Arazi Aracı Gerekli", text: "Arazi Aracı Gerekli" },
      ],
      dataSource_124355: [
        { key: "Çit Mevcut", text: "Çit Mevcut" },
        { key: "Kamera/Bekçi Gerekli", text: "Kamera/Bekçi Gerekli" },
      ],
      dataSource_994578: [
        { key: "Uygun", text: "Uygun" },
        { key: "İyileştirme Gerekiyor", text: "İyileştirme Gerekiyor" },
      ],
      dataSource_428549: [
        { key: "Derin Kuyu", text: "Derin Kuyu" },
        { key: "Akarsu/Göl", text: "Akarsu/Göl" },
        { key: "Havuz/Depo", text: "Havuz/Depo" },
      ],
      dataSource_301315: [
        { key: "Dalgıç Pompa", text: "Dalgıç Pompa" },
        { key: "Yüzey Pompası", text: "Yüzey Pompası" },
      ],
      dataSource_347190: [
        { key: "HP", text: "HP" },
        { key: "kW", text: "kW" },
      ],
      dataSource_248435: [
        { key: "Monofaze (220V)", text: "Monofaze (220V)" },
        { key: "Trifaze (380V)", text: "Trifaze (380V)" },
      ],
      dataSource_54683: [
        { key: "Var", text: "Var" },
        { key: "Yok", text: "Yok" },
      ],
      dataSource_726812: [
        { key: "Boş Arazi", text: "Boş Arazi" },
        { key: "Çatı", text: "Çatı" },
        { key: "Tracker", text: "Tracker" },
      ],
      dataSource_320807: [
        { key: "Toprak", text: "Toprak" },
        { key: "Kayalık", text: "Kayalık" },
        { key: "Beton", text: "Beton" },
        { key: "Diğer", text: "Diğer" },
      ],
      dataSource_716982: [
        { key: "Sorun Yok", text: "Sorun Yok" },
        { key: "Riskli", text: "Riskli" },
      ],
      dataSource_407044: [
        { key: "Off-Grid", text: "Off-Grid" },
        { key: "Hibrit", text: "Hibrit" },
        { key: "On-Grid", text: "On-Grid" },
      ],
      dataSource_232820: [
        { key: "Kazı Gerekli", text: "Kazı Gerekli" },
        { key: "Mevcut Kanal Uygun", text: "Mevcut Kanal Uygun" },
      ],
      isComp379455Visible: "hidden",
      isComp321509Visible: "visible",
      isComp930685Visible: "hidden",
      isComp200548Visible: "hidden",
      isComp38139Visible: "hidden",
      isComp230193Visible: "hidden",
      isComp108416Visible: "hidden",
      isComp167824Visible: "hidden",
      isComp995070Visible: "hidden",
      isComp606562Visible: "hidden",
      isComp777039Visible: "hidden",
      isComp682157Visible: "hidden",
      isComp457735Visible: "hidden",
      isComp724523Visible: "hidden",
      isComp867312Visible: "hidden",
      isComp970414Visible: "hidden",
      isComp987888Visible: "hidden",
      isComp564425Visible: "hidden",
      isComp98381Visible: "hidden",
      isComp825089Visible: "hidden",
      isComp340333Visible: "hidden",
      isComp589579Visible: "hidden",
      isComp278838Visible: "hidden",
      isComp788639Visible: "hidden",
      isComp557821Visible: "hidden",
      isComp171830Visible: "hidden",
      isComp485928Visible: "hidden",
      isComp429832Visible: "hidden",
      isComp384588Visible: "hidden",
      isComp814465Visible: "hidden",
      isComp831693Visible: "hidden",
      isComp551404Visible: "hidden",
      isComp687126Visible: "hidden",
      isComp759553Visible: "hidden",
      isComp52540Visible: "hidden",
      isComp647527Visible: "hidden",
      isComp371141Visible: "hidden",
      isComp583734Visible: "hidden",
      isComp3461Visible: "hidden",
      isComp848368Visible: "hidden",
      isComp135945Visible: "hidden",
      isComp289590Visible: "hidden",
      isComp432583Visible: "hidden",
      isComp781192Visible: "hidden",
      isComp465589Visible: "hidden",
      isComp848477Visible: "hidden",
      isComp500544Visible: "hidden",
      isComp233488Visible: "hidden",
      isComp320489Visible: "hidden",
      isComp480487Enabled: "disabled",
      isComp353063Enabled: "disabled",
      isComp570640Enabled: "disabled",
      isComp759553Enabled: "disabled",
      isComp451651Enabled: "disabled",
      isComptarimsalsulamaonsurecler_261399AuthorizationVisible: "visible",
      isComptarimsalsulamaonsurecler_367991AuthorizationVisible: "visible",
      isComptarimsalsulamaonsurecler_832682AuthorizationVisible: "visible",
      isComptarimsalsulamaonsurecler_899938AuthorizationVisible: "visible",
      isComptarimsalsulamaonsurecler_442005AuthorizationVisible: "visible",
      isComptarimsalsulamaonsurecler_494735AuthorizationVisible: "visible",
      isComptarimsalsulamaonsurecler_135945AuthorizationVisible: "visible",
    };

    this.CheckPageAuthorization(this.state);
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("tarimsalsulamaonsurecler", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.TarimsalSulamaOnSureclerPageInit();
    }
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isComptarimsalsulamaonsurecler_261399AuthorizationVisible",
      [
        "c6f29069-ffbd-951c-18cd-094e80904f66",
        "06be6eb0-5136-2612-4c7e-0eb322469265",
        "f78ce546-5305-afb9-7ce9-25deaa006292",
        "SatisTemsilcisi",
        "ProjeYonetici",
        "AdminYonetici",
      ]
    );
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isComptarimsalsulamaonsurecler_367991AuthorizationVisible",
      [
        "c6f29069-ffbd-951c-18cd-094e80904f66",
        "06be6eb0-5136-2612-4c7e-0eb322469265",
        "SatisTemsilcisi",
        "AdminYonetici",
      ]
    );
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isComptarimsalsulamaonsurecler_832682AuthorizationVisible",
      [
        "c6f29069-ffbd-951c-18cd-094e80904f66",
        "06be6eb0-5136-2612-4c7e-0eb322469265",
        "SatisTemsilcisi",
        "AdminYonetici",
      ]
    );
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isComptarimsalsulamaonsurecler_899938AuthorizationVisible",
      [
        "f78ce546-5305-afb9-7ce9-25deaa006292",
        "06be6eb0-5136-2612-4c7e-0eb322469265",
        "ProjeYonetici",
        "AdminYonetici",
      ]
    );
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isComptarimsalsulamaonsurecler_442005AuthorizationVisible",
      [
        "f78ce546-5305-afb9-7ce9-25deaa006292",
        "06be6eb0-5136-2612-4c7e-0eb322469265",
        "ProjeYonetici",
        "AdminYonetici",
      ]
    );
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isComptarimsalsulamaonsurecler_494735AuthorizationVisible",
      ["06be6eb0-5136-2612-4c7e-0eb322469265", "AdminYonetici"]
    );
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isComptarimsalsulamaonsurecler_135945AuthorizationVisible",
      [
        "c6f29069-ffbd-951c-18cd-094e80904f66",
        "f78ce546-5305-afb9-7ce9-25deaa006292",
        "06be6eb0-5136-2612-4c7e-0eb322469265",
        "SatisTemsilcisi",
        "ProjeYonetici",
        "AdminYonetici",
      ]
    );

    KuikaAppManager.calculateAndSetBodyHeight("tarimsalsulamaonsurecler", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  CheckPageAuthorization = async (state) => {
    KuikaAppManager.showSpinner(this);
    if (_.isEmpty(window.userInfo)) {
      await UserService.GetUserInfoForce();
    }
    const permittedRoleNames: string[] = [
      "SatisTemsilcisi",
      "ProjeYonetici",
      "AdminYonetici",
    ];
    const userInfo = window.userInfo as IUserInfoDto;
    const userRoleNames = userInfo.roles.map((role) => role.name);
    if (
      !permittedRoleNames.some((roleName) => userRoleNames.includes(roleName))
    ) {
      await ReactSystemFunctions.goBack(this);

      const language = localStorage.getItem("ml");
      let permissonErrorMessageText =
        "You do not have permission to access this page.";
      if (language === "tr_TR") {
        permissonErrorMessageText = "Bu sayfaya erişim yetkiniz yok.";
      } else if (language === "fr_FR") {
        permissonErrorMessageText =
          "Vous n'avez pas la permission d'accéder à cette page.";
      } else if (language === "de_DE") {
        permissonErrorMessageText =
          "Sie haben keine Berechtigung, auf diese Seite zuzugreifen.";
      } else if (language === "es_ES") {
        permissonErrorMessageText =
          "No tienes permiso para acceder a esta página.";
      }

      KMainFunctions.displayErrorNotification(permissonErrorMessageText);
      state.isPageVisible = false;
      KuikaAppManager.hideSpinner(this);
      return;
    }
    state.isPageVisible = true;
    KuikaAppManager.hideSpinner(this);
  };

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("tarimsalsulamaonsurecler", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.TarimsalSulamaOnSureclerPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({
      tarimsalsulamaonsurecler_14467_value:
        this.state.CATI_GES_ON_KESIF_GETIR?.at?.(0)?.sozlesmeGucu_kW ??
        undefined,
      tarimsalsulamaonsurecler_766200_value:
        this.state.CATI_GES_ON_KESIF_GETIR?.at?.(0)?.trafoGucu_kVA ?? undefined,
      tarimsalsulamaonsurecler_145387_value:
        this.state.CATI_GES_ON_KESIF_GETIR?.at?.(0)?.anaŞalterAkim_A ??
        undefined,
      tarimsalsulamaonsurecler_707377_value:
        this.state.CATI_GES_ON_KESIF_GETIR?.at?.(0)?.aboneTipi ?? undefined,
      tarimsalsulamaonsurecler_743336_value:
        this.state.CATI_GES_ON_KESIF_GETIR?.at?.(0)?.panoMesafesi_m ??
        undefined,
      tarimsalsulamaonsurecler_166467_value:
        this.state.CATI_GES_ON_KESIF_GETIR?.at?.(0)?.catiTipi ?? undefined,
      tarimsalsulamaonsurecler_724523_value:
        this.state.CATI_GES_ON_KESIF_GETIR?.at?.(0)?.catiEgimi_Derece ??
        undefined,
      tarimsalsulamaonsurecler_867312_value:
        this.state.CATI_GES_ON_KESIF_GETIR?.at?.(0)?.catiEgimi_Derece ??
        undefined,
      tarimsalsulamaonsurecler_149112_value:
        this.state.CATI_GES_ON_KESIF_GETIR?.at?.(0)?.catiYonu ?? undefined,
      tarimsalsulamaonsurecler_380385_value:
        this.state.CATI_GES_ON_KESIF_GETIR?.at?.(0)?.catiYonu ?? undefined,
      tarimsalsulamaonsurecler_886075_value:
        this.state.CATI_GES_ON_KESIF_GETIR?.at?.(0)?.kullanilabilirAlan_m2 ??
        undefined,
      tarimsalsulamaonsurecler_186956_value:
        this.state.CATI_GES_ON_KESIF_GETIR?.at?.(0)?.adaParselBilgisi ??
        undefined,
      tarimsalsulamaonsurecler_628425_value:
        this.state.CATI_GES_ON_KESIF_GETIR?.at?.(0)?.catiYonu ?? undefined,
      tarimsalsulamaonsurecler_681014_value:
        this.state.CATI_GES_ON_KESIF_GETIR?.at?.(0)?.catiTasiyiciSistem ??
        undefined,
      tarimsalsulamaonsurecler_321509_value:
        this.state.CATI_GES_ON_KESIF_GETIR?.at?.(0)?.catiTasiyiciSistem ??
        undefined,
      tarimsalsulamaonsurecler_310926_value:
        this.state.CATI_GES_ON_KESIF_GETIR?.at?.(0)?.adaParselBilgisi ??
        undefined,
      tarimsalsulamaonsurecler_174079_value:
        this.state.CATI_GES_ON_KESIF_GETIR?.at?.(0)?.catiTasiyiciSistem ??
        undefined,
      tarimsalsulamaonsurecler_107465_value:
        this.state.CATI_GES_ON_KESIF_GETIR?.at?.(0)?.catiEgimi_Derece ??
        undefined,
      tarimsalsulamaonsurecler_542990_value:
        this.state.CATI_GES_ON_KESIF_GETIR?.at?.(0)?.panoMesafesi_m ??
        undefined,
      tarimsalsulamaonsurecler_195553_value:
        this.state.CATI_GES_ON_KESIF_GETIR?.at?.(0)?.panoMesafesi_m ??
        undefined,
      tarimsalsulamaonsurecler_118876_value:
        this.state.CATI_GES_ON_KESIF_GETIR?.at?.(0)?.catiTasiyiciSistem ??
        undefined,
      tarimsalsulamaonsurecler_80062_value:
        this.state.CATI_GES_ON_KESIF_GETIR?.at?.(0)?.panoMesafesi_m ??
        undefined,
      tarimsalsulamaonsurecler_900878_value:
        this.state.CATI_GES_ON_KESIF_GETIR?.at?.(0)?.catiTasiyiciSistem ??
        undefined,
      tarimsalsulamaonsurecler_928420_value:
        this.state.CATI_GES_ON_KESIF_GETIR?.at?.(0)?.panoMesafesi_m ??
        undefined,
      tarimsalsulamaonsurecler_753684_value:
        this.state.CATI_GES_ON_KESIF_GETIR?.at?.(0)?.catiTasiyiciSistem ??
        undefined,
      tarimsalsulamaonsurecler_648547_value:
        this.state.CATI_GES_ON_KESIF_GETIR?.at?.(0)?.catiTasiyiciSistem ??
        undefined,
      tarimsalsulamaonsurecler_124355_value:
        this.state.CATI_GES_ON_KESIF_GETIR?.at?.(0)?.catiTasiyiciSistem ??
        undefined,
      tarimsalsulamaonsurecler_994578_value:
        this.state.CATI_GES_ON_KESIF_GETIR?.at?.(0)?.catiTasiyiciSistem ??
        undefined,
      tarimsalsulamaonsurecler_207266_value: undefined,
      tarimsalsulamaonsurecler_353063_value: 0,
      tarimsalsulamaonsurecler_570640_value: 0,
      tarimsalsulamaonsurecler_225026_value:
        this.state.CATI_GES_ON_KESIF_GETIR?.at?.(-1)?.kesif_Aciklama1 ??
        undefined,
      tarimsalsulamaonsurecler_26200_value:
        this.state.CATI_GES_ON_KESIF_GETIR?.at?.(-1)?.kesif_Aciklama2 ??
        undefined,
      tarimsalsulamaonsurecler_122352_value:
        this.state.CATI_GES_ON_KESIF_GETIR?.at?.(0)?.kesif_Aciklama3 ??
        undefined,
      tarimsalsulamaonsurecler_505390_value:
        this.state.PROFORMA_GENEL_BILGILERI_GETIR?.at?.(0)?.proforma_Tutar ??
        undefined,
      tarimsalsulamaonsurecler_169821_value:
        this.state.PROFORMA_GENEL_BILGILERI_GETIR?.at?.(0)?.proforma_Notu ??
        undefined,
      tarimsalsulamaonsurecler_606165_value:
        this.state.CATI_GES_ON_KESIF_GETIR?.at?.(0)?.sozlesmeGucu_kW ??
        undefined,
      tarimsalsulamaonsurecler_205697_value:
        this.state.CATI_GES_ON_KESIF_GETIR?.at?.(0)?.trafoGucu_kVA ?? undefined,
      tarimsalsulamaonsurecler_137398_value:
        this.state.CATI_GES_ON_KESIF_GETIR?.at?.(0)?.anaŞalterAkim_A ??
        undefined,
      tarimsalsulamaonsurecler_428549_value:
        this.state.CATI_GES_ON_KESIF_GETIR?.at?.(0)?.aboneTipi ?? undefined,
      tarimsalsulamaonsurecler_299122_value:
        this.state.CATI_GES_ON_KESIF_GETIR?.at?.(0)?.panoMesafesi_m ??
        undefined,
      tarimsalsulamaonsurecler_301315_value:
        this.state.CATI_GES_ON_KESIF_GETIR?.at?.(0)?.catiTipi ?? undefined,
      tarimsalsulamaonsurecler_987888_value:
        this.state.CATI_GES_ON_KESIF_GETIR?.at?.(0)?.catiEgimi_Derece ??
        undefined,
      tarimsalsulamaonsurecler_564425_value:
        this.state.CATI_GES_ON_KESIF_GETIR?.at?.(0)?.catiEgimi_Derece ??
        undefined,
      tarimsalsulamaonsurecler_347190_value:
        this.state.CATI_GES_ON_KESIF_GETIR?.at?.(0)?.catiYonu ?? undefined,
      tarimsalsulamaonsurecler_248435_value:
        this.state.CATI_GES_ON_KESIF_GETIR?.at?.(0)?.catiYonu ?? undefined,
      tarimsalsulamaonsurecler_527428_value:
        this.state.CATI_GES_ON_KESIF_GETIR?.at?.(0)?.kullanilabilirAlan_m2 ??
        undefined,
      tarimsalsulamaonsurecler_363152_value:
        this.state.CATI_GES_ON_KESIF_GETIR?.at?.(0)?.adaParselBilgisi ??
        undefined,
      tarimsalsulamaonsurecler_54683_value:
        this.state.CATI_GES_ON_KESIF_GETIR?.at?.(0)?.catiYonu ?? undefined,
      tarimsalsulamaonsurecler_726812_value:
        this.state.CATI_GES_ON_KESIF_GETIR?.at?.(0)?.catiTasiyiciSistem ??
        undefined,
      tarimsalsulamaonsurecler_320807_value:
        this.state.CATI_GES_ON_KESIF_GETIR?.at?.(0)?.catiTasiyiciSistem ??
        undefined,
      tarimsalsulamaonsurecler_530736_value:
        this.state.CATI_GES_ON_KESIF_GETIR?.at?.(0)?.adaParselBilgisi ??
        undefined,
      tarimsalsulamaonsurecler_716982_value:
        this.state.CATI_GES_ON_KESIF_GETIR?.at?.(0)?.catiTasiyiciSistem ??
        undefined,
      tarimsalsulamaonsurecler_39609_value:
        this.state.CATI_GES_ON_KESIF_GETIR?.at?.(0)?.catiEgimi_Derece ??
        undefined,
      tarimsalsulamaonsurecler_468368_value:
        this.state.CATI_GES_ON_KESIF_GETIR?.at?.(0)?.panoMesafesi_m ??
        undefined,
      tarimsalsulamaonsurecler_732086_value:
        this.state.CATI_GES_ON_KESIF_GETIR?.at?.(0)?.panoMesafesi_m ??
        undefined,
      tarimsalsulamaonsurecler_407044_value:
        this.state.CATI_GES_ON_KESIF_GETIR?.at?.(0)?.catiTasiyiciSistem ??
        undefined,
      tarimsalsulamaonsurecler_39980_value:
        this.state.CATI_GES_ON_KESIF_GETIR?.at?.(0)?.panoMesafesi_m ??
        undefined,
      tarimsalsulamaonsurecler_232820_value:
        this.state.CATI_GES_ON_KESIF_GETIR?.at?.(0)?.catiTasiyiciSistem ??
        undefined,
    });
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  checkTabErrors = () => {
    document.querySelectorAll(".rc-tabs-tab").forEach((tab) => {
      (tab as HTMLElement).style.color = "";
    });

    const tabPanes = document.querySelectorAll(".rc-tabs-tabpane");
    const tabs = document.querySelectorAll(".rc-tabs-tab");

    tabPanes.forEach((tabPane, index) => {
      const uniquePaneId = `rc-tabs-tabpane-${index}`;
      if (!tabPane.hasAttribute("id")) {
        tabPane.setAttribute("id", uniquePaneId);
      }

      const uniqueTabId = `rc-tabs-tab-${index}`;
      if (tabs[index]) {
        if (!tabs[index].hasAttribute("id")) {
          tabs[index].setAttribute("id", uniqueTabId);
        }
        tabs[index].setAttribute("aria-controls", uniquePaneId);
      }
    });

    const errorElements = document.querySelectorAll(
      ".rc-tabs .ant-form-item-explain-error"
    );

    const tabsWithErrors = new Set<string>();

    errorElements.forEach((errorElement) => {
      const tabPane = errorElement.closest(".rc-tabs-tabpane");
      if (tabPane && tabPane.id) {
        tabsWithErrors.add(tabPane.id);
      }
    });

    tabsWithErrors.forEach((tabPaneId) => {
      const tab = document.querySelector(
        `.rc-tabs-tab[aria-controls="${tabPaneId}"]`
      );
      if (tab) {
        (tab as HTMLElement).style.color = "red";
      }
    });
  };

  TarimsalSulamaOnSureclerPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      UserName_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUsername(),
        "string"
      ),
      ProjeId_2: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
        "number"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "TarimsalSulamaOnSurecler/TarimsalSulamaOnSureclerPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetUserByUsername = result?.data.getUserByUsername;
    stateVars.AktifSirketGetir = result?.data.aktifSirketGetir;
    stateVars.GET_ON_SUREC_OZET_GETIR = result?.data.geT_ON_SUREC_OZET_GETIR;
    formVars.tarimsalsulamaonsurecler_271446_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].projeKodu
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].projeKodu
          : null
      );
    formVars.tarimsalsulamaonsurecler_585180_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kategoriAdi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].kategoriAdi
          : null
      );
    formVars.tarimsalsulamaonsurecler_491925_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].projeAdi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].projeAdi
          : null
      );
    formVars.tarimsalsulamaonsurecler_135540_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].iletisimKisi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].iletisimKisi
          : null
      );
    formVars.tarimsalsulamaonsurecler_554247_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].musteriAdi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].musteriAdi
          : null
      );
    formVars.tarimsalsulamaonsurecler_470797_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].baslangicTarihi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].baslangicTarihi
        : null
    );
    formVars.tarimsalsulamaonsurecler_931176_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].tahminiBitis
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].tahminiBitis
        : null
    );
    formVars.tarimsalsulamaonsurecler_286346_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kategoriAdi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].kategoriAdi
          : null
      );
    formVars.tarimsalsulamaonsurecler_725534_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netsisProjKodu
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].netsisProjKodu
          : null
      );
    formVars.tarimsalsulamaonsurecler_82922_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].musteriAdi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].musteriAdi
          : null
      );
    formVars.tarimsalsulamaonsurecler_548_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].iletisimKisi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].iletisimKisi
        : null
    );
    formVars.tarimsalsulamaonsurecler_21963_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].telefon
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].telefon
          : null
      );
    formVars.tarimsalsulamaonsurecler_819965_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_Tarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_Tarih
        : null
    );
    formVars.tarimsalsulamaonsurecler_726292_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
          : null
      );
    formVars.tarimsalsulamaonsurecler_32769_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].proforma_Tarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].proforma_Tarih
        : null
    );
    formVars.tarimsalsulamaonsurecler_726526_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciAdi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciAdi
          : null
      );
    formVars.tarimsalsulamaonsurecler_776921_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netKesif_Tarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].netKesif_Tarih
        : null
    );
    formVars.tarimsalsulamaonsurecler_735264_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
          : null
      );
    formVars.tarimsalsulamaonsurecler_916010_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].pM_OnayTarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].pM_OnayTarih
        : null
    );
    formVars.tarimsalsulamaonsurecler_365802_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanAdi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanAdi
          : null
      );
    formVars.tarimsalsulamaonsurecler_295328_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[
              stateVars.GET_ON_SUREC_OZET_GETIR.length - 1
            ].uY_OnayTarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[
            this.state.GET_ON_SUREC_OZET_GETIR.length - 1
          ].uY_OnayTarih
        : null
    );
    formVars.tarimsalsulamaonsurecler_511988_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[
                stateVars.GET_ON_SUREC_OZET_GETIR.length - 1
              ].uY_OnaylayanAdi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[
              this.state.GET_ON_SUREC_OZET_GETIR.length - 1
            ].uY_OnaylayanAdi
          : null
      );
    formVars.tarimsalsulamaonsurecler_979930_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_TahminiGuc
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_TahminiGuc
          : null
      );
    formVars.tarimsalsulamaonsurecler_120818_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_AlanM2
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_AlanM2
          : null
      );
    formVars.tarimsalsulamaonsurecler_300623_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].teknik_CatiTipi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].teknik_CatiTipi
          : null
      );
    formVars.tarimsalsulamaonsurecler_379284_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].onKesif_ToplamMaliyet
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].onKesif_ToplamMaliyet
          : null
      );
    formVars.tarimsalsulamaonsurecler_357016_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kategoriAdi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].kategoriAdi
          : null
      );
    formVars.tarimsalsulamaonsurecler_455222_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netsisProjKodu
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].netsisProjKodu
          : null
      );
    formVars.tarimsalsulamaonsurecler_402895_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].musteriAdi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].musteriAdi
          : null
      );
    formVars.tarimsalsulamaonsurecler_625966_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].iletisimKisi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].iletisimKisi
          : null
      );
    formVars.tarimsalsulamaonsurecler_514278_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].telefon
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].telefon
          : null
      );
    formVars.tarimsalsulamaonsurecler_784309_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_Tarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_Tarih
        : null
    );
    formVars.tarimsalsulamaonsurecler_936865_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
          : null
      );
    formVars.tarimsalsulamaonsurecler_115403_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].proforma_Tarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].proforma_Tarih
        : null
    );
    formVars.tarimsalsulamaonsurecler_199667_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciAdi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciAdi
          : null
      );
    formVars.tarimsalsulamaonsurecler_122248_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netKesif_Tarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].netKesif_Tarih
        : null
    );
    formVars.tarimsalsulamaonsurecler_330741_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
          : null
      );
    formVars.tarimsalsulamaonsurecler_977440_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].pM_OnayTarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].pM_OnayTarih
        : null
    );
    formVars.tarimsalsulamaonsurecler_76435_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanAdi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanAdi
          : null
      );
    formVars.tarimsalsulamaonsurecler_585379_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[
              stateVars.GET_ON_SUREC_OZET_GETIR.length - 1
            ].uY_OnayTarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[
            this.state.GET_ON_SUREC_OZET_GETIR.length - 1
          ].uY_OnayTarih
        : null
    );
    formVars.tarimsalsulamaonsurecler_678296_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[
                stateVars.GET_ON_SUREC_OZET_GETIR.length - 1
              ].uY_OnaylayanAdi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[
              this.state.GET_ON_SUREC_OZET_GETIR.length - 1
            ].uY_OnaylayanAdi
          : null
      );
    formVars.tarimsalsulamaonsurecler_197581_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_TahminiGuc
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_TahminiGuc
          : null
      );
    formVars.tarimsalsulamaonsurecler_4809_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_AlanM2
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_AlanM2
          : null
      );
    formVars.tarimsalsulamaonsurecler_969958_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].teknik_CatiTipi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].teknik_CatiTipi
          : null
      );
    formVars.tarimsalsulamaonsurecler_905887_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].onKesif_ToplamMaliyet
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].onKesif_ToplamMaliyet
          : null
      );
    formVars.tarimsalsulamaonsurecler_958888_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kategoriAdi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].kategoriAdi
          : null
      );
    formVars.tarimsalsulamaonsurecler_156155_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netsisProjKodu
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].netsisProjKodu
          : null
      );
    formVars.tarimsalsulamaonsurecler_987296_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].musteriAdi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].musteriAdi
          : null
      );
    formVars.tarimsalsulamaonsurecler_179447_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].iletisimKisi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].iletisimKisi
          : null
      );
    formVars.tarimsalsulamaonsurecler_451953_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].telefon
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].telefon
          : null
      );
    formVars.tarimsalsulamaonsurecler_106507_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_Tarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_Tarih
        : null
    );
    formVars.tarimsalsulamaonsurecler_117221_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
          : null
      );
    formVars.tarimsalsulamaonsurecler_686232_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].proforma_Tarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].proforma_Tarih
        : null
    );
    formVars.tarimsalsulamaonsurecler_621424_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciAdi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciAdi
          : null
      );
    formVars.tarimsalsulamaonsurecler_112950_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netKesif_Tarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].netKesif_Tarih
        : null
    );
    formVars.tarimsalsulamaonsurecler_615433_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
          : null
      );
    formVars.tarimsalsulamaonsurecler_140697_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].pM_OnayTarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].pM_OnayTarih
        : null
    );
    formVars.tarimsalsulamaonsurecler_64459_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanAdi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanAdi
          : null
      );
    formVars.tarimsalsulamaonsurecler_616609_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[
              stateVars.GET_ON_SUREC_OZET_GETIR.length - 1
            ].uY_OnayTarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[
            this.state.GET_ON_SUREC_OZET_GETIR.length - 1
          ].uY_OnayTarih
        : null
    );
    formVars.tarimsalsulamaonsurecler_619277_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[
                stateVars.GET_ON_SUREC_OZET_GETIR.length - 1
              ].uY_OnaylayanAdi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[
              this.state.GET_ON_SUREC_OZET_GETIR.length - 1
            ].uY_OnaylayanAdi
          : null
      );
    formVars.tarimsalsulamaonsurecler_676113_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_TahminiGuc
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_TahminiGuc
          : null
      );
    formVars.tarimsalsulamaonsurecler_395234_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_AlanM2
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_AlanM2
          : null
      );
    formVars.tarimsalsulamaonsurecler_554511_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].teknik_CatiTipi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].teknik_CatiTipi
          : null
      );
    formVars.tarimsalsulamaonsurecler_688343_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].onKesif_ToplamMaliyet
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].onKesif_ToplamMaliyet
          : null
      );
    stateVars.isComp930685Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp200548Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp38139Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp230193Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp108416Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp167824Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp995070Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanAdi
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanAdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp606562Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanAdi
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanAdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp777039Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].uY_OnaylayanAdi
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].uY_OnaylayanAdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp682157Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].uY_OnaylayanAdi
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].uY_OnaylayanAdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp457735Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp825089Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp340333Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp589579Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciAdi
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciAdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp278838Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciAdi
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciAdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp788639Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp557821Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp171830Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp485928Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp429832Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].uY_OnaylayanId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].uY_OnaylayanId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp384588Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].uY_OnaylayanId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].uY_OnaylayanId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp814465Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp831693Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp551404Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].pM_OnayDurum
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].pM_OnayDurum
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("ONAYLANDI", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp687126Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].pM_OnayDurum
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].pM_OnayDurum
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("ONAYLANDI", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp52540Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp647527Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp371141Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciAdi
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciAdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp583734Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciAdi
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciAdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp3461Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp848368Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp135945Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanAdi
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanAdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp289590Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanAdi
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanAdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp432583Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].uY_OnaylayanAdi
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].uY_OnaylayanAdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp781192Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].uY_OnaylayanAdi
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].uY_OnaylayanAdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp465589Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp848477Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp500544Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp233488Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].uY_OnayDurum
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].uY_OnayDurum
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("ONAYLANDI", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp320489Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].uY_OnayDurum
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].uY_OnayDurum
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("ONAYLANDI", "string")
      ) === true
        ? "visible"
        : "hidden";
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.TarimsalSulamaOnSureclerPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  TarimsalSulamaOnSureclerPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.tarimsalsulamaonsurecler_271446_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].projeKodu
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].projeKodu
          : null
      );

    formVars.tarimsalsulamaonsurecler_585180_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kategoriAdi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].kategoriAdi
          : null
      );

    formVars.tarimsalsulamaonsurecler_491925_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].projeAdi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].projeAdi
          : null
      );

    formVars.tarimsalsulamaonsurecler_135540_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].iletisimKisi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].iletisimKisi
          : null
      );

    formVars.tarimsalsulamaonsurecler_554247_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].musteriAdi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].musteriAdi
          : null
      );

    formVars.tarimsalsulamaonsurecler_470797_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].baslangicTarihi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].baslangicTarihi
        : null
    );

    formVars.tarimsalsulamaonsurecler_931176_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].tahminiBitis
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].tahminiBitis
        : null
    );

    formVars.tarimsalsulamaonsurecler_286346_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kategoriAdi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].kategoriAdi
          : null
      );

    formVars.tarimsalsulamaonsurecler_725534_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netsisProjKodu
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].netsisProjKodu
          : null
      );

    formVars.tarimsalsulamaonsurecler_82922_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].musteriAdi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].musteriAdi
          : null
      );

    formVars.tarimsalsulamaonsurecler_548_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].iletisimKisi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].iletisimKisi
        : null
    );

    formVars.tarimsalsulamaonsurecler_21963_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].telefon
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].telefon
          : null
      );

    stateVars.isComp930685Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.tarimsalsulamaonsurecler_819965_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_Tarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_Tarih
        : null
    );

    formVars.tarimsalsulamaonsurecler_726292_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
          : null
      );

    stateVars.isComp200548Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp38139Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.tarimsalsulamaonsurecler_32769_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].proforma_Tarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].proforma_Tarih
        : null
    );

    formVars.tarimsalsulamaonsurecler_726526_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciAdi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciAdi
          : null
      );

    stateVars.isComp230193Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp108416Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.tarimsalsulamaonsurecler_776921_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netKesif_Tarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].netKesif_Tarih
        : null
    );

    formVars.tarimsalsulamaonsurecler_735264_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
          : null
      );

    stateVars.isComp167824Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp995070Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanAdi
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanAdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.tarimsalsulamaonsurecler_916010_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].pM_OnayTarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].pM_OnayTarih
        : null
    );

    formVars.tarimsalsulamaonsurecler_365802_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanAdi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanAdi
          : null
      );

    stateVars.isComp606562Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanAdi
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanAdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp777039Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].uY_OnaylayanAdi
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].uY_OnaylayanAdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.tarimsalsulamaonsurecler_295328_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[
              stateVars.GET_ON_SUREC_OZET_GETIR.length - 1
            ].uY_OnayTarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[
            this.state.GET_ON_SUREC_OZET_GETIR.length - 1
          ].uY_OnayTarih
        : null
    );

    formVars.tarimsalsulamaonsurecler_511988_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[
                stateVars.GET_ON_SUREC_OZET_GETIR.length - 1
              ].uY_OnaylayanAdi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[
              this.state.GET_ON_SUREC_OZET_GETIR.length - 1
            ].uY_OnaylayanAdi
          : null
      );

    stateVars.isComp682157Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].uY_OnaylayanAdi
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].uY_OnaylayanAdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp457735Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.tarimsalsulamaonsurecler_979930_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_TahminiGuc
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_TahminiGuc
          : null
      );

    formVars.tarimsalsulamaonsurecler_120818_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_AlanM2
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_AlanM2
          : null
      );

    formVars.tarimsalsulamaonsurecler_300623_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].teknik_CatiTipi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].teknik_CatiTipi
          : null
      );

    formVars.tarimsalsulamaonsurecler_379284_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].onKesif_ToplamMaliyet
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].onKesif_ToplamMaliyet
          : null
      );

    stateVars.isComp724523Visible =
      (ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "tarimsalsulamaonsurecler_149112_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        ReactSystemFunctions.convertToTypeByName("HP", "string")
      ) ||
        ReactSystemFunctions.isEmpty(
          ReactSystemFunctions.toString(
            this,
            ReactSystemFunctions.value(
              this,
              "tarimsalsulamaonsurecler_149112_value",
              "value",
              "",
              "key",
              ""
            )
          ),
          ReactSystemFunctions.convertToTypeByName("True", "string")
        )) === true
        ? "visible"
        : "hidden";
    stateVars.isComp867312Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "tarimsalsulamaonsurecler_149112_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        ReactSystemFunctions.convertToTypeByName("kW", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp987888Visible =
      (ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "tarimsalsulamaonsurecler_149112_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        ReactSystemFunctions.convertToTypeByName("HP", "string")
      ) ||
        ReactSystemFunctions.isEmpty(
          ReactSystemFunctions.toString(
            this,
            ReactSystemFunctions.value(
              this,
              "tarimsalsulamaonsurecler_149112_value",
              "value",
              "",
              "key",
              ""
            )
          ),
          ReactSystemFunctions.convertToTypeByName("True", "string")
        )) === true
        ? "visible"
        : "hidden";
    stateVars.isComp564425Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "tarimsalsulamaonsurecler_149112_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        ReactSystemFunctions.convertToTypeByName("kW", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.tarimsalsulamaonsurecler_357016_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kategoriAdi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].kategoriAdi
          : null
      );

    formVars.tarimsalsulamaonsurecler_455222_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netsisProjKodu
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].netsisProjKodu
          : null
      );

    formVars.tarimsalsulamaonsurecler_402895_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].musteriAdi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].musteriAdi
          : null
      );

    formVars.tarimsalsulamaonsurecler_625966_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].iletisimKisi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].iletisimKisi
          : null
      );

    formVars.tarimsalsulamaonsurecler_514278_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].telefon
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].telefon
          : null
      );

    stateVars.isComp825089Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.tarimsalsulamaonsurecler_784309_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_Tarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_Tarih
        : null
    );

    formVars.tarimsalsulamaonsurecler_936865_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
          : null
      );

    stateVars.isComp340333Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp589579Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciAdi
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciAdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.tarimsalsulamaonsurecler_115403_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].proforma_Tarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].proforma_Tarih
        : null
    );

    formVars.tarimsalsulamaonsurecler_199667_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciAdi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciAdi
          : null
      );

    stateVars.isComp278838Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciAdi
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciAdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp788639Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.tarimsalsulamaonsurecler_122248_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netKesif_Tarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].netKesif_Tarih
        : null
    );

    formVars.tarimsalsulamaonsurecler_330741_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
          : null
      );

    stateVars.isComp557821Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp171830Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.tarimsalsulamaonsurecler_977440_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].pM_OnayTarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].pM_OnayTarih
        : null
    );

    formVars.tarimsalsulamaonsurecler_76435_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanAdi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanAdi
          : null
      );

    stateVars.isComp485928Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp429832Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].uY_OnaylayanId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].uY_OnaylayanId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.tarimsalsulamaonsurecler_585379_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[
              stateVars.GET_ON_SUREC_OZET_GETIR.length - 1
            ].uY_OnayTarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[
            this.state.GET_ON_SUREC_OZET_GETIR.length - 1
          ].uY_OnayTarih
        : null
    );

    formVars.tarimsalsulamaonsurecler_678296_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[
                stateVars.GET_ON_SUREC_OZET_GETIR.length - 1
              ].uY_OnaylayanAdi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[
              this.state.GET_ON_SUREC_OZET_GETIR.length - 1
            ].uY_OnaylayanAdi
          : null
      );

    stateVars.isComp384588Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].uY_OnaylayanId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].uY_OnaylayanId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp814465Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.tarimsalsulamaonsurecler_197581_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_TahminiGuc
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_TahminiGuc
          : null
      );

    formVars.tarimsalsulamaonsurecler_4809_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_AlanM2
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_AlanM2
          : null
      );

    formVars.tarimsalsulamaonsurecler_969958_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].teknik_CatiTipi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].teknik_CatiTipi
          : null
      );

    formVars.tarimsalsulamaonsurecler_905887_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].onKesif_ToplamMaliyet
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].onKesif_ToplamMaliyet
          : null
      );

    stateVars.isComp831693Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp551404Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].pM_OnayDurum
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].pM_OnayDurum
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("ONAYLANDI", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp687126Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].pM_OnayDurum
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].pM_OnayDurum
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("ONAYLANDI", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.tarimsalsulamaonsurecler_958888_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kategoriAdi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].kategoriAdi
          : null
      );

    formVars.tarimsalsulamaonsurecler_156155_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netsisProjKodu
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].netsisProjKodu
          : null
      );

    formVars.tarimsalsulamaonsurecler_987296_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].musteriAdi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].musteriAdi
          : null
      );

    formVars.tarimsalsulamaonsurecler_179447_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].iletisimKisi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].iletisimKisi
          : null
      );

    formVars.tarimsalsulamaonsurecler_451953_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].telefon
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].telefon
          : null
      );

    stateVars.isComp52540Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.tarimsalsulamaonsurecler_106507_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_Tarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_Tarih
        : null
    );

    formVars.tarimsalsulamaonsurecler_117221_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
          : null
      );

    stateVars.isComp647527Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp371141Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciAdi
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciAdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.tarimsalsulamaonsurecler_686232_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].proforma_Tarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].proforma_Tarih
        : null
    );

    formVars.tarimsalsulamaonsurecler_621424_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciAdi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciAdi
          : null
      );

    stateVars.isComp583734Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciAdi
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciAdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp3461Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.tarimsalsulamaonsurecler_112950_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netKesif_Tarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].netKesif_Tarih
        : null
    );

    formVars.tarimsalsulamaonsurecler_615433_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
          : null
      );

    stateVars.isComp848368Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp135945Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanAdi
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanAdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.tarimsalsulamaonsurecler_140697_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].pM_OnayTarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].pM_OnayTarih
        : null
    );

    formVars.tarimsalsulamaonsurecler_64459_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanAdi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanAdi
          : null
      );

    stateVars.isComp289590Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanAdi
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanAdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp432583Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].uY_OnaylayanAdi
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].uY_OnaylayanAdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.tarimsalsulamaonsurecler_616609_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[
              stateVars.GET_ON_SUREC_OZET_GETIR.length - 1
            ].uY_OnayTarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[
            this.state.GET_ON_SUREC_OZET_GETIR.length - 1
          ].uY_OnayTarih
        : null
    );

    formVars.tarimsalsulamaonsurecler_619277_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[
                stateVars.GET_ON_SUREC_OZET_GETIR.length - 1
              ].uY_OnaylayanAdi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[
              this.state.GET_ON_SUREC_OZET_GETIR.length - 1
            ].uY_OnaylayanAdi
          : null
      );

    stateVars.isComp781192Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].uY_OnaylayanAdi
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].uY_OnaylayanAdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp465589Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.tarimsalsulamaonsurecler_676113_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_TahminiGuc
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_TahminiGuc
          : null
      );

    formVars.tarimsalsulamaonsurecler_395234_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_AlanM2
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_AlanM2
          : null
      );

    formVars.tarimsalsulamaonsurecler_554511_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].teknik_CatiTipi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].teknik_CatiTipi
          : null
      );

    formVars.tarimsalsulamaonsurecler_688343_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].onKesif_ToplamMaliyet
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].onKesif_ToplamMaliyet
          : null
      );

    stateVars.isComp848477Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp500544Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp233488Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].uY_OnayDurum
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].uY_OnayDurum
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("ONAYLANDI", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp320489Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].uY_OnayDurum
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].uY_OnayDurum
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("ONAYLANDI", "string")
      ) === true
        ? "visible"
        : "hidden";

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  TarimsalSulamaOnSureclerComponent_838016_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  TarimsalSulamaOnSureclerComponent_490554_onActive = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      KategoriKodu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("CATI_GES", "string"),
        "string"
      ),
      TipKodu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("1", "string"),
        "string"
      ),
      ProjeId_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
        "number"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "TarimsalSulamaOnSurecler/TarimsalSulamaOnSureclerComponent_490554_onActive",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetProjeAsamalari = result?.data.getProjeAsamalari;
    stateVars.GET_ON_SUREC_OZET_GETIR = result?.data.geT_ON_SUREC_OZET_GETIR;
    formVars.tarimsalsulamaonsurecler_271446_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].projeKodu
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].projeKodu
          : null
      );
    formVars.tarimsalsulamaonsurecler_585180_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kategoriAdi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].kategoriAdi
          : null
      );
    formVars.tarimsalsulamaonsurecler_491925_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].projeAdi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].projeAdi
          : null
      );
    formVars.tarimsalsulamaonsurecler_135540_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].iletisimKisi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].iletisimKisi
          : null
      );
    formVars.tarimsalsulamaonsurecler_554247_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].musteriAdi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].musteriAdi
          : null
      );
    formVars.tarimsalsulamaonsurecler_470797_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].baslangicTarihi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].baslangicTarihi
        : null
    );
    formVars.tarimsalsulamaonsurecler_931176_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].tahminiBitis
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].tahminiBitis
        : null
    );
    formVars.tarimsalsulamaonsurecler_286346_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kategoriAdi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].kategoriAdi
          : null
      );
    formVars.tarimsalsulamaonsurecler_725534_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netsisProjKodu
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].netsisProjKodu
          : null
      );
    formVars.tarimsalsulamaonsurecler_82922_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].musteriAdi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].musteriAdi
          : null
      );
    formVars.tarimsalsulamaonsurecler_548_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].iletisimKisi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].iletisimKisi
        : null
    );
    formVars.tarimsalsulamaonsurecler_21963_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].telefon
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].telefon
          : null
      );
    formVars.tarimsalsulamaonsurecler_819965_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_Tarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_Tarih
        : null
    );
    formVars.tarimsalsulamaonsurecler_726292_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
          : null
      );
    formVars.tarimsalsulamaonsurecler_32769_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].proforma_Tarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].proforma_Tarih
        : null
    );
    formVars.tarimsalsulamaonsurecler_726526_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciAdi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciAdi
          : null
      );
    formVars.tarimsalsulamaonsurecler_776921_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netKesif_Tarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].netKesif_Tarih
        : null
    );
    formVars.tarimsalsulamaonsurecler_735264_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
          : null
      );
    formVars.tarimsalsulamaonsurecler_916010_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].pM_OnayTarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].pM_OnayTarih
        : null
    );
    formVars.tarimsalsulamaonsurecler_365802_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanAdi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanAdi
          : null
      );
    formVars.tarimsalsulamaonsurecler_295328_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[
              stateVars.GET_ON_SUREC_OZET_GETIR.length - 1
            ].uY_OnayTarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[
            this.state.GET_ON_SUREC_OZET_GETIR.length - 1
          ].uY_OnayTarih
        : null
    );
    formVars.tarimsalsulamaonsurecler_511988_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[
                stateVars.GET_ON_SUREC_OZET_GETIR.length - 1
              ].uY_OnaylayanAdi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[
              this.state.GET_ON_SUREC_OZET_GETIR.length - 1
            ].uY_OnaylayanAdi
          : null
      );
    formVars.tarimsalsulamaonsurecler_979930_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_TahminiGuc
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_TahminiGuc
          : null
      );
    formVars.tarimsalsulamaonsurecler_120818_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_AlanM2
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_AlanM2
          : null
      );
    formVars.tarimsalsulamaonsurecler_300623_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].teknik_CatiTipi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].teknik_CatiTipi
          : null
      );
    formVars.tarimsalsulamaonsurecler_379284_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].onKesif_ToplamMaliyet
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].onKesif_ToplamMaliyet
          : null
      );
    formVars.tarimsalsulamaonsurecler_357016_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kategoriAdi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].kategoriAdi
          : null
      );
    formVars.tarimsalsulamaonsurecler_455222_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netsisProjKodu
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].netsisProjKodu
          : null
      );
    formVars.tarimsalsulamaonsurecler_402895_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].musteriAdi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].musteriAdi
          : null
      );
    formVars.tarimsalsulamaonsurecler_625966_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].iletisimKisi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].iletisimKisi
          : null
      );
    formVars.tarimsalsulamaonsurecler_514278_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].telefon
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].telefon
          : null
      );
    formVars.tarimsalsulamaonsurecler_784309_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_Tarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_Tarih
        : null
    );
    formVars.tarimsalsulamaonsurecler_936865_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
          : null
      );
    formVars.tarimsalsulamaonsurecler_115403_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].proforma_Tarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].proforma_Tarih
        : null
    );
    formVars.tarimsalsulamaonsurecler_199667_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciAdi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciAdi
          : null
      );
    formVars.tarimsalsulamaonsurecler_122248_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netKesif_Tarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].netKesif_Tarih
        : null
    );
    formVars.tarimsalsulamaonsurecler_330741_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
          : null
      );
    formVars.tarimsalsulamaonsurecler_977440_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].pM_OnayTarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].pM_OnayTarih
        : null
    );
    formVars.tarimsalsulamaonsurecler_76435_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanAdi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanAdi
          : null
      );
    formVars.tarimsalsulamaonsurecler_585379_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[
              stateVars.GET_ON_SUREC_OZET_GETIR.length - 1
            ].uY_OnayTarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[
            this.state.GET_ON_SUREC_OZET_GETIR.length - 1
          ].uY_OnayTarih
        : null
    );
    formVars.tarimsalsulamaonsurecler_678296_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[
                stateVars.GET_ON_SUREC_OZET_GETIR.length - 1
              ].uY_OnaylayanAdi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[
              this.state.GET_ON_SUREC_OZET_GETIR.length - 1
            ].uY_OnaylayanAdi
          : null
      );
    formVars.tarimsalsulamaonsurecler_197581_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_TahminiGuc
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_TahminiGuc
          : null
      );
    formVars.tarimsalsulamaonsurecler_4809_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_AlanM2
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_AlanM2
          : null
      );
    formVars.tarimsalsulamaonsurecler_969958_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].teknik_CatiTipi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].teknik_CatiTipi
          : null
      );
    formVars.tarimsalsulamaonsurecler_905887_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].onKesif_ToplamMaliyet
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].onKesif_ToplamMaliyet
          : null
      );
    formVars.tarimsalsulamaonsurecler_958888_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kategoriAdi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].kategoriAdi
          : null
      );
    formVars.tarimsalsulamaonsurecler_156155_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netsisProjKodu
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].netsisProjKodu
          : null
      );
    formVars.tarimsalsulamaonsurecler_987296_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].musteriAdi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].musteriAdi
          : null
      );
    formVars.tarimsalsulamaonsurecler_179447_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].iletisimKisi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].iletisimKisi
          : null
      );
    formVars.tarimsalsulamaonsurecler_451953_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].telefon
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].telefon
          : null
      );
    formVars.tarimsalsulamaonsurecler_106507_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_Tarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_Tarih
        : null
    );
    formVars.tarimsalsulamaonsurecler_117221_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
          : null
      );
    formVars.tarimsalsulamaonsurecler_686232_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].proforma_Tarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].proforma_Tarih
        : null
    );
    formVars.tarimsalsulamaonsurecler_621424_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciAdi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciAdi
          : null
      );
    formVars.tarimsalsulamaonsurecler_112950_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netKesif_Tarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].netKesif_Tarih
        : null
    );
    formVars.tarimsalsulamaonsurecler_615433_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
          : null
      );
    formVars.tarimsalsulamaonsurecler_140697_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].pM_OnayTarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].pM_OnayTarih
        : null
    );
    formVars.tarimsalsulamaonsurecler_64459_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanAdi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanAdi
          : null
      );
    formVars.tarimsalsulamaonsurecler_616609_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[
              stateVars.GET_ON_SUREC_OZET_GETIR.length - 1
            ].uY_OnayTarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[
            this.state.GET_ON_SUREC_OZET_GETIR.length - 1
          ].uY_OnayTarih
        : null
    );
    formVars.tarimsalsulamaonsurecler_619277_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[
                stateVars.GET_ON_SUREC_OZET_GETIR.length - 1
              ].uY_OnaylayanAdi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[
              this.state.GET_ON_SUREC_OZET_GETIR.length - 1
            ].uY_OnaylayanAdi
          : null
      );
    formVars.tarimsalsulamaonsurecler_676113_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_TahminiGuc
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_TahminiGuc
          : null
      );
    formVars.tarimsalsulamaonsurecler_395234_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_AlanM2
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_AlanM2
          : null
      );
    formVars.tarimsalsulamaonsurecler_554511_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].teknik_CatiTipi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].teknik_CatiTipi
          : null
      );
    formVars.tarimsalsulamaonsurecler_688343_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].onKesif_ToplamMaliyet
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].onKesif_ToplamMaliyet
          : null
      );
    stateVars.isComp930685Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp200548Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp38139Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp230193Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp108416Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp167824Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp995070Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanAdi
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanAdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp606562Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanAdi
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanAdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp777039Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].uY_OnaylayanAdi
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].uY_OnaylayanAdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp682157Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].uY_OnaylayanAdi
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].uY_OnaylayanAdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp457735Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp825089Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp340333Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp589579Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciAdi
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciAdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp278838Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciAdi
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciAdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp788639Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp557821Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp171830Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp485928Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp429832Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].uY_OnaylayanId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].uY_OnaylayanId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp384588Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].uY_OnaylayanId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].uY_OnaylayanId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp814465Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp831693Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp551404Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].pM_OnayDurum
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].pM_OnayDurum
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("ONAYLANDI", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp687126Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].pM_OnayDurum
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].pM_OnayDurum
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("ONAYLANDI", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp52540Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp647527Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp371141Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciAdi
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciAdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp583734Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciAdi
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciAdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp3461Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp848368Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp135945Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanAdi
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanAdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp289590Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanAdi
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanAdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp432583Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].uY_OnaylayanAdi
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].uY_OnaylayanAdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp781192Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].uY_OnaylayanAdi
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].uY_OnaylayanAdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp465589Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp848477Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp500544Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp233488Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].uY_OnayDurum
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].uY_OnayDurum
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("ONAYLANDI", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp320489Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].uY_OnayDurum
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].uY_OnayDurum
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("ONAYLANDI", "string")
      ) === true
        ? "visible"
        : "hidden";
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.TarimsalSulamaOnSureclerComponent_490554_onActive1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  TarimsalSulamaOnSureclerComponent_490554_onActive1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.tarimsalsulamaonsurecler_271446_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].projeKodu
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].projeKodu
          : null
      );

    formVars.tarimsalsulamaonsurecler_585180_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kategoriAdi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].kategoriAdi
          : null
      );

    formVars.tarimsalsulamaonsurecler_491925_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].projeAdi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].projeAdi
          : null
      );

    formVars.tarimsalsulamaonsurecler_135540_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].iletisimKisi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].iletisimKisi
          : null
      );

    formVars.tarimsalsulamaonsurecler_554247_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].musteriAdi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].musteriAdi
          : null
      );

    formVars.tarimsalsulamaonsurecler_470797_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].baslangicTarihi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].baslangicTarihi
        : null
    );

    formVars.tarimsalsulamaonsurecler_931176_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].tahminiBitis
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].tahminiBitis
        : null
    );

    formVars.tarimsalsulamaonsurecler_286346_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kategoriAdi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].kategoriAdi
          : null
      );

    formVars.tarimsalsulamaonsurecler_725534_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netsisProjKodu
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].netsisProjKodu
          : null
      );

    formVars.tarimsalsulamaonsurecler_82922_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].musteriAdi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].musteriAdi
          : null
      );

    formVars.tarimsalsulamaonsurecler_548_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].iletisimKisi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].iletisimKisi
        : null
    );

    formVars.tarimsalsulamaonsurecler_21963_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].telefon
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].telefon
          : null
      );

    formVars.tarimsalsulamaonsurecler_819965_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_Tarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_Tarih
        : null
    );

    formVars.tarimsalsulamaonsurecler_726292_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
          : null
      );

    formVars.tarimsalsulamaonsurecler_32769_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].proforma_Tarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].proforma_Tarih
        : null
    );

    formVars.tarimsalsulamaonsurecler_726526_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciAdi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciAdi
          : null
      );

    formVars.tarimsalsulamaonsurecler_776921_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netKesif_Tarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].netKesif_Tarih
        : null
    );

    formVars.tarimsalsulamaonsurecler_735264_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
          : null
      );

    formVars.tarimsalsulamaonsurecler_916010_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].pM_OnayTarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].pM_OnayTarih
        : null
    );

    formVars.tarimsalsulamaonsurecler_365802_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanAdi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanAdi
          : null
      );

    formVars.tarimsalsulamaonsurecler_295328_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[
              stateVars.GET_ON_SUREC_OZET_GETIR.length - 1
            ].uY_OnayTarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[
            this.state.GET_ON_SUREC_OZET_GETIR.length - 1
          ].uY_OnayTarih
        : null
    );

    formVars.tarimsalsulamaonsurecler_511988_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[
                stateVars.GET_ON_SUREC_OZET_GETIR.length - 1
              ].uY_OnaylayanAdi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[
              this.state.GET_ON_SUREC_OZET_GETIR.length - 1
            ].uY_OnaylayanAdi
          : null
      );

    formVars.tarimsalsulamaonsurecler_979930_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_TahminiGuc
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_TahminiGuc
          : null
      );

    formVars.tarimsalsulamaonsurecler_120818_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_AlanM2
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_AlanM2
          : null
      );

    formVars.tarimsalsulamaonsurecler_300623_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].teknik_CatiTipi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].teknik_CatiTipi
          : null
      );

    formVars.tarimsalsulamaonsurecler_379284_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].onKesif_ToplamMaliyet
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].onKesif_ToplamMaliyet
          : null
      );

    formVars.tarimsalsulamaonsurecler_357016_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kategoriAdi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].kategoriAdi
          : null
      );

    formVars.tarimsalsulamaonsurecler_455222_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netsisProjKodu
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].netsisProjKodu
          : null
      );

    formVars.tarimsalsulamaonsurecler_402895_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].musteriAdi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].musteriAdi
          : null
      );

    formVars.tarimsalsulamaonsurecler_625966_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].iletisimKisi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].iletisimKisi
          : null
      );

    formVars.tarimsalsulamaonsurecler_514278_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].telefon
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].telefon
          : null
      );

    formVars.tarimsalsulamaonsurecler_784309_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_Tarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_Tarih
        : null
    );

    formVars.tarimsalsulamaonsurecler_936865_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
          : null
      );

    formVars.tarimsalsulamaonsurecler_115403_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].proforma_Tarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].proforma_Tarih
        : null
    );

    formVars.tarimsalsulamaonsurecler_199667_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciAdi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciAdi
          : null
      );

    formVars.tarimsalsulamaonsurecler_122248_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netKesif_Tarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].netKesif_Tarih
        : null
    );

    formVars.tarimsalsulamaonsurecler_330741_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
          : null
      );

    formVars.tarimsalsulamaonsurecler_977440_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].pM_OnayTarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].pM_OnayTarih
        : null
    );

    formVars.tarimsalsulamaonsurecler_76435_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanAdi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanAdi
          : null
      );

    formVars.tarimsalsulamaonsurecler_585379_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[
              stateVars.GET_ON_SUREC_OZET_GETIR.length - 1
            ].uY_OnayTarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[
            this.state.GET_ON_SUREC_OZET_GETIR.length - 1
          ].uY_OnayTarih
        : null
    );

    formVars.tarimsalsulamaonsurecler_678296_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[
                stateVars.GET_ON_SUREC_OZET_GETIR.length - 1
              ].uY_OnaylayanAdi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[
              this.state.GET_ON_SUREC_OZET_GETIR.length - 1
            ].uY_OnaylayanAdi
          : null
      );

    formVars.tarimsalsulamaonsurecler_197581_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_TahminiGuc
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_TahminiGuc
          : null
      );

    formVars.tarimsalsulamaonsurecler_4809_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_AlanM2
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_AlanM2
          : null
      );

    formVars.tarimsalsulamaonsurecler_969958_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].teknik_CatiTipi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].teknik_CatiTipi
          : null
      );

    formVars.tarimsalsulamaonsurecler_905887_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].onKesif_ToplamMaliyet
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].onKesif_ToplamMaliyet
          : null
      );

    formVars.tarimsalsulamaonsurecler_958888_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kategoriAdi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].kategoriAdi
          : null
      );

    formVars.tarimsalsulamaonsurecler_156155_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netsisProjKodu
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].netsisProjKodu
          : null
      );

    formVars.tarimsalsulamaonsurecler_987296_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].musteriAdi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].musteriAdi
          : null
      );

    formVars.tarimsalsulamaonsurecler_179447_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].iletisimKisi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].iletisimKisi
          : null
      );

    formVars.tarimsalsulamaonsurecler_451953_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].telefon
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].telefon
          : null
      );

    formVars.tarimsalsulamaonsurecler_106507_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_Tarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_Tarih
        : null
    );

    formVars.tarimsalsulamaonsurecler_117221_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
          : null
      );

    formVars.tarimsalsulamaonsurecler_686232_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].proforma_Tarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].proforma_Tarih
        : null
    );

    formVars.tarimsalsulamaonsurecler_621424_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciAdi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciAdi
          : null
      );

    formVars.tarimsalsulamaonsurecler_112950_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netKesif_Tarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].netKesif_Tarih
        : null
    );

    formVars.tarimsalsulamaonsurecler_615433_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
          : null
      );

    formVars.tarimsalsulamaonsurecler_140697_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].pM_OnayTarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].pM_OnayTarih
        : null
    );

    formVars.tarimsalsulamaonsurecler_64459_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanAdi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanAdi
          : null
      );

    formVars.tarimsalsulamaonsurecler_616609_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[
              stateVars.GET_ON_SUREC_OZET_GETIR.length - 1
            ].uY_OnayTarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[
            this.state.GET_ON_SUREC_OZET_GETIR.length - 1
          ].uY_OnayTarih
        : null
    );

    formVars.tarimsalsulamaonsurecler_619277_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[
                stateVars.GET_ON_SUREC_OZET_GETIR.length - 1
              ].uY_OnaylayanAdi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[
              this.state.GET_ON_SUREC_OZET_GETIR.length - 1
            ].uY_OnaylayanAdi
          : null
      );

    formVars.tarimsalsulamaonsurecler_676113_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_TahminiGuc
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_TahminiGuc
          : null
      );

    formVars.tarimsalsulamaonsurecler_395234_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_AlanM2
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_AlanM2
          : null
      );

    formVars.tarimsalsulamaonsurecler_554511_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].teknik_CatiTipi
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].teknik_CatiTipi
          : null
      );

    formVars.tarimsalsulamaonsurecler_688343_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
          ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? stateVars.GET_ON_SUREC_OZET_GETIR[0].onKesif_ToplamMaliyet
            : null
          : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? this.state.GET_ON_SUREC_OZET_GETIR[0].onKesif_ToplamMaliyet
          : null
      );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  TarimsalSulamaOnSureclerComponent_367991_onActive = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      ProjeId_2: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
        "number"
      ),
      DbName_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.AktifSirketGetir !== undefined
            ? stateVars.AktifSirketGetir?.length > 0
              ? stateVars.AktifSirketGetir[0].sirket
              : null
            : this.state.AktifSirketGetir?.length > 0
            ? this.state.AktifSirketGetir[0].sirket
            : null
        ),
        "string"
      ),
      Ara_3: ReactSystemFunctions.convertToTypeByName(null, "string"),
      ProjeId_4: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
        "number"
      ),
      ProjeId_5: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
        "number"
      ),
      IslemTipi_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("ON_KESIF", "string"),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "TarimsalSulamaOnSurecler/TarimsalSulamaOnSureclerComponent_367991_onActive",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.AktifSirketGetir = result?.data.aktifSirketGetir;
    stateVars.GET_SATIS_TEMSILCISI = result?.data.geT_SATIS_TEMSILCISI;

    formVars.tarimsalsulamaonsurecler_234840_options =
      stateVars.GET_SATIS_TEMSILCISI;

    formVars.tarimsalsulamaonsurecler_390590_options =
      stateVars.GET_SATIS_TEMSILCISI;
    stateVars.GET_PROJE_ON_SUREC = result?.data.geT_PROJE_ON_SUREC;
    stateVars.GET_NETSIS_STOK_LISTESI = result?.data.geT_NETSIS_STOK_LISTESI;

    formVars.tarimsalsulamaonsurecler_393036_options =
      stateVars.GET_NETSIS_STOK_LISTESI;
    stateVars.CATI_GES_ON_KESIF_GETIR = result?.data.catI_GES_ON_KESIF_GETIR;
    formVars.tarimsalsulamaonsurecler_14467_value = ReactSystemFunctions.value(
      this,
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].sozlesmeGucu_kW
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].sozlesmeGucu_kW
        : null
    );
    formVars.tarimsalsulamaonsurecler_766200_value = ReactSystemFunctions.value(
      this,
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].trafoGucu_kVA
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].trafoGucu_kVA
        : null
    );
    formVars.tarimsalsulamaonsurecler_145387_value = ReactSystemFunctions.value(
      this,
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].anaŞalterAkim_A
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].anaŞalterAkim_A
        : null
    );
    formVars.tarimsalsulamaonsurecler_707377_value =
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].aboneTipi
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].aboneTipi
        : null;
    formVars.tarimsalsulamaonsurecler_743336_value = ReactSystemFunctions.value(
      this,
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].panoMesafesi_m
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].panoMesafesi_m
        : null
    );
    formVars.tarimsalsulamaonsurecler_166467_value =
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].catiTipi
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].catiTipi
        : null;
    formVars.tarimsalsulamaonsurecler_724523_value = ReactSystemFunctions.value(
      this,
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].catiEgimi_Derece
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].catiEgimi_Derece
        : null
    );
    formVars.tarimsalsulamaonsurecler_867312_value = ReactSystemFunctions.value(
      this,
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].catiEgimi_Derece
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].catiEgimi_Derece
        : null
    );
    formVars.tarimsalsulamaonsurecler_149112_value =
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].catiYonu
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].catiYonu
        : null;
    formVars.tarimsalsulamaonsurecler_380385_value =
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].catiYonu
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].catiYonu
        : null;
    formVars.tarimsalsulamaonsurecler_886075_value = ReactSystemFunctions.value(
      this,
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].kullanilabilirAlan_m2
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].kullanilabilirAlan_m2
        : null
    );
    formVars.tarimsalsulamaonsurecler_186956_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
          ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
            ? stateVars.CATI_GES_ON_KESIF_GETIR[0].adaParselBilgisi
            : null
          : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? this.state.CATI_GES_ON_KESIF_GETIR[0].adaParselBilgisi
          : null
      );
    formVars.tarimsalsulamaonsurecler_628425_value =
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].catiYonu
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].catiYonu
        : null;
    formVars.tarimsalsulamaonsurecler_681014_value =
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].catiTasiyiciSistem
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].catiTasiyiciSistem
        : null;
    formVars.tarimsalsulamaonsurecler_321509_value =
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].catiTasiyiciSistem
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].catiTasiyiciSistem
        : null;
    formVars.tarimsalsulamaonsurecler_310926_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
          ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
            ? stateVars.CATI_GES_ON_KESIF_GETIR[0].adaParselBilgisi
            : null
          : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? this.state.CATI_GES_ON_KESIF_GETIR[0].adaParselBilgisi
          : null
      );
    formVars.tarimsalsulamaonsurecler_174079_value =
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].catiTasiyiciSistem
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].catiTasiyiciSistem
        : null;
    formVars.tarimsalsulamaonsurecler_107465_value = ReactSystemFunctions.value(
      this,
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].catiEgimi_Derece
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].catiEgimi_Derece
        : null
    );
    formVars.tarimsalsulamaonsurecler_542990_value = ReactSystemFunctions.value(
      this,
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].panoMesafesi_m
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].panoMesafesi_m
        : null
    );
    formVars.tarimsalsulamaonsurecler_195553_value = ReactSystemFunctions.value(
      this,
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].panoMesafesi_m
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].panoMesafesi_m
        : null
    );
    formVars.tarimsalsulamaonsurecler_118876_value =
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].catiTasiyiciSistem
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].catiTasiyiciSistem
        : null;
    formVars.tarimsalsulamaonsurecler_80062_value = ReactSystemFunctions.value(
      this,
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].panoMesafesi_m
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].panoMesafesi_m
        : null
    );
    formVars.tarimsalsulamaonsurecler_900878_value =
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].catiTasiyiciSistem
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].catiTasiyiciSistem
        : null;
    formVars.tarimsalsulamaonsurecler_928420_value = ReactSystemFunctions.value(
      this,
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].panoMesafesi_m
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].panoMesafesi_m
        : null
    );
    formVars.tarimsalsulamaonsurecler_753684_value =
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].catiTasiyiciSistem
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].catiTasiyiciSistem
        : null;
    formVars.tarimsalsulamaonsurecler_648547_value =
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].catiTasiyiciSistem
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].catiTasiyiciSistem
        : null;
    formVars.tarimsalsulamaonsurecler_124355_value =
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].catiTasiyiciSistem
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].catiTasiyiciSistem
        : null;
    formVars.tarimsalsulamaonsurecler_994578_value =
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].catiTasiyiciSistem
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].catiTasiyiciSistem
        : null;
    formVars.tarimsalsulamaonsurecler_225026_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
          ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
            ? stateVars.CATI_GES_ON_KESIF_GETIR[
                stateVars.CATI_GES_ON_KESIF_GETIR.length - 1
              ].kesif_Aciklama1
            : null
          : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? this.state.CATI_GES_ON_KESIF_GETIR[
              this.state.CATI_GES_ON_KESIF_GETIR.length - 1
            ].kesif_Aciklama1
          : null
      );
    formVars.tarimsalsulamaonsurecler_26200_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
          ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
            ? stateVars.CATI_GES_ON_KESIF_GETIR[
                stateVars.CATI_GES_ON_KESIF_GETIR.length - 1
              ].kesif_Aciklama2
            : null
          : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? this.state.CATI_GES_ON_KESIF_GETIR[
              this.state.CATI_GES_ON_KESIF_GETIR.length - 1
            ].kesif_Aciklama2
          : null
      );
    formVars.tarimsalsulamaonsurecler_122352_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
          ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
            ? stateVars.CATI_GES_ON_KESIF_GETIR[0].kesif_Aciklama3
            : null
          : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? this.state.CATI_GES_ON_KESIF_GETIR[0].kesif_Aciklama3
          : null
      );
    formVars.tarimsalsulamaonsurecler_606165_value = ReactSystemFunctions.value(
      this,
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].sozlesmeGucu_kW
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].sozlesmeGucu_kW
        : null
    );
    formVars.tarimsalsulamaonsurecler_205697_value = ReactSystemFunctions.value(
      this,
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].trafoGucu_kVA
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].trafoGucu_kVA
        : null
    );
    formVars.tarimsalsulamaonsurecler_137398_value = ReactSystemFunctions.value(
      this,
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].anaŞalterAkim_A
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].anaŞalterAkim_A
        : null
    );
    formVars.tarimsalsulamaonsurecler_428549_value =
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].aboneTipi
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].aboneTipi
        : null;
    formVars.tarimsalsulamaonsurecler_299122_value = ReactSystemFunctions.value(
      this,
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].panoMesafesi_m
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].panoMesafesi_m
        : null
    );
    formVars.tarimsalsulamaonsurecler_301315_value =
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].catiTipi
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].catiTipi
        : null;
    formVars.tarimsalsulamaonsurecler_987888_value = ReactSystemFunctions.value(
      this,
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].catiEgimi_Derece
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].catiEgimi_Derece
        : null
    );
    formVars.tarimsalsulamaonsurecler_564425_value = ReactSystemFunctions.value(
      this,
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].catiEgimi_Derece
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].catiEgimi_Derece
        : null
    );
    formVars.tarimsalsulamaonsurecler_347190_value =
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].catiYonu
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].catiYonu
        : null;
    formVars.tarimsalsulamaonsurecler_248435_value =
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].catiYonu
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].catiYonu
        : null;
    formVars.tarimsalsulamaonsurecler_527428_value = ReactSystemFunctions.value(
      this,
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].kullanilabilirAlan_m2
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].kullanilabilirAlan_m2
        : null
    );
    formVars.tarimsalsulamaonsurecler_363152_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
          ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
            ? stateVars.CATI_GES_ON_KESIF_GETIR[0].adaParselBilgisi
            : null
          : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? this.state.CATI_GES_ON_KESIF_GETIR[0].adaParselBilgisi
          : null
      );
    formVars.tarimsalsulamaonsurecler_54683_value =
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].catiYonu
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].catiYonu
        : null;
    formVars.tarimsalsulamaonsurecler_726812_value =
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].catiTasiyiciSistem
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].catiTasiyiciSistem
        : null;
    formVars.tarimsalsulamaonsurecler_320807_value =
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].catiTasiyiciSistem
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].catiTasiyiciSistem
        : null;
    formVars.tarimsalsulamaonsurecler_530736_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
          ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
            ? stateVars.CATI_GES_ON_KESIF_GETIR[0].adaParselBilgisi
            : null
          : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? this.state.CATI_GES_ON_KESIF_GETIR[0].adaParselBilgisi
          : null
      );
    formVars.tarimsalsulamaonsurecler_716982_value =
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].catiTasiyiciSistem
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].catiTasiyiciSistem
        : null;
    formVars.tarimsalsulamaonsurecler_39609_value = ReactSystemFunctions.value(
      this,
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].catiEgimi_Derece
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].catiEgimi_Derece
        : null
    );
    formVars.tarimsalsulamaonsurecler_468368_value = ReactSystemFunctions.value(
      this,
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].panoMesafesi_m
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].panoMesafesi_m
        : null
    );
    formVars.tarimsalsulamaonsurecler_732086_value = ReactSystemFunctions.value(
      this,
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].panoMesafesi_m
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].panoMesafesi_m
        : null
    );
    formVars.tarimsalsulamaonsurecler_407044_value =
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].catiTasiyiciSistem
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].catiTasiyiciSistem
        : null;
    formVars.tarimsalsulamaonsurecler_39980_value = ReactSystemFunctions.value(
      this,
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].panoMesafesi_m
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].panoMesafesi_m
        : null
    );
    formVars.tarimsalsulamaonsurecler_232820_value =
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].catiTasiyiciSistem
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].catiTasiyiciSistem
        : null;
    stateVars.PROJE_DOSYLARI_GETIR = result?.data.projE_DOSYLARI_GETIR;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.TarimsalSulamaOnSureclerComponent_367991_onActive1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  TarimsalSulamaOnSureclerComponent_367991_onActive1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.DosyalariDBdenYukle = CWTypeScript.DosyalariDBdenYukle(
      ReactSystemFunctions.toString(
        this,
        stateVars.GetUserByUsername !== undefined
          ? stateVars.GetUserByUsername?.length > 0
            ? stateVars.GetUserByUsername[0].id
            : null
          : this.state.GetUserByUsername?.length > 0
          ? this.state.GetUserByUsername[0].id
          : null
      ),
      this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
      ReactSystemFunctions.convertToTypeByName("ON_KESIF", "string"),
      ReactSystemFunctions.value(this, this.state.PROJE_DOSYLARI_GETIR)
    );
    stateVars.DosyalariGetir = CWTypeScript.DosyalariGetir(
      ReactSystemFunctions.toString(
        this,
        stateVars.GetUserByUsername !== undefined
          ? stateVars.GetUserByUsername?.length > 0
            ? stateVars.GetUserByUsername[0].id
            : null
          : this.state.GetUserByUsername?.length > 0
          ? this.state.GetUserByUsername[0].id
          : null
      ),
      this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
      ReactSystemFunctions.convertToTypeByName("ON_KESIF", "string")
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.TarimsalSulamaOnSureclerComponent_367991_onActive2_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  TarimsalSulamaOnSureclerComponent_367991_onActive2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      ProjeId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
        "number"
      ),
      TipKodu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("ON_KESIF", "string"),
        "string"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "TarimsalSulamaOnSurecler/TarimsalSulamaOnSureclerComponent_367991_onActive2_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.ON_KESIF_KALEMLER_GETIR = result?.data.oN_KESIF_KALEMLER_GETIR;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.TarimsalSulamaOnSureclerComponent_367991_onActive3_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  TarimsalSulamaOnSureclerComponent_367991_onActive3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.KalemleriDBdenYukle = CWTypeScript.KalemleriDBdenYukle(
      ReactSystemFunctions.toString(
        this,
        stateVars.GetUserByUsername !== undefined
          ? stateVars.GetUserByUsername?.length > 0
            ? stateVars.GetUserByUsername[0].id
            : null
          : this.state.GetUserByUsername?.length > 0
          ? this.state.GetUserByUsername[0].id
          : null
      ),
      this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
      ReactSystemFunctions.convertToTypeByName("ON_KESIF", "string"),
      ReactSystemFunctions.value(this, this.state.ON_KESIF_KALEMLER_GETIR)
    );
    stateVars.KalemleriGetir = CWTypeScript.KalemleriGetir(
      ReactSystemFunctions.toString(
        this,
        stateVars.GetUserByUsername !== undefined
          ? stateVars.GetUserByUsername?.length > 0
            ? stateVars.GetUserByUsername[0].id
            : null
          : this.state.GetUserByUsername?.length > 0
          ? this.state.GetUserByUsername[0].id
          : null
      ),
      this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
      ReactSystemFunctions.convertToTypeByName("ON_KESIF", "string")
    );

    formVars.tarimsalsulamaonsurecler_742412_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.KalemleriGetir !== undefined
          ? stateVars.KalemleriGetir?.length > 0
            ? stateVars.KalemleriGetir[0].genelToplam
            : null
          : this.state.KalemleriGetir?.length > 0
          ? this.state.KalemleriGetir[0].genelToplam
          : null
      );
    formVars.tarimsalsulamaonsurecler_505390_value = ReactSystemFunctions.value(
      this,
      stateVars.PROFORMA_GENEL_BILGILERI_GETIR !== undefined
        ? stateVars.PROFORMA_GENEL_BILGILERI_GETIR?.length > 0
          ? stateVars.PROFORMA_GENEL_BILGILERI_GETIR[0].proforma_Tutar
          : null
        : this.state.PROFORMA_GENEL_BILGILERI_GETIR?.length > 0
        ? this.state.PROFORMA_GENEL_BILGILERI_GETIR[0].proforma_Tutar
        : null
    );
    formVars.tarimsalsulamaonsurecler_505390_placeholder =
      ReactSystemFunctions.toString(
        this,
        stateVars.KalemleriGetir !== undefined
          ? stateVars.KalemleriGetir?.length > 0
            ? stateVars.KalemleriGetir[0].genelToplam
            : null
          : this.state.KalemleriGetir?.length > 0
          ? this.state.KalemleriGetir[0].genelToplam
          : null
      );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.TarimsalSulamaOnSureclerComponent_367991_onActive4_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  TarimsalSulamaOnSureclerComponent_367991_onActive4_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      UserName_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUsername(),
        "string"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "TarimsalSulamaOnSurecler/TarimsalSulamaOnSureclerComponent_367991_onActive4_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetUserByUsername = result?.data.getUserByUsername;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.TarimsalSulamaOnSureclerComponent_367991_onActive5_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  TarimsalSulamaOnSureclerComponent_367991_onActive5_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_234840 =
      stateVars.GET_SATIS_TEMSILCISI ?? this.state.GET_SATIS_TEMSILCISI;
    stateVars.dataSource_234840 =
      stateVars.GET_SATIS_TEMSILCISI ?? this.state.GET_SATIS_TEMSILCISI;
    formVars.tarimsalsulamaonsurecler_14467_value = ReactSystemFunctions.value(
      this,
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].sozlesmeGucu_kW
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].sozlesmeGucu_kW
        : null
    );

    formVars.tarimsalsulamaonsurecler_766200_value = ReactSystemFunctions.value(
      this,
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].trafoGucu_kVA
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].trafoGucu_kVA
        : null
    );

    formVars.tarimsalsulamaonsurecler_145387_value = ReactSystemFunctions.value(
      this,
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].anaŞalterAkim_A
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].anaŞalterAkim_A
        : null
    );

    formVars.tarimsalsulamaonsurecler_707377_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
          ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
            ? stateVars.CATI_GES_ON_KESIF_GETIR[0].aboneTipi
            : null
          : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? this.state.CATI_GES_ON_KESIF_GETIR[0].aboneTipi
          : null
      );

    formVars.tarimsalsulamaonsurecler_743336_value = ReactSystemFunctions.value(
      this,
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].panoMesafesi_m
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].panoMesafesi_m
        : null
    );

    formVars.tarimsalsulamaonsurecler_166467_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
          ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
            ? stateVars.CATI_GES_ON_KESIF_GETIR[0].catiTipi
            : null
          : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? this.state.CATI_GES_ON_KESIF_GETIR[0].catiTipi
          : null
      );

    formVars.tarimsalsulamaonsurecler_724523_value = ReactSystemFunctions.value(
      this,
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].catiEgimi_Derece
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].catiEgimi_Derece
        : null
    );

    formVars.tarimsalsulamaonsurecler_867312_value = ReactSystemFunctions.value(
      this,
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].catiEgimi_Derece
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].catiEgimi_Derece
        : null
    );

    formVars.tarimsalsulamaonsurecler_149112_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
          ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
            ? stateVars.CATI_GES_ON_KESIF_GETIR[0].catiYonu
            : null
          : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? this.state.CATI_GES_ON_KESIF_GETIR[0].catiYonu
          : null
      );

    formVars.tarimsalsulamaonsurecler_380385_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
          ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
            ? stateVars.CATI_GES_ON_KESIF_GETIR[0].catiYonu
            : null
          : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? this.state.CATI_GES_ON_KESIF_GETIR[0].catiYonu
          : null
      );

    formVars.tarimsalsulamaonsurecler_886075_value = ReactSystemFunctions.value(
      this,
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].kullanilabilirAlan_m2
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].kullanilabilirAlan_m2
        : null
    );

    formVars.tarimsalsulamaonsurecler_186956_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
          ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
            ? stateVars.CATI_GES_ON_KESIF_GETIR[0].adaParselBilgisi
            : null
          : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? this.state.CATI_GES_ON_KESIF_GETIR[0].adaParselBilgisi
          : null
      );

    formVars.tarimsalsulamaonsurecler_628425_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
          ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
            ? stateVars.CATI_GES_ON_KESIF_GETIR[0].catiYonu
            : null
          : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? this.state.CATI_GES_ON_KESIF_GETIR[0].catiYonu
          : null
      );

    formVars.tarimsalsulamaonsurecler_681014_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
          ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
            ? stateVars.CATI_GES_ON_KESIF_GETIR[0].catiTasiyiciSistem
            : null
          : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? this.state.CATI_GES_ON_KESIF_GETIR[0].catiTasiyiciSistem
          : null
      );

    formVars.tarimsalsulamaonsurecler_321509_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
          ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
            ? stateVars.CATI_GES_ON_KESIF_GETIR[0].catiTasiyiciSistem
            : null
          : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? this.state.CATI_GES_ON_KESIF_GETIR[0].catiTasiyiciSistem
          : null
      );

    formVars.tarimsalsulamaonsurecler_310926_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
          ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
            ? stateVars.CATI_GES_ON_KESIF_GETIR[0].adaParselBilgisi
            : null
          : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? this.state.CATI_GES_ON_KESIF_GETIR[0].adaParselBilgisi
          : null
      );

    formVars.tarimsalsulamaonsurecler_174079_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
          ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
            ? stateVars.CATI_GES_ON_KESIF_GETIR[0].catiTasiyiciSistem
            : null
          : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? this.state.CATI_GES_ON_KESIF_GETIR[0].catiTasiyiciSistem
          : null
      );

    formVars.tarimsalsulamaonsurecler_107465_value = ReactSystemFunctions.value(
      this,
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].catiEgimi_Derece
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].catiEgimi_Derece
        : null
    );

    formVars.tarimsalsulamaonsurecler_542990_value = ReactSystemFunctions.value(
      this,
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].panoMesafesi_m
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].panoMesafesi_m
        : null
    );

    formVars.tarimsalsulamaonsurecler_195553_value = ReactSystemFunctions.value(
      this,
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].panoMesafesi_m
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].panoMesafesi_m
        : null
    );

    formVars.tarimsalsulamaonsurecler_118876_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
          ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
            ? stateVars.CATI_GES_ON_KESIF_GETIR[0].catiTasiyiciSistem
            : null
          : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? this.state.CATI_GES_ON_KESIF_GETIR[0].catiTasiyiciSistem
          : null
      );

    formVars.tarimsalsulamaonsurecler_80062_value = ReactSystemFunctions.value(
      this,
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].panoMesafesi_m
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].panoMesafesi_m
        : null
    );

    formVars.tarimsalsulamaonsurecler_900878_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
          ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
            ? stateVars.CATI_GES_ON_KESIF_GETIR[0].catiTasiyiciSistem
            : null
          : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? this.state.CATI_GES_ON_KESIF_GETIR[0].catiTasiyiciSistem
          : null
      );

    formVars.tarimsalsulamaonsurecler_928420_value = ReactSystemFunctions.value(
      this,
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].panoMesafesi_m
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].panoMesafesi_m
        : null
    );

    formVars.tarimsalsulamaonsurecler_753684_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
          ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
            ? stateVars.CATI_GES_ON_KESIF_GETIR[0].catiTasiyiciSistem
            : null
          : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? this.state.CATI_GES_ON_KESIF_GETIR[0].catiTasiyiciSistem
          : null
      );

    formVars.tarimsalsulamaonsurecler_648547_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
          ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
            ? stateVars.CATI_GES_ON_KESIF_GETIR[0].catiTasiyiciSistem
            : null
          : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? this.state.CATI_GES_ON_KESIF_GETIR[0].catiTasiyiciSistem
          : null
      );

    formVars.tarimsalsulamaonsurecler_124355_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
          ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
            ? stateVars.CATI_GES_ON_KESIF_GETIR[0].catiTasiyiciSistem
            : null
          : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? this.state.CATI_GES_ON_KESIF_GETIR[0].catiTasiyiciSistem
          : null
      );

    formVars.tarimsalsulamaonsurecler_994578_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
          ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
            ? stateVars.CATI_GES_ON_KESIF_GETIR[0].catiTasiyiciSistem
            : null
          : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? this.state.CATI_GES_ON_KESIF_GETIR[0].catiTasiyiciSistem
          : null
      );

    stateVars.dataSource_478263 =
      stateVars.KalemleriGetir ?? this.state.KalemleriGetir;

    stateVars.dataSource_393036 =
      stateVars.GET_NETSIS_STOK_LISTESI ?? this.state.GET_NETSIS_STOK_LISTESI;
    stateVars.dataSource_393036 =
      stateVars.GET_NETSIS_STOK_LISTESI ?? this.state.GET_NETSIS_STOK_LISTESI;
    formVars.tarimsalsulamaonsurecler_225026_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
          ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
            ? stateVars.CATI_GES_ON_KESIF_GETIR[
                stateVars.CATI_GES_ON_KESIF_GETIR.length - 1
              ].kesif_Aciklama1
            : null
          : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? this.state.CATI_GES_ON_KESIF_GETIR[
              this.state.CATI_GES_ON_KESIF_GETIR.length - 1
            ].kesif_Aciklama1
          : null
      );

    formVars.tarimsalsulamaonsurecler_26200_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
          ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
            ? stateVars.CATI_GES_ON_KESIF_GETIR[
                stateVars.CATI_GES_ON_KESIF_GETIR.length - 1
              ].kesif_Aciklama2
            : null
          : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? this.state.CATI_GES_ON_KESIF_GETIR[
              this.state.CATI_GES_ON_KESIF_GETIR.length - 1
            ].kesif_Aciklama2
          : null
      );

    formVars.tarimsalsulamaonsurecler_122352_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
          ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
            ? stateVars.CATI_GES_ON_KESIF_GETIR[0].kesif_Aciklama3
            : null
          : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? this.state.CATI_GES_ON_KESIF_GETIR[0].kesif_Aciklama3
          : null
      );

    stateVars.dataSource_801362 =
      stateVars.DosyalariGetir ?? this.state.DosyalariGetir;
    formVars.tarimsalsulamaonsurecler_742412_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.KalemleriGetir !== undefined
          ? stateVars.KalemleriGetir?.length > 0
            ? stateVars.KalemleriGetir[0].genelToplam
            : null
          : this.state.KalemleriGetir?.length > 0
          ? this.state.KalemleriGetir[0].genelToplam
          : null
      );

    stateVars.dataSource_266261 =
      stateVars.DosyalariGetir ?? this.state.DosyalariGetir;
    formVars.tarimsalsulamaonsurecler_505390_placeholder =
      ReactSystemFunctions.toString(
        this,
        stateVars.KalemleriGetir !== undefined
          ? stateVars.KalemleriGetir?.length > 0
            ? stateVars.KalemleriGetir[0].genelToplam
            : null
          : this.state.KalemleriGetir?.length > 0
          ? this.state.KalemleriGetir[0].genelToplam
          : null
      );

    stateVars.dataSource_390590 =
      stateVars.GET_SATIS_TEMSILCISI ?? this.state.GET_SATIS_TEMSILCISI;
    stateVars.dataSource_390590 =
      stateVars.GET_SATIS_TEMSILCISI ?? this.state.GET_SATIS_TEMSILCISI;
    formVars.tarimsalsulamaonsurecler_606165_value = ReactSystemFunctions.value(
      this,
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].sozlesmeGucu_kW
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].sozlesmeGucu_kW
        : null
    );

    formVars.tarimsalsulamaonsurecler_205697_value = ReactSystemFunctions.value(
      this,
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].trafoGucu_kVA
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].trafoGucu_kVA
        : null
    );

    formVars.tarimsalsulamaonsurecler_137398_value = ReactSystemFunctions.value(
      this,
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].anaŞalterAkim_A
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].anaŞalterAkim_A
        : null
    );

    formVars.tarimsalsulamaonsurecler_428549_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
          ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
            ? stateVars.CATI_GES_ON_KESIF_GETIR[0].aboneTipi
            : null
          : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? this.state.CATI_GES_ON_KESIF_GETIR[0].aboneTipi
          : null
      );

    formVars.tarimsalsulamaonsurecler_299122_value = ReactSystemFunctions.value(
      this,
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].panoMesafesi_m
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].panoMesafesi_m
        : null
    );

    formVars.tarimsalsulamaonsurecler_301315_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
          ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
            ? stateVars.CATI_GES_ON_KESIF_GETIR[0].catiTipi
            : null
          : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? this.state.CATI_GES_ON_KESIF_GETIR[0].catiTipi
          : null
      );

    formVars.tarimsalsulamaonsurecler_987888_value = ReactSystemFunctions.value(
      this,
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].catiEgimi_Derece
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].catiEgimi_Derece
        : null
    );

    formVars.tarimsalsulamaonsurecler_564425_value = ReactSystemFunctions.value(
      this,
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].catiEgimi_Derece
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].catiEgimi_Derece
        : null
    );

    formVars.tarimsalsulamaonsurecler_347190_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
          ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
            ? stateVars.CATI_GES_ON_KESIF_GETIR[0].catiYonu
            : null
          : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? this.state.CATI_GES_ON_KESIF_GETIR[0].catiYonu
          : null
      );

    formVars.tarimsalsulamaonsurecler_248435_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
          ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
            ? stateVars.CATI_GES_ON_KESIF_GETIR[0].catiYonu
            : null
          : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? this.state.CATI_GES_ON_KESIF_GETIR[0].catiYonu
          : null
      );

    formVars.tarimsalsulamaonsurecler_527428_value = ReactSystemFunctions.value(
      this,
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].kullanilabilirAlan_m2
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].kullanilabilirAlan_m2
        : null
    );

    formVars.tarimsalsulamaonsurecler_363152_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
          ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
            ? stateVars.CATI_GES_ON_KESIF_GETIR[0].adaParselBilgisi
            : null
          : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? this.state.CATI_GES_ON_KESIF_GETIR[0].adaParselBilgisi
          : null
      );

    formVars.tarimsalsulamaonsurecler_54683_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
          ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
            ? stateVars.CATI_GES_ON_KESIF_GETIR[0].catiYonu
            : null
          : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? this.state.CATI_GES_ON_KESIF_GETIR[0].catiYonu
          : null
      );

    formVars.tarimsalsulamaonsurecler_726812_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
          ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
            ? stateVars.CATI_GES_ON_KESIF_GETIR[0].catiTasiyiciSistem
            : null
          : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? this.state.CATI_GES_ON_KESIF_GETIR[0].catiTasiyiciSistem
          : null
      );

    formVars.tarimsalsulamaonsurecler_320807_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
          ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
            ? stateVars.CATI_GES_ON_KESIF_GETIR[0].catiTasiyiciSistem
            : null
          : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? this.state.CATI_GES_ON_KESIF_GETIR[0].catiTasiyiciSistem
          : null
      );

    formVars.tarimsalsulamaonsurecler_530736_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
          ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
            ? stateVars.CATI_GES_ON_KESIF_GETIR[0].adaParselBilgisi
            : null
          : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? this.state.CATI_GES_ON_KESIF_GETIR[0].adaParselBilgisi
          : null
      );

    formVars.tarimsalsulamaonsurecler_716982_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
          ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
            ? stateVars.CATI_GES_ON_KESIF_GETIR[0].catiTasiyiciSistem
            : null
          : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? this.state.CATI_GES_ON_KESIF_GETIR[0].catiTasiyiciSistem
          : null
      );

    formVars.tarimsalsulamaonsurecler_39609_value = ReactSystemFunctions.value(
      this,
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].catiEgimi_Derece
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].catiEgimi_Derece
        : null
    );

    formVars.tarimsalsulamaonsurecler_468368_value = ReactSystemFunctions.value(
      this,
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].panoMesafesi_m
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].panoMesafesi_m
        : null
    );

    formVars.tarimsalsulamaonsurecler_732086_value = ReactSystemFunctions.value(
      this,
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].panoMesafesi_m
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].panoMesafesi_m
        : null
    );

    formVars.tarimsalsulamaonsurecler_407044_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
          ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
            ? stateVars.CATI_GES_ON_KESIF_GETIR[0].catiTasiyiciSistem
            : null
          : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? this.state.CATI_GES_ON_KESIF_GETIR[0].catiTasiyiciSistem
          : null
      );

    formVars.tarimsalsulamaonsurecler_39980_value = ReactSystemFunctions.value(
      this,
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].panoMesafesi_m
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].panoMesafesi_m
        : null
    );

    formVars.tarimsalsulamaonsurecler_232820_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
          ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
            ? stateVars.CATI_GES_ON_KESIF_GETIR[0].catiTasiyiciSistem
            : null
          : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? this.state.CATI_GES_ON_KESIF_GETIR[0].catiTasiyiciSistem
          : null
      );

    stateVars.dataSource_508933 =
      stateVars.KalemleriGetir ?? this.state.KalemleriGetir;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  TarimsalSulamaOnSureclerComponent_321509_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "tarimsalsulamaonsurecler_321509_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "Diğer"
      )
    ) {
      KuikaAppManager.showSpinner(this);

      stateVars.ChangeVisibilityOf =
        await ReactSystemFunctions.changeVisibilityOf(
          this,
          ReactSystemFunctions.convertToTypeByName(
            "isComp379455Visible",
            "string"
          ),
          ReactSystemFunctions.convertToTypeByName("visible", "string")
        );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.TarimsalSulamaOnSureclerComponent_321509_onChange1_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.TarimsalSulamaOnSureclerComponent_321509_onChange1_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  TarimsalSulamaOnSureclerComponent_321509_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp321509Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("hidden", "string")
      );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  TarimsalSulamaOnSureclerComponent_88381_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp379455Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("hidden", "string")
      );
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp321509Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("visible", "string")
      );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  TarimsalSulamaOnSureclerComponent_78287_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "tarimsalsulamaonsurecler_393036_value",
        "string"
      ),
      ReactSystemFunctions.value(
        this,
        "tarimsalsulamaonsurecler_478263_value",
        "stokKodu"
      ),
      null,
      "STOK_KODU"
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "tarimsalsulamaonsurecler_207266_value",
        "string"
      ),
      ReactSystemFunctions.value(
        this,
        "tarimsalsulamaonsurecler_478263_value",
        "miktar"
      ),
      null,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  TarimsalSulamaOnSureclerComponent_285034_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.KalemSil = CWTypeScript.KalemSil(
      ReactSystemFunctions.toString(
        this,
        stateVars.GetUserByUsername !== undefined
          ? stateVars.GetUserByUsername?.length > 0
            ? stateVars.GetUserByUsername[0].id
            : null
          : this.state.GetUserByUsername?.length > 0
          ? this.state.GetUserByUsername[0].id
          : null
      ),
      this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
      ReactSystemFunctions.convertToTypeByName("ON_KESIF", "string"),
      ReactSystemFunctions.value(
        this,
        "tarimsalsulamaonsurecler_478263_value",
        "stokKodu"
      )
    );
    stateVars.KalemleriGetir = CWTypeScript.KalemleriGetir(
      ReactSystemFunctions.toString(
        this,
        stateVars.GetUserByUsername !== undefined
          ? stateVars.GetUserByUsername?.length > 0
            ? stateVars.GetUserByUsername[0].id
            : null
          : this.state.GetUserByUsername?.length > 0
          ? this.state.GetUserByUsername[0].id
          : null
      ),
      this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
      ReactSystemFunctions.convertToTypeByName("ON_KESIF", "string")
    );

    formVars.tarimsalsulamaonsurecler_742412_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.KalemleriGetir !== undefined
          ? stateVars.KalemleriGetir?.length > 0
            ? stateVars.KalemleriGetir[0].genelToplam
            : null
          : this.state.KalemleriGetir?.length > 0
          ? this.state.KalemleriGetir[0].genelToplam
          : null
      );
    formVars.tarimsalsulamaonsurecler_505390_value = ReactSystemFunctions.value(
      this,
      stateVars.PROFORMA_GENEL_BILGILERI_GETIR !== undefined
        ? stateVars.PROFORMA_GENEL_BILGILERI_GETIR?.length > 0
          ? stateVars.PROFORMA_GENEL_BILGILERI_GETIR[0].proforma_Tutar
          : null
        : this.state.PROFORMA_GENEL_BILGILERI_GETIR?.length > 0
        ? this.state.PROFORMA_GENEL_BILGILERI_GETIR[0].proforma_Tutar
        : null
    );
    formVars.tarimsalsulamaonsurecler_505390_placeholder =
      ReactSystemFunctions.toString(
        this,
        stateVars.KalemleriGetir !== undefined
          ? stateVars.KalemleriGetir?.length > 0
            ? stateVars.KalemleriGetir[0].genelToplam
            : null
          : this.state.KalemleriGetir?.length > 0
          ? this.state.KalemleriGetir[0].genelToplam
          : null
      );
    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "4b1e2c66_37b7_c891_1819_cb2547759127_notify",
        this.defaultML,
        "Kalem Başarıyla Silindi !"
      ),
      ReactSystemFunctions.convertToTypeByName("default", "string"),
      ReactSystemFunctions.convertToTypeByName("center", "string"),
      4,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    stateVars.dataSource_478263 =
      stateVars.KalemleriGetir ?? this.state.KalemleriGetir;
    formVars.tarimsalsulamaonsurecler_742412_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.KalemleriGetir !== undefined
          ? stateVars.KalemleriGetir?.length > 0
            ? stateVars.KalemleriGetir[0].genelToplam
            : null
          : this.state.KalemleriGetir?.length > 0
          ? this.state.KalemleriGetir[0].genelToplam
          : null
      );

    formVars.tarimsalsulamaonsurecler_505390_placeholder =
      ReactSystemFunctions.toString(
        this,
        stateVars.KalemleriGetir !== undefined
          ? stateVars.KalemleriGetir?.length > 0
            ? stateVars.KalemleriGetir[0].genelToplam
            : null
          : this.state.KalemleriGetir?.length > 0
          ? this.state.KalemleriGetir[0].genelToplam
          : null
      );

    stateVars.dataSource_508933 =
      stateVars.KalemleriGetir ?? this.state.KalemleriGetir;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  TarimsalSulamaOnSureclerComponent_393036_onSearch = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      DbName_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.AktifSirketGetir !== undefined
            ? stateVars.AktifSirketGetir?.length > 0
              ? stateVars.AktifSirketGetir[0].sirket
              : null
            : this.state.AktifSirketGetir?.length > 0
            ? this.state.AktifSirketGetir[0].sirket
            : null
        ),
        "string"
      ),
      Ara_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "tarimsalsulamaonsurecler_393036_value",
            "",
            "GET_NETSIS_STOK_LISTESI",
            "stoK_KODU",
            "k_searchValue"
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "TarimsalSulamaOnSurecler/TarimsalSulamaOnSureclerComponent_393036_onSearch",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GET_NETSIS_STOK_LISTESI = result?.data.geT_NETSIS_STOK_LISTESI;

    formVars.tarimsalsulamaonsurecler_393036_options =
      stateVars.GET_NETSIS_STOK_LISTESI;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.TarimsalSulamaOnSureclerComponent_393036_onSearch1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  TarimsalSulamaOnSureclerComponent_393036_onSearch1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_393036 =
      stateVars.GET_NETSIS_STOK_LISTESI ?? this.state.GET_NETSIS_STOK_LISTESI;
    stateVars.dataSource_393036 =
      stateVars.GET_NETSIS_STOK_LISTESI ?? this.state.GET_NETSIS_STOK_LISTESI;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  TarimsalSulamaOnSureclerComponent_393036_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "tarimsalsulamaonsurecler_353063_value",
        "string"
      ),
      ReactSystemFunctions.value(
        this,
        ReactSystemFunctions.value(
          this,
          "tarimsalsulamaonsurecler_393036_value",
          "value",
          "GET_NETSIS_STOK_LISTESI",
          "stoK_KODU",
          "satiS_FIAT1"
        )
      ),
      null,
      false
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "tarimsalsulamaonsurecler_207266_value",
        "string"
      ),
      1,
      null,
      false
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "tarimsalsulamaonsurecler_480487_value",
        "string"
      ),
      ReactSystemFunctions.toString(
        this,
        ReactSystemFunctions.value(
          this,
          "tarimsalsulamaonsurecler_393036_value",
          "value",
          "GET_NETSIS_STOK_LISTESI",
          "stoK_KODU",
          "olcU_BR1"
        )
      ),
      null,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  TarimsalSulamaOnSureclerComponent_207266_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.Multiply = await ReactSystemFunctions.multiply(
      ReactSystemFunctions.value(
        this,
        ReactSystemFunctions.value(
          this,
          "tarimsalsulamaonsurecler_353063_value",
          "value",
          "",
          "",
          ""
        )
      ),
      ReactSystemFunctions.value(
        this,
        ReactSystemFunctions.value(
          this,
          "tarimsalsulamaonsurecler_207266_value",
          "value",
          "",
          "",
          ""
        )
      )
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "tarimsalsulamaonsurecler_570640_value",
        "string"
      ),
      ReactSystemFunctions.value(this, stateVars.Multiply),
      null,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  TarimsalSulamaOnSureclerComponent_740127_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "tarimsalsulamaonsurecler_393036_value",
          "value",
          "GET_NETSIS_STOK_LISTESI",
          "stoK_KODU",
          ""
        ),
        null
      ),
      message: "Bu alanın doldurulması zorunludur.",
      formName: "tarimsalsulamaonsurecler_393036_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "tarimsalsulamaonsurecler_207266_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "Bu alanın doldurulması zorunludur.",
      formName: "tarimsalsulamaonsurecler_207266_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.KalemEkle = CWTypeScript.KalemEkle(
      ReactSystemFunctions.toString(
        this,
        stateVars.GetUserByUsername !== undefined
          ? stateVars.GetUserByUsername?.length > 0
            ? stateVars.GetUserByUsername[0].id
            : null
          : this.state.GetUserByUsername?.length > 0
          ? this.state.GetUserByUsername[0].id
          : null
      ),
      this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
      ReactSystemFunctions.convertToTypeByName("ON_KESIF", "string"),
      ReactSystemFunctions.toString(
        this,
        ReactSystemFunctions.value(
          this,
          "tarimsalsulamaonsurecler_393036_value",
          "value",
          "GET_NETSIS_STOK_LISTESI",
          "stoK_KODU",
          "stoK_KODU"
        )
      ),
      ReactSystemFunctions.toString(
        this,
        ReactSystemFunctions.value(
          this,
          "tarimsalsulamaonsurecler_393036_value",
          "value",
          "GET_NETSIS_STOK_LISTESI",
          "stoK_KODU",
          "stoK_ADI"
        )
      ),
      ReactSystemFunctions.value(
        this,
        ReactSystemFunctions.value(
          this,
          "tarimsalsulamaonsurecler_480487_value",
          "value",
          "",
          "",
          ""
        )
      ),
      ReactSystemFunctions.value(
        this,
        ReactSystemFunctions.value(
          this,
          "tarimsalsulamaonsurecler_353063_value",
          "value",
          "",
          "",
          ""
        )
      ),
      ReactSystemFunctions.value(
        this,
        ReactSystemFunctions.value(
          this,
          "tarimsalsulamaonsurecler_207266_value",
          "value",
          "",
          "",
          ""
        )
      )
    );
    stateVars.KalemleriGetir = CWTypeScript.KalemleriGetir(
      ReactSystemFunctions.toString(
        this,
        stateVars.GetUserByUsername !== undefined
          ? stateVars.GetUserByUsername?.length > 0
            ? stateVars.GetUserByUsername[0].id
            : null
          : this.state.GetUserByUsername?.length > 0
          ? this.state.GetUserByUsername[0].id
          : null
      ),
      this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
      ReactSystemFunctions.convertToTypeByName("ON_KESIF", "string")
    );

    formVars.tarimsalsulamaonsurecler_742412_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.KalemleriGetir !== undefined
          ? stateVars.KalemleriGetir?.length > 0
            ? stateVars.KalemleriGetir[0].genelToplam
            : null
          : this.state.KalemleriGetir?.length > 0
          ? this.state.KalemleriGetir[0].genelToplam
          : null
      );
    formVars.tarimsalsulamaonsurecler_505390_value = ReactSystemFunctions.value(
      this,
      stateVars.PROFORMA_GENEL_BILGILERI_GETIR !== undefined
        ? stateVars.PROFORMA_GENEL_BILGILERI_GETIR?.length > 0
          ? stateVars.PROFORMA_GENEL_BILGILERI_GETIR[0].proforma_Tutar
          : null
        : this.state.PROFORMA_GENEL_BILGILERI_GETIR?.length > 0
        ? this.state.PROFORMA_GENEL_BILGILERI_GETIR[0].proforma_Tutar
        : null
    );
    formVars.tarimsalsulamaonsurecler_505390_placeholder =
      ReactSystemFunctions.toString(
        this,
        stateVars.KalemleriGetir !== undefined
          ? stateVars.KalemleriGetir?.length > 0
            ? stateVars.KalemleriGetir[0].genelToplam
            : null
          : this.state.KalemleriGetir?.length > 0
          ? this.state.KalemleriGetir[0].genelToplam
          : null
      );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "tarimsalsulamaonsurecler_393036_value",
        "string"
      ),
      null,
      null,
      "STOK_KODU"
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "tarimsalsulamaonsurecler_353063_value",
        "string"
      ),
      null,
      null,
      false
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "tarimsalsulamaonsurecler_570640_value",
        "string"
      ),
      null,
      null,
      false
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "tarimsalsulamaonsurecler_207266_value",
        "string"
      ),
      null,
      null,
      false
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "tarimsalsulamaonsurecler_480487_value",
        "string"
      ),
      null,
      null,
      false
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.TarimsalSulamaOnSureclerComponent_740127_onClick1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  TarimsalSulamaOnSureclerComponent_740127_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.KalemleriGetir !== undefined
            ? stateVars.KalemleriGetir?.length > 0
              ? stateVars.KalemleriGetir[0].sonuc
              : null
            : this.state.KalemleriGetir?.length > 0
            ? this.state.KalemleriGetir[0].sonuc
            : null
        ),
        "KALEM MEVCUT"
      )
    ) {
      stateVars.Notify = await ReactSystemFunctions.notify(
        this,
        ReactSystemFunctions.translateCustomActions(
          this.ml,
          "28390ac9_7ba2_881f_ca06_d404be3e56e4_notify",
          this.defaultML,
          "Seçtiğiniz ürün listede zaten mevcuttur."
        ),
        ReactSystemFunctions.convertToTypeByName("info", "string"),
        ReactSystemFunctions.convertToTypeByName("center", "string"),
        4,
        ReactSystemFunctions.convertToTypeByName("", "string"),
        ReactSystemFunctions.convertToTypeByName("", "string"),
        0
      );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.TarimsalSulamaOnSureclerComponent_740127_onClick2_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.TarimsalSulamaOnSureclerComponent_740127_onClick2_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  TarimsalSulamaOnSureclerComponent_740127_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_478263 =
      stateVars.KalemleriGetir ?? this.state.KalemleriGetir;
    formVars.tarimsalsulamaonsurecler_742412_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.KalemleriGetir !== undefined
          ? stateVars.KalemleriGetir?.length > 0
            ? stateVars.KalemleriGetir[0].genelToplam
            : null
          : this.state.KalemleriGetir?.length > 0
          ? this.state.KalemleriGetir[0].genelToplam
          : null
      );

    formVars.tarimsalsulamaonsurecler_505390_placeholder =
      ReactSystemFunctions.toString(
        this,
        stateVars.KalemleriGetir !== undefined
          ? stateVars.KalemleriGetir?.length > 0
            ? stateVars.KalemleriGetir[0].genelToplam
            : null
          : this.state.KalemleriGetir?.length > 0
          ? this.state.KalemleriGetir[0].genelToplam
          : null
      );

    stateVars.dataSource_508933 =
      stateVars.KalemleriGetir ?? this.state.KalemleriGetir;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  TarimsalSulamaOnSureclerComponent_261776_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.UploadFile = (
      (await ReactSystemFunctions.uploadFilesWithInfo(
        ReactSystemFunctions.convertToTypeByName("", "string")
      )) as any
    ).data;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.TarimsalSulamaOnSureclerComponent_261776_onClick1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  TarimsalSulamaOnSureclerComponent_261776_onClick_foreach1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.DosyaEkle = CWTypeScript.DosyaEkle(
      ReactSystemFunctions.toString(
        this,
        stateVars.GetUserByUsername !== undefined
          ? stateVars.GetUserByUsername?.length > 0
            ? stateVars.GetUserByUsername[0].id
            : null
          : this.state.GetUserByUsername?.length > 0
          ? this.state.GetUserByUsername[0].id
          : null
      ),
      this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
      ReactSystemFunctions.convertToTypeByName("ON_KESIF", "string"),
      ReactSystemFunctions.value(this, this.ForEach1?.name),
      ReactSystemFunctions.value(this, this.ForEach1?.data),
      ReactSystemFunctions.value(this, this.ForEach1?.type),
      ReactSystemFunctions.value(this, this.ForEach1?.size)
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  TarimsalSulamaOnSureclerComponent_261776_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    if (ReactSystemFunctions.value(this, this.state.UploadFile)?.length) {
      for (let item of ReactSystemFunctions.value(
        this,
        this.state.UploadFile
      )) {
        this.ForEach1 = item;
        await this.TarimsalSulamaOnSureclerComponent_261776_onClick_foreach1();
      }
    }

    stateVars.DosyalariGetir = CWTypeScript.DosyalariGetir(
      ReactSystemFunctions.toString(
        this,
        stateVars.GetUserByUsername !== undefined
          ? stateVars.GetUserByUsername?.length > 0
            ? stateVars.GetUserByUsername[0].id
            : null
          : this.state.GetUserByUsername?.length > 0
          ? this.state.GetUserByUsername[0].id
          : null
      ),
      this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
      ReactSystemFunctions.convertToTypeByName("ON_KESIF", "string")
    );

    stateVars.dataSource_801362 =
      stateVars.DosyalariGetir ?? this.state.DosyalariGetir;

    stateVars.dataSource_266261 =
      stateVars.DosyalariGetir ?? this.state.DosyalariGetir;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  TarimsalSulamaOnSureclerComponent_218119_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.DownloadFile = await ReactSystemFunctions.downloadFile(
      ReactSystemFunctions.value(
        this,
        "tarimsalsulamaonsurecler_801362_value",
        "base64Icerik"
      ),
      ReactSystemFunctions.value(
        this,
        "tarimsalsulamaonsurecler_801362_value",
        "dosyaAdi"
      )
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  TarimsalSulamaOnSureclerComponent_885016_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.DosyaSil = CWTypeScript.DosyaSil(
      ReactSystemFunctions.toString(
        this,
        stateVars.GetUserByUsername !== undefined
          ? stateVars.GetUserByUsername?.length > 0
            ? stateVars.GetUserByUsername[0].id
            : null
          : this.state.GetUserByUsername?.length > 0
          ? this.state.GetUserByUsername[0].id
          : null
      ),
      this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
      ReactSystemFunctions.convertToTypeByName("ON_KESIF", "string"),
      ReactSystemFunctions.value(
        this,
        "tarimsalsulamaonsurecler_801362_value",
        "dosyaAdi"
      )
    );
    stateVars.DosyalariGetir = CWTypeScript.DosyalariGetir(
      ReactSystemFunctions.toString(
        this,
        stateVars.GetUserByUsername !== undefined
          ? stateVars.GetUserByUsername?.length > 0
            ? stateVars.GetUserByUsername[0].id
            : null
          : this.state.GetUserByUsername?.length > 0
          ? this.state.GetUserByUsername[0].id
          : null
      ),
      this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
      ReactSystemFunctions.convertToTypeByName("ON_KESIF", "string")
    );

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "6e1d75f9_0024_60ed_5f1f_5011eeeae21a_notify",
        this.defaultML,
        "Dosya Başarıyla Silindi !"
      ),
      ReactSystemFunctions.convertToTypeByName("default", "string"),
      ReactSystemFunctions.convertToTypeByName("center", "string"),
      4,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    stateVars.dataSource_801362 =
      stateVars.DosyalariGetir ?? this.state.DosyalariGetir;

    stateVars.dataSource_266261 =
      stateVars.DosyalariGetir ?? this.state.DosyalariGetir;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  TarimsalSulamaOnSureclerComponent_970414_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.KaydetHazirla = CWTypeScript.KaydetHazirla(
      ReactSystemFunctions.toString(
        this,
        stateVars.GetUserByUsername !== undefined
          ? stateVars.GetUserByUsername?.length > 0
            ? stateVars.GetUserByUsername[0].id
            : null
          : this.state.GetUserByUsername?.length > 0
          ? this.state.GetUserByUsername[0].id
          : null
      ),
      this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
      ReactSystemFunctions.convertToTypeByName("ON_KESIF", "string")
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.TarimsalSulamaOnSureclerComponent_970414_onClick1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  TarimsalSulamaOnSureclerComponent_970414_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      ProjeId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
        "number"
      ),
      KullaniciId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetUserByUsername !== undefined
            ? stateVars.GetUserByUsername?.length > 0
              ? stateVars.GetUserByUsername[0].id
              : null
            : this.state.GetUserByUsername?.length > 0
            ? this.state.GetUserByUsername[0].id
            : null
        ),
        "string"
      ),
      IslemTipi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("ON_KESIF", "string"),
        "string"
      ),
      Konum_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "tarimsalsulamaonsurecler_558557_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      IletisimBilgisi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("1", "string"),
        "string"
      ),
      KuyuToplamDerinligi_m_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "tarimsalsulamaonsurecler_14467_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      StatikSeviye_m_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "tarimsalsulamaonsurecler_766200_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      DinamikSeviye_m_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "tarimsalsulamaonsurecler_145387_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      KuyuVerimi_m3saat_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "tarimsalsulamaonsurecler_743336_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      SuKaynagiTipi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "tarimsalsulamaonsurecler_707377_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "string"
      ),
      PompaTipi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "tarimsalsulamaonsurecler_166467_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "string"
      ),
      MotorGucu_HP_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "tarimsalsulamaonsurecler_724523_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      MotorGucu_kW_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "tarimsalsulamaonsurecler_867312_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      CalismaGerilimi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "tarimsalsulamaonsurecler_380385_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "string"
      ),
      NominalAkim_A_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "tarimsalsulamaonsurecler_886075_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      PompaMarka_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "tarimsalsulamaonsurecler_186956_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      MevcutSurucu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "tarimsalsulamaonsurecler_628425_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "string"
      ),
      KurulumAlani_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "tarimsalsulamaonsurecler_681014_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "string"
      ),
      ZeminYapisi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "tarimsalsulamaonsurecler_310926_value",
            "mask",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      GolgelemeDurumu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "tarimsalsulamaonsurecler_174079_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "string"
      ),
      KullanilabilirAlan_m2_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "tarimsalsulamaonsurecler_107465_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      InverterPanelMesafe_m_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "tarimsalsulamaonsurecler_542990_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      InverterPanoMesafe_m_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "tarimsalsulamaonsurecler_195553_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      SistemModeli_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "tarimsalsulamaonsurecler_118876_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "string"
      ),
      TrafoBilgisi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "tarimsalsulamaonsurecler_80062_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      KabloYoluDurumu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "tarimsalsulamaonsurecler_900878_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "string"
      ),
      GunlukSuIhtiyaci_m3_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "tarimsalsulamaonsurecler_928420_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      SulamaDonemi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "tarimsalsulamaonsurecler_753684_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "string"
      ),
      SulamaYontemi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "tarimsalsulamaonsurecler_648547_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "string"
      ),
      SahaUlasimi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "tarimsalsulamaonsurecler_546366_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "string"
      ),
      GuvenlikDurumu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "tarimsalsulamaonsurecler_124355_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "string"
      ),
      TopraklamaAlani_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "tarimsalsulamaonsurecler_994578_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "string"
      ),
      TahminiGuc_kWp_0: ReactSystemFunctions.convertToTypeByName(150, "number"),
      Aciklama1_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "tarimsalsulamaonsurecler_225026_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      Aciklama2_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "tarimsalsulamaonsurecler_26200_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      Aciklama3_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "tarimsalsulamaonsurecler_122352_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      KalemlerJson_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, this.state.KaydetHazirla),
        "string"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "TarimsalSulamaOnSurecler/TarimsalSulamaOnSureclerComponent_970414_onClick1_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.ON_SUREC_TARIMSAL_SULAMA_KAYDET =
      result?.data.oN_SUREC_TARIMSAL_SULAMA_KAYDET;
    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };

  TarimsalSulamaOnSureclerComponent_832682_onActive = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      ProjeId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
        "number"
      ),
      TipKodu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("ON_KESIF", "string"),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "TarimsalSulamaOnSurecler/TarimsalSulamaOnSureclerComponent_832682_onActive",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.ON_KESIF_KALEMLER_GETIR = result?.data.oN_KESIF_KALEMLER_GETIR;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.TarimsalSulamaOnSureclerComponent_832682_onActive1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  TarimsalSulamaOnSureclerComponent_832682_onActive1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.KalemleriDBdenYukle = CWTypeScript.KalemleriDBdenYukle(
      ReactSystemFunctions.toString(
        this,
        stateVars.GetUserByUsername !== undefined
          ? stateVars.GetUserByUsername?.length > 0
            ? stateVars.GetUserByUsername[0].id
            : null
          : this.state.GetUserByUsername?.length > 0
          ? this.state.GetUserByUsername[0].id
          : null
      ),
      this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
      ReactSystemFunctions.convertToTypeByName("ON_KESIF", "string"),
      ReactSystemFunctions.value(this, this.state.ON_KESIF_KALEMLER_GETIR)
    );
    stateVars.KalemleriGetir = CWTypeScript.KalemleriGetir(
      ReactSystemFunctions.toString(
        this,
        stateVars.GetUserByUsername !== undefined
          ? stateVars.GetUserByUsername?.length > 0
            ? stateVars.GetUserByUsername[0].id
            : null
          : this.state.GetUserByUsername?.length > 0
          ? this.state.GetUserByUsername[0].id
          : null
      ),
      this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
      ReactSystemFunctions.convertToTypeByName("ON_KESIF", "string")
    );

    formVars.tarimsalsulamaonsurecler_742412_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.KalemleriGetir !== undefined
          ? stateVars.KalemleriGetir?.length > 0
            ? stateVars.KalemleriGetir[0].genelToplam
            : null
          : this.state.KalemleriGetir?.length > 0
          ? this.state.KalemleriGetir[0].genelToplam
          : null
      );
    formVars.tarimsalsulamaonsurecler_505390_value = ReactSystemFunctions.value(
      this,
      stateVars.PROFORMA_GENEL_BILGILERI_GETIR !== undefined
        ? stateVars.PROFORMA_GENEL_BILGILERI_GETIR?.length > 0
          ? stateVars.PROFORMA_GENEL_BILGILERI_GETIR[0].proforma_Tutar
          : null
        : this.state.PROFORMA_GENEL_BILGILERI_GETIR?.length > 0
        ? this.state.PROFORMA_GENEL_BILGILERI_GETIR[0].proforma_Tutar
        : null
    );
    formVars.tarimsalsulamaonsurecler_505390_placeholder =
      ReactSystemFunctions.toString(
        this,
        stateVars.KalemleriGetir !== undefined
          ? stateVars.KalemleriGetir?.length > 0
            ? stateVars.KalemleriGetir[0].genelToplam
            : null
          : this.state.KalemleriGetir?.length > 0
          ? this.state.KalemleriGetir[0].genelToplam
          : null
      );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.TarimsalSulamaOnSureclerComponent_832682_onActive2_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  TarimsalSulamaOnSureclerComponent_832682_onActive2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      ProjeId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
        "number"
      ),
      IslemTipi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("PROFORMA", "string"),
        "string"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "TarimsalSulamaOnSurecler/TarimsalSulamaOnSureclerComponent_832682_onActive2_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.PROJE_DOSYLARI_GETIR = result?.data.projE_DOSYLARI_GETIR;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.TarimsalSulamaOnSureclerComponent_832682_onActive3_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  TarimsalSulamaOnSureclerComponent_832682_onActive3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.DosyalariDBdenYukle = CWTypeScript.DosyalariDBdenYukle(
      ReactSystemFunctions.toString(
        this,
        stateVars.GetUserByUsername !== undefined
          ? stateVars.GetUserByUsername?.length > 0
            ? stateVars.GetUserByUsername[0].id
            : null
          : this.state.GetUserByUsername?.length > 0
          ? this.state.GetUserByUsername[0].id
          : null
      ),
      this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
      ReactSystemFunctions.convertToTypeByName("PROFORMA", "string"),
      ReactSystemFunctions.value(this, this.state.PROJE_DOSYLARI_GETIR)
    );
    stateVars.DosyalariGetir = CWTypeScript.DosyalariGetir(
      ReactSystemFunctions.toString(
        this,
        stateVars.GetUserByUsername !== undefined
          ? stateVars.GetUserByUsername?.length > 0
            ? stateVars.GetUserByUsername[0].id
            : null
          : this.state.GetUserByUsername?.length > 0
          ? this.state.GetUserByUsername[0].id
          : null
      ),
      this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
      ReactSystemFunctions.convertToTypeByName("PROFORMA", "string")
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.TarimsalSulamaOnSureclerComponent_832682_onActive4_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  TarimsalSulamaOnSureclerComponent_832682_onActive4_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      ProjeId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
        "number"
      ),
      DbName_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.AktifSirketGetir !== undefined
            ? stateVars.AktifSirketGetir?.length > 0
              ? stateVars.AktifSirketGetir[0].sirket
              : null
            : this.state.AktifSirketGetir?.length > 0
            ? this.state.AktifSirketGetir[0].sirket
            : null
        ),
        "string"
      ),
      ProjeKodu_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netsisProjKodu
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].netsisProjKodu
            : null
        ),
        "string"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "TarimsalSulamaOnSurecler/TarimsalSulamaOnSureclerComponent_832682_onActive4_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.PROFORMA_GENEL_BILGILERI_GETIR =
      result?.data.proformA_GENEL_BILGILERI_GETIR;
    formVars.tarimsalsulamaonsurecler_505390_value = ReactSystemFunctions.value(
      this,
      stateVars.PROFORMA_GENEL_BILGILERI_GETIR !== undefined
        ? stateVars.PROFORMA_GENEL_BILGILERI_GETIR?.length > 0
          ? stateVars.PROFORMA_GENEL_BILGILERI_GETIR[0].proforma_Tutar
          : null
        : this.state.PROFORMA_GENEL_BILGILERI_GETIR?.length > 0
        ? this.state.PROFORMA_GENEL_BILGILERI_GETIR[0].proforma_Tutar
        : null
    );
    formVars.tarimsalsulamaonsurecler_505390_placeholder =
      ReactSystemFunctions.toString(
        this,
        stateVars.KalemleriGetir !== undefined
          ? stateVars.KalemleriGetir?.length > 0
            ? stateVars.KalemleriGetir[0].genelToplam
            : null
          : this.state.KalemleriGetir?.length > 0
          ? this.state.KalemleriGetir[0].genelToplam
          : null
      );
    formVars.tarimsalsulamaonsurecler_169821_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.PROFORMA_GENEL_BILGILERI_GETIR !== undefined
          ? stateVars.PROFORMA_GENEL_BILGILERI_GETIR?.length > 0
            ? stateVars.PROFORMA_GENEL_BILGILERI_GETIR[0].proforma_Notu
            : null
          : this.state.PROFORMA_GENEL_BILGILERI_GETIR?.length > 0
          ? this.state.PROFORMA_GENEL_BILGILERI_GETIR[0].proforma_Notu
          : null
      );
    stateVars.PROFORMA_KALEMLERI_GETIR = result?.data.proformA_KALEMLERI_GETIR;

    formVars.tarimsalsulamaonsurecler_189730_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.PROFORMA_KALEMLERI_GETIR !== undefined
          ? stateVars.PROFORMA_KALEMLERI_GETIR?.length > 0
            ? stateVars.PROFORMA_KALEMLERI_GETIR[0].geneltoplam
            : null
          : this.state.PROFORMA_KALEMLERI_GETIR?.length > 0
          ? this.state.PROFORMA_KALEMLERI_GETIR[0].geneltoplam
          : null
      );
    formVars.tarimsalsulamaonsurecler_328239_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.PROFORMA_KALEMLERI_GETIR !== undefined
          ? stateVars.PROFORMA_KALEMLERI_GETIR?.length > 0
            ? stateVars.PROFORMA_KALEMLERI_GETIR[0].geneltoplam
            : null
          : this.state.PROFORMA_KALEMLERI_GETIR?.length > 0
          ? this.state.PROFORMA_KALEMLERI_GETIR[0].geneltoplam
          : null
      );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.TarimsalSulamaOnSureclerComponent_832682_onActive5_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  TarimsalSulamaOnSureclerComponent_832682_onActive5_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_478263 =
      stateVars.KalemleriGetir ?? this.state.KalemleriGetir;

    stateVars.dataSource_801362 =
      stateVars.DosyalariGetir ?? this.state.DosyalariGetir;
    formVars.tarimsalsulamaonsurecler_742412_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.KalemleriGetir !== undefined
          ? stateVars.KalemleriGetir?.length > 0
            ? stateVars.KalemleriGetir[0].genelToplam
            : null
          : this.state.KalemleriGetir?.length > 0
          ? this.state.KalemleriGetir[0].genelToplam
          : null
      );

    stateVars.dataSource_200053 =
      stateVars.PROFORMA_KALEMLERI_GETIR ?? this.state.PROFORMA_KALEMLERI_GETIR;
    formVars.tarimsalsulamaonsurecler_189730_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.PROFORMA_KALEMLERI_GETIR !== undefined
          ? stateVars.PROFORMA_KALEMLERI_GETIR?.length > 0
            ? stateVars.PROFORMA_KALEMLERI_GETIR[0].geneltoplam
            : null
          : this.state.PROFORMA_KALEMLERI_GETIR?.length > 0
          ? this.state.PROFORMA_KALEMLERI_GETIR[0].geneltoplam
          : null
      );

    stateVars.dataSource_266261 =
      stateVars.DosyalariGetir ?? this.state.DosyalariGetir;
    formVars.tarimsalsulamaonsurecler_505390_value = ReactSystemFunctions.value(
      this,
      stateVars.PROFORMA_GENEL_BILGILERI_GETIR !== undefined
        ? stateVars.PROFORMA_GENEL_BILGILERI_GETIR?.length > 0
          ? stateVars.PROFORMA_GENEL_BILGILERI_GETIR[0].proforma_Tutar
          : null
        : this.state.PROFORMA_GENEL_BILGILERI_GETIR?.length > 0
        ? this.state.PROFORMA_GENEL_BILGILERI_GETIR[0].proforma_Tutar
        : null
    );

    formVars.tarimsalsulamaonsurecler_505390_placeholder =
      ReactSystemFunctions.toString(
        this,
        stateVars.KalemleriGetir !== undefined
          ? stateVars.KalemleriGetir?.length > 0
            ? stateVars.KalemleriGetir[0].genelToplam
            : null
          : this.state.KalemleriGetir?.length > 0
          ? this.state.KalemleriGetir[0].genelToplam
          : null
      );

    formVars.tarimsalsulamaonsurecler_169821_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.PROFORMA_GENEL_BILGILERI_GETIR !== undefined
          ? stateVars.PROFORMA_GENEL_BILGILERI_GETIR?.length > 0
            ? stateVars.PROFORMA_GENEL_BILGILERI_GETIR[0].proforma_Notu
            : null
          : this.state.PROFORMA_GENEL_BILGILERI_GETIR?.length > 0
          ? this.state.PROFORMA_GENEL_BILGILERI_GETIR[0].proforma_Notu
          : null
      );

    stateVars.dataSource_822795 =
      stateVars.PROFORMA_KALEMLERI_GETIR ?? this.state.PROFORMA_KALEMLERI_GETIR;
    formVars.tarimsalsulamaonsurecler_328239_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.PROFORMA_KALEMLERI_GETIR !== undefined
          ? stateVars.PROFORMA_KALEMLERI_GETIR?.length > 0
            ? stateVars.PROFORMA_KALEMLERI_GETIR[0].geneltoplam
            : null
          : this.state.PROFORMA_KALEMLERI_GETIR?.length > 0
          ? this.state.PROFORMA_KALEMLERI_GETIR[0].geneltoplam
          : null
      );

    stateVars.dataSource_508933 =
      stateVars.KalemleriGetir ?? this.state.KalemleriGetir;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  TarimsalSulamaOnSureclerComponent_410008_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.UploadFile = (
      (await ReactSystemFunctions.uploadFilesWithInfo(
        ReactSystemFunctions.convertToTypeByName("", "string")
      )) as any
    ).data;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.TarimsalSulamaOnSureclerComponent_410008_onClick1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  TarimsalSulamaOnSureclerComponent_410008_onClick_foreach1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.DosyaEkle = CWTypeScript.DosyaEkle(
      ReactSystemFunctions.toString(
        this,
        stateVars.GetUserByUsername !== undefined
          ? stateVars.GetUserByUsername?.length > 0
            ? stateVars.GetUserByUsername[0].id
            : null
          : this.state.GetUserByUsername?.length > 0
          ? this.state.GetUserByUsername[0].id
          : null
      ),
      this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
      ReactSystemFunctions.convertToTypeByName("PROFORMA", "string"),
      ReactSystemFunctions.value(this, this.ForEach2?.name),
      ReactSystemFunctions.value(this, this.ForEach2?.data),
      ReactSystemFunctions.value(this, this.ForEach2?.type),
      ReactSystemFunctions.value(this, this.ForEach2?.size)
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  TarimsalSulamaOnSureclerComponent_410008_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    if (ReactSystemFunctions.value(this, this.state.UploadFile)?.length) {
      for (let item of ReactSystemFunctions.value(
        this,
        this.state.UploadFile
      )) {
        this.ForEach2 = item;
        await this.TarimsalSulamaOnSureclerComponent_410008_onClick_foreach1();
      }
    }

    stateVars.DosyalariGetir = CWTypeScript.DosyalariGetir(
      ReactSystemFunctions.toString(
        this,
        stateVars.GetUserByUsername !== undefined
          ? stateVars.GetUserByUsername?.length > 0
            ? stateVars.GetUserByUsername[0].id
            : null
          : this.state.GetUserByUsername?.length > 0
          ? this.state.GetUserByUsername[0].id
          : null
      ),
      this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
      ReactSystemFunctions.convertToTypeByName("PROFORMA", "string")
    );

    stateVars.dataSource_801362 =
      stateVars.DosyalariGetir ?? this.state.DosyalariGetir;

    stateVars.dataSource_266261 =
      stateVars.DosyalariGetir ?? this.state.DosyalariGetir;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  TarimsalSulamaOnSureclerComponent_931911_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.DownloadFile = await ReactSystemFunctions.downloadFile(
      ReactSystemFunctions.value(
        this,
        "tarimsalsulamaonsurecler_266261_value",
        "base64Icerik"
      ),
      ReactSystemFunctions.value(
        this,
        "tarimsalsulamaonsurecler_266261_value",
        "dosyaAdi"
      )
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  TarimsalSulamaOnSureclerComponent_117547_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.DosyaSil = CWTypeScript.DosyaSil(
      ReactSystemFunctions.toString(
        this,
        stateVars.GetUserByUsername !== undefined
          ? stateVars.GetUserByUsername?.length > 0
            ? stateVars.GetUserByUsername[0].id
            : null
          : this.state.GetUserByUsername?.length > 0
          ? this.state.GetUserByUsername[0].id
          : null
      ),
      this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
      ReactSystemFunctions.convertToTypeByName("PROFORMA", "string"),
      ReactSystemFunctions.value(
        this,
        "tarimsalsulamaonsurecler_266261_value",
        "dosyaAdi"
      )
    );
    stateVars.DosyalariGetir = CWTypeScript.DosyalariGetir(
      ReactSystemFunctions.toString(
        this,
        stateVars.GetUserByUsername !== undefined
          ? stateVars.GetUserByUsername?.length > 0
            ? stateVars.GetUserByUsername[0].id
            : null
          : this.state.GetUserByUsername?.length > 0
          ? this.state.GetUserByUsername[0].id
          : null
      ),
      this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
      ReactSystemFunctions.convertToTypeByName("PROFORMA", "string")
    );

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "da838d57_3134_477a_e13c_d692eaef2802_notify",
        this.defaultML,
        "Dosya Başarıyla Silindi !"
      ),
      ReactSystemFunctions.convertToTypeByName("default", "string"),
      ReactSystemFunctions.convertToTypeByName("center", "string"),
      4,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    stateVars.dataSource_801362 =
      stateVars.DosyalariGetir ?? this.state.DosyalariGetir;

    stateVars.dataSource_266261 =
      stateVars.DosyalariGetir ?? this.state.DosyalariGetir;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  TarimsalSulamaOnSureclerComponent_641491_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.DosyalariKaydetHazirla = CWTypeScript.DosyalariKaydetHazirla(
      ReactSystemFunctions.toString(
        this,
        stateVars.GetUserByUsername !== undefined
          ? stateVars.GetUserByUsername?.length > 0
            ? stateVars.GetUserByUsername[0].id
            : null
          : this.state.GetUserByUsername?.length > 0
          ? this.state.GetUserByUsername[0].id
          : null
      ),
      this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
      ReactSystemFunctions.convertToTypeByName("PROFORMA", "string")
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.TarimsalSulamaOnSureclerComponent_641491_onClick1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  TarimsalSulamaOnSureclerComponent_641491_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      ProjeId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
        "number"
      ),
      IslemTipi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("PROFORMA", "string"),
        "string"
      ),
      DosyalarJson_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, this.state.DosyalariKaydetHazirla),
        "string"
      ),
      KullaniciId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetUserByUsername !== undefined
            ? stateVars.GetUserByUsername?.length > 0
              ? stateVars.GetUserByUsername[0].userName
              : null
            : this.state.GetUserByUsername?.length > 0
            ? this.state.GetUserByUsername[0].userName
            : null
        ),
        "string"
      ),
      ProjeId_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
        "number"
      ),
      KullaniciId_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetUserByUsername !== undefined
            ? stateVars.GetUserByUsername?.length > 0
              ? stateVars.GetUserByUsername[0].id
              : null
            : this.state.GetUserByUsername?.length > 0
            ? this.state.GetUserByUsername[0].id
            : null
        ),
        "string"
      ),
      Proforma_Tutar_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "tarimsalsulamaonsurecler_505390_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      Proforma_DovizTipi_1: ReactSystemFunctions.convertToTypeByName(
        0,
        "number"
      ),
      Proforma_Notu_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "tarimsalsulamaonsurecler_169821_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "TarimsalSulamaOnSurecler/TarimsalSulamaOnSureclerComponent_641491_onClick1_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.TopluDosyaKaydet = result?.data.topluDosyaKaydet;
    stateVars.ON_KESIF_PROFORMA_KAYDET = result?.data.oN_KESIF_PROFORMA_KAYDET;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.TarimsalSulamaOnSureclerComponent_641491_onClick2_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  TarimsalSulamaOnSureclerComponent_641491_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "d4793bb6_6eee_f607_5902_cb6d895ffb3f_notify",
        this.defaultML,
        "Proforma bilgileri başarıyla kaydedildi !"
      ),
      ReactSystemFunctions.convertToTypeByName("success", "string"),
      ReactSystemFunctions.convertToTypeByName("center", "string"),
      3,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );
    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  TarimsalSulamaOnSureclerComponent_899938_onActive = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      UserName_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUsername(),
        "string"
      ),
      DbName_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.AktifSirketGetir !== undefined
            ? stateVars.AktifSirketGetir?.length > 0
              ? stateVars.AktifSirketGetir[0].sirket
              : null
            : this.state.AktifSirketGetir?.length > 0
            ? this.state.AktifSirketGetir[0].sirket
            : null
        ),
        "string"
      ),
      Ara_2: ReactSystemFunctions.convertToTypeByName(null, "string"),
      ProjeID_3: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
        "number"
      ),
      ProjeId_4: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
        "number"
      ),
      IslemTipi_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("NET_KESIF", "string"),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "TarimsalSulamaOnSurecler/TarimsalSulamaOnSureclerComponent_899938_onActive",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.AktifSirketGetir = result?.data.aktifSirketGetir;
    stateVars.GetUserByUsername = result?.data.getUserByUsername;
    stateVars.GET_NETSIS_STOK_LISTESI = result?.data.geT_NETSIS_STOK_LISTESI;

    formVars.tarimsalsulamaonsurecler_393036_options =
      stateVars.GET_NETSIS_STOK_LISTESI;
    stateVars.NET_KESIF_CATI_GETIR = result?.data.neT_KESIF_CATI_GETIR;
    stateVars.PROJE_DOSYLARI_GETIR = result?.data.projE_DOSYLARI_GETIR;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.TarimsalSulamaOnSureclerComponent_899938_onActive1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  TarimsalSulamaOnSureclerComponent_899938_onActive1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.DosyalariDBdenYukle = CWTypeScript.DosyalariDBdenYukle(
      ReactSystemFunctions.toString(
        this,
        stateVars.GetUserByUsername !== undefined
          ? stateVars.GetUserByUsername?.length > 0
            ? stateVars.GetUserByUsername[0].id
            : null
          : this.state.GetUserByUsername?.length > 0
          ? this.state.GetUserByUsername[0].id
          : null
      ),
      this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
      ReactSystemFunctions.convertToTypeByName("NET_KESIF", "string"),
      ReactSystemFunctions.value(this, this.state.PROJE_DOSYLARI_GETIR)
    );
    stateVars.DosyalariGetir = CWTypeScript.DosyalariGetir(
      ReactSystemFunctions.toString(
        this,
        stateVars.GetUserByUsername !== undefined
          ? stateVars.GetUserByUsername?.length > 0
            ? stateVars.GetUserByUsername[0].id
            : null
          : this.state.GetUserByUsername?.length > 0
          ? this.state.GetUserByUsername[0].id
          : null
      ),
      this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
      ReactSystemFunctions.convertToTypeByName("NET_KESIF", "string")
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.TarimsalSulamaOnSureclerComponent_899938_onActive2_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  TarimsalSulamaOnSureclerComponent_899938_onActive2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      ProjeId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
        "number"
      ),
      TipKodu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("NET_KESIF", "string"),
        "string"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "TarimsalSulamaOnSurecler/TarimsalSulamaOnSureclerComponent_899938_onActive2_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.ON_KESIF_KALEMLER_GETIR = result?.data.oN_KESIF_KALEMLER_GETIR;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.TarimsalSulamaOnSureclerComponent_899938_onActive3_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  TarimsalSulamaOnSureclerComponent_899938_onActive3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.KalemleriDBdenYukle = CWTypeScript.KalemleriDBdenYukle(
      ReactSystemFunctions.toString(
        this,
        stateVars.GetUserByUsername !== undefined
          ? stateVars.GetUserByUsername?.length > 0
            ? stateVars.GetUserByUsername[0].id
            : null
          : this.state.GetUserByUsername?.length > 0
          ? this.state.GetUserByUsername[0].id
          : null
      ),
      this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
      ReactSystemFunctions.convertToTypeByName("NET_KESIF", "string"),
      ReactSystemFunctions.value(this, this.state.ON_KESIF_KALEMLER_GETIR)
    );
    stateVars.KalemleriGetir = CWTypeScript.KalemleriGetir(
      ReactSystemFunctions.toString(
        this,
        stateVars.GetUserByUsername !== undefined
          ? stateVars.GetUserByUsername?.length > 0
            ? stateVars.GetUserByUsername[0].id
            : null
          : this.state.GetUserByUsername?.length > 0
          ? this.state.GetUserByUsername[0].id
          : null
      ),
      this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
      ReactSystemFunctions.convertToTypeByName("NET_KESIF", "string")
    );

    formVars.tarimsalsulamaonsurecler_742412_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.KalemleriGetir !== undefined
          ? stateVars.KalemleriGetir?.length > 0
            ? stateVars.KalemleriGetir[0].genelToplam
            : null
          : this.state.KalemleriGetir?.length > 0
          ? this.state.KalemleriGetir[0].genelToplam
          : null
      );
    formVars.tarimsalsulamaonsurecler_505390_value = ReactSystemFunctions.value(
      this,
      stateVars.PROFORMA_GENEL_BILGILERI_GETIR !== undefined
        ? stateVars.PROFORMA_GENEL_BILGILERI_GETIR?.length > 0
          ? stateVars.PROFORMA_GENEL_BILGILERI_GETIR[0].proforma_Tutar
          : null
        : this.state.PROFORMA_GENEL_BILGILERI_GETIR?.length > 0
        ? this.state.PROFORMA_GENEL_BILGILERI_GETIR[0].proforma_Tutar
        : null
    );
    formVars.tarimsalsulamaonsurecler_505390_placeholder =
      ReactSystemFunctions.toString(
        this,
        stateVars.KalemleriGetir !== undefined
          ? stateVars.KalemleriGetir?.length > 0
            ? stateVars.KalemleriGetir[0].genelToplam
            : null
          : this.state.KalemleriGetir?.length > 0
          ? this.state.KalemleriGetir[0].genelToplam
          : null
      );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.TarimsalSulamaOnSureclerComponent_899938_onActive4_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  TarimsalSulamaOnSureclerComponent_899938_onActive4_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {};

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "TarimsalSulamaOnSurecler/TarimsalSulamaOnSureclerComponent_899938_onActive4_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GET_PROJEYONETICI_USERS = result?.data.geT_PROJEYONETICI_USERS;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.TarimsalSulamaOnSureclerComponent_899938_onActive5_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  TarimsalSulamaOnSureclerComponent_899938_onActive5_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_478263 =
      stateVars.KalemleriGetir ?? this.state.KalemleriGetir;

    stateVars.dataSource_393036 =
      stateVars.GET_NETSIS_STOK_LISTESI ?? this.state.GET_NETSIS_STOK_LISTESI;
    stateVars.dataSource_393036 =
      stateVars.GET_NETSIS_STOK_LISTESI ?? this.state.GET_NETSIS_STOK_LISTESI;

    stateVars.dataSource_801362 =
      stateVars.DosyalariGetir ?? this.state.DosyalariGetir;
    formVars.tarimsalsulamaonsurecler_742412_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.KalemleriGetir !== undefined
          ? stateVars.KalemleriGetir?.length > 0
            ? stateVars.KalemleriGetir[0].genelToplam
            : null
          : this.state.KalemleriGetir?.length > 0
          ? this.state.KalemleriGetir[0].genelToplam
          : null
      );

    stateVars.dataSource_266261 =
      stateVars.DosyalariGetir ?? this.state.DosyalariGetir;
    formVars.tarimsalsulamaonsurecler_505390_placeholder =
      ReactSystemFunctions.toString(
        this,
        stateVars.KalemleriGetir !== undefined
          ? stateVars.KalemleriGetir?.length > 0
            ? stateVars.KalemleriGetir[0].genelToplam
            : null
          : this.state.KalemleriGetir?.length > 0
          ? this.state.KalemleriGetir[0].genelToplam
          : null
      );

    stateVars.dataSource_508933 =
      stateVars.KalemleriGetir ?? this.state.KalemleriGetir;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  TarimsalSulamaOnSureclerComponent_442005_onActive = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      ProjeId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
        "number"
      ),
      TipKodu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("NET_KESIF", "string"),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "TarimsalSulamaOnSurecler/TarimsalSulamaOnSureclerComponent_442005_onActive",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.ON_KESIF_KALEMLER_GETIR = result?.data.oN_KESIF_KALEMLER_GETIR;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.TarimsalSulamaOnSureclerComponent_442005_onActive1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  TarimsalSulamaOnSureclerComponent_442005_onActive1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.KalemleriDBdenYukle = CWTypeScript.KalemleriDBdenYukle(
      ReactSystemFunctions.toString(
        this,
        stateVars.GetUserByUsername !== undefined
          ? stateVars.GetUserByUsername?.length > 0
            ? stateVars.GetUserByUsername[0].id
            : null
          : this.state.GetUserByUsername?.length > 0
          ? this.state.GetUserByUsername[0].id
          : null
      ),
      this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
      ReactSystemFunctions.convertToTypeByName("NET_KESIF", "string"),
      ReactSystemFunctions.value(this, this.state.ON_KESIF_KALEMLER_GETIR)
    );
    stateVars.KalemleriGetir = CWTypeScript.KalemleriGetir(
      ReactSystemFunctions.toString(
        this,
        stateVars.GetUserByUsername !== undefined
          ? stateVars.GetUserByUsername?.length > 0
            ? stateVars.GetUserByUsername[0].id
            : null
          : this.state.GetUserByUsername?.length > 0
          ? this.state.GetUserByUsername[0].id
          : null
      ),
      this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
      ReactSystemFunctions.convertToTypeByName("NET_KESIF", "string")
    );

    formVars.tarimsalsulamaonsurecler_742412_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.KalemleriGetir !== undefined
          ? stateVars.KalemleriGetir?.length > 0
            ? stateVars.KalemleriGetir[0].genelToplam
            : null
          : this.state.KalemleriGetir?.length > 0
          ? this.state.KalemleriGetir[0].genelToplam
          : null
      );
    formVars.tarimsalsulamaonsurecler_505390_value = ReactSystemFunctions.value(
      this,
      stateVars.PROFORMA_GENEL_BILGILERI_GETIR !== undefined
        ? stateVars.PROFORMA_GENEL_BILGILERI_GETIR?.length > 0
          ? stateVars.PROFORMA_GENEL_BILGILERI_GETIR[0].proforma_Tutar
          : null
        : this.state.PROFORMA_GENEL_BILGILERI_GETIR?.length > 0
        ? this.state.PROFORMA_GENEL_BILGILERI_GETIR[0].proforma_Tutar
        : null
    );
    formVars.tarimsalsulamaonsurecler_505390_placeholder =
      ReactSystemFunctions.toString(
        this,
        stateVars.KalemleriGetir !== undefined
          ? stateVars.KalemleriGetir?.length > 0
            ? stateVars.KalemleriGetir[0].genelToplam
            : null
          : this.state.KalemleriGetir?.length > 0
          ? this.state.KalemleriGetir[0].genelToplam
          : null
      );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.TarimsalSulamaOnSureclerComponent_442005_onActive2_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  TarimsalSulamaOnSureclerComponent_442005_onActive2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      DbName_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.AktifSirketGetir !== undefined
            ? stateVars.AktifSirketGetir?.length > 0
              ? stateVars.AktifSirketGetir[0].sirket
              : null
            : this.state.AktifSirketGetir?.length > 0
            ? this.state.AktifSirketGetir[0].sirket
            : null
        ),
        "string"
      ),
      ProjeKodu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netsisProjKodu
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].netsisProjKodu
            : null
        ),
        "string"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "TarimsalSulamaOnSurecler/TarimsalSulamaOnSureclerComponent_442005_onActive2_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.PROFORMA_KALEMLERI_GETIR = result?.data.proformA_KALEMLERI_GETIR;

    formVars.tarimsalsulamaonsurecler_189730_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.PROFORMA_KALEMLERI_GETIR !== undefined
          ? stateVars.PROFORMA_KALEMLERI_GETIR?.length > 0
            ? stateVars.PROFORMA_KALEMLERI_GETIR[0].geneltoplam
            : null
          : this.state.PROFORMA_KALEMLERI_GETIR?.length > 0
          ? this.state.PROFORMA_KALEMLERI_GETIR[0].geneltoplam
          : null
      );
    formVars.tarimsalsulamaonsurecler_328239_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.PROFORMA_KALEMLERI_GETIR !== undefined
          ? stateVars.PROFORMA_KALEMLERI_GETIR?.length > 0
            ? stateVars.PROFORMA_KALEMLERI_GETIR[0].geneltoplam
            : null
          : this.state.PROFORMA_KALEMLERI_GETIR?.length > 0
          ? this.state.PROFORMA_KALEMLERI_GETIR[0].geneltoplam
          : null
      );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.TarimsalSulamaOnSureclerComponent_442005_onActive3_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  TarimsalSulamaOnSureclerComponent_442005_onActive3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_478263 =
      stateVars.KalemleriGetir ?? this.state.KalemleriGetir;
    formVars.tarimsalsulamaonsurecler_742412_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.KalemleriGetir !== undefined
          ? stateVars.KalemleriGetir?.length > 0
            ? stateVars.KalemleriGetir[0].genelToplam
            : null
          : this.state.KalemleriGetir?.length > 0
          ? this.state.KalemleriGetir[0].genelToplam
          : null
      );

    stateVars.dataSource_200053 =
      stateVars.PROFORMA_KALEMLERI_GETIR ?? this.state.PROFORMA_KALEMLERI_GETIR;
    formVars.tarimsalsulamaonsurecler_189730_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.PROFORMA_KALEMLERI_GETIR !== undefined
          ? stateVars.PROFORMA_KALEMLERI_GETIR?.length > 0
            ? stateVars.PROFORMA_KALEMLERI_GETIR[0].geneltoplam
            : null
          : this.state.PROFORMA_KALEMLERI_GETIR?.length > 0
          ? this.state.PROFORMA_KALEMLERI_GETIR[0].geneltoplam
          : null
      );

    formVars.tarimsalsulamaonsurecler_505390_placeholder =
      ReactSystemFunctions.toString(
        this,
        stateVars.KalemleriGetir !== undefined
          ? stateVars.KalemleriGetir?.length > 0
            ? stateVars.KalemleriGetir[0].genelToplam
            : null
          : this.state.KalemleriGetir?.length > 0
          ? this.state.KalemleriGetir[0].genelToplam
          : null
      );

    stateVars.dataSource_822795 =
      stateVars.PROFORMA_KALEMLERI_GETIR ?? this.state.PROFORMA_KALEMLERI_GETIR;
    formVars.tarimsalsulamaonsurecler_328239_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.PROFORMA_KALEMLERI_GETIR !== undefined
          ? stateVars.PROFORMA_KALEMLERI_GETIR?.length > 0
            ? stateVars.PROFORMA_KALEMLERI_GETIR[0].geneltoplam
            : null
          : this.state.PROFORMA_KALEMLERI_GETIR?.length > 0
          ? this.state.PROFORMA_KALEMLERI_GETIR[0].geneltoplam
          : null
      );

    stateVars.dataSource_508933 =
      stateVars.KalemleriGetir ?? this.state.KalemleriGetir;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  TarimsalSulamaOnSureclerComponent_551404_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      ProjeId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
        "number"
      ),
      KullaniciId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetUserByUsername !== undefined
            ? stateVars.GetUserByUsername?.length > 0
              ? stateVars.GetUserByUsername[0].id
              : null
            : this.state.GetUserByUsername?.length > 0
            ? this.state.GetUserByUsername[0].id
            : null
        ),
        "string"
      ),
      OnayNotu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "tarimsalsulamaonsurecler_858665_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "TarimsalSulamaOnSurecler/TarimsalSulamaOnSureclerComponent_551404_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.ON_SUREC_PM_GERI_AL = result?.data.oN_SUREC_PM_GERI_AL;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.TarimsalSulamaOnSureclerComponent_551404_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  TarimsalSulamaOnSureclerComponent_551404_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "d9482151_7381_0714_ca53_c8c47cd12aad_notify",
        this.defaultML,
        "Proje Onayı Geri Alındı !"
      ),
      ReactSystemFunctions.convertToTypeByName("info", "string"),
      ReactSystemFunctions.convertToTypeByName("center", "string"),
      4,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );
    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  TarimsalSulamaOnSureclerComponent_687126_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      ProjeId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
        "number"
      ),
      KullaniciID_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetUserByUsername !== undefined
            ? stateVars.GetUserByUsername?.length > 0
              ? stateVars.GetUserByUsername[0].id
              : null
            : this.state.GetUserByUsername?.length > 0
            ? this.state.GetUserByUsername[0].id
            : null
        ),
        "string"
      ),
      OnayNotu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "tarimsalsulamaonsurecler_858665_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "TarimsalSulamaOnSurecler/TarimsalSulamaOnSureclerComponent_687126_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.ON_SUREC_PM_ONAYLA = result?.data.oN_SUREC_PM_ONAYLA;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.TarimsalSulamaOnSureclerComponent_687126_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  TarimsalSulamaOnSureclerComponent_687126_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "41233a97_b393_c420_9fc1_e3d5481fc5aa_notify",
        this.defaultML,
        "Proje Başarıyla Onaylandı !"
      ),
      ReactSystemFunctions.convertToTypeByName("success", "string"),
      ReactSystemFunctions.convertToTypeByName("center", "string"),
      4,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );
    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  TarimsalSulamaOnSureclerComponent_494735_onActive = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      ProjeId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
        "number"
      ),
      TipKodu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("NET_KESIF", "string"),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "TarimsalSulamaOnSurecler/TarimsalSulamaOnSureclerComponent_494735_onActive",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.ON_KESIF_KALEMLER_GETIR = result?.data.oN_KESIF_KALEMLER_GETIR;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.TarimsalSulamaOnSureclerComponent_494735_onActive1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  TarimsalSulamaOnSureclerComponent_494735_onActive1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.KalemleriDBdenYukle = CWTypeScript.KalemleriDBdenYukle(
      ReactSystemFunctions.toString(
        this,
        stateVars.GetUserByUsername !== undefined
          ? stateVars.GetUserByUsername?.length > 0
            ? stateVars.GetUserByUsername[0].id
            : null
          : this.state.GetUserByUsername?.length > 0
          ? this.state.GetUserByUsername[0].id
          : null
      ),
      this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
      ReactSystemFunctions.convertToTypeByName("NET_KESIF", "string"),
      ReactSystemFunctions.value(this, this.state.ON_KESIF_KALEMLER_GETIR)
    );
    stateVars.KalemleriGetir = CWTypeScript.KalemleriGetir(
      ReactSystemFunctions.toString(
        this,
        stateVars.GetUserByUsername !== undefined
          ? stateVars.GetUserByUsername?.length > 0
            ? stateVars.GetUserByUsername[0].id
            : null
          : this.state.GetUserByUsername?.length > 0
          ? this.state.GetUserByUsername[0].id
          : null
      ),
      this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
      ReactSystemFunctions.convertToTypeByName("NET_KESIF", "string")
    );

    formVars.tarimsalsulamaonsurecler_742412_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.KalemleriGetir !== undefined
          ? stateVars.KalemleriGetir?.length > 0
            ? stateVars.KalemleriGetir[0].genelToplam
            : null
          : this.state.KalemleriGetir?.length > 0
          ? this.state.KalemleriGetir[0].genelToplam
          : null
      );
    formVars.tarimsalsulamaonsurecler_505390_value = ReactSystemFunctions.value(
      this,
      stateVars.PROFORMA_GENEL_BILGILERI_GETIR !== undefined
        ? stateVars.PROFORMA_GENEL_BILGILERI_GETIR?.length > 0
          ? stateVars.PROFORMA_GENEL_BILGILERI_GETIR[0].proforma_Tutar
          : null
        : this.state.PROFORMA_GENEL_BILGILERI_GETIR?.length > 0
        ? this.state.PROFORMA_GENEL_BILGILERI_GETIR[0].proforma_Tutar
        : null
    );
    formVars.tarimsalsulamaonsurecler_505390_placeholder =
      ReactSystemFunctions.toString(
        this,
        stateVars.KalemleriGetir !== undefined
          ? stateVars.KalemleriGetir?.length > 0
            ? stateVars.KalemleriGetir[0].genelToplam
            : null
          : this.state.KalemleriGetir?.length > 0
          ? this.state.KalemleriGetir[0].genelToplam
          : null
      );

    stateVars.dataSource_478263 =
      stateVars.KalemleriGetir ?? this.state.KalemleriGetir;
    formVars.tarimsalsulamaonsurecler_742412_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.KalemleriGetir !== undefined
          ? stateVars.KalemleriGetir?.length > 0
            ? stateVars.KalemleriGetir[0].genelToplam
            : null
          : this.state.KalemleriGetir?.length > 0
          ? this.state.KalemleriGetir[0].genelToplam
          : null
      );

    formVars.tarimsalsulamaonsurecler_505390_placeholder =
      ReactSystemFunctions.toString(
        this,
        stateVars.KalemleriGetir !== undefined
          ? stateVars.KalemleriGetir?.length > 0
            ? stateVars.KalemleriGetir[0].genelToplam
            : null
          : this.state.KalemleriGetir?.length > 0
          ? this.state.KalemleriGetir[0].genelToplam
          : null
      );

    stateVars.dataSource_508933 =
      stateVars.KalemleriGetir ?? this.state.KalemleriGetir;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  TarimsalSulamaOnSureclerComponent_233488_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      ProjeId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
        "number"
      ),
      KullaniciId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetUserByUsername !== undefined
            ? stateVars.GetUserByUsername?.length > 0
              ? stateVars.GetUserByUsername[0].id
              : null
            : this.state.GetUserByUsername?.length > 0
            ? this.state.GetUserByUsername[0].id
            : null
        ),
        "string"
      ),
      OnayNotu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "tarimsalsulamaonsurecler_961677_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "TarimsalSulamaOnSurecler/TarimsalSulamaOnSureclerComponent_233488_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.ON_SUREC_UY_ONAY_GERIAL = result?.data.oN_SUREC_UY_ONAY_GERIAL;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.TarimsalSulamaOnSureclerComponent_233488_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  TarimsalSulamaOnSureclerComponent_233488_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "7fb695ce_501a_1191_efde_41261da9e493_notify",
        this.defaultML,
        "Proje onayı geri alındı !"
      ),
      ReactSystemFunctions.convertToTypeByName("info", "string"),
      ReactSystemFunctions.convertToTypeByName("center", "string"),
      3,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );
    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  TarimsalSulamaOnSureclerComponent_320489_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      ProjeId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
        "number"
      ),
      KullaniciId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetUserByUsername !== undefined
            ? stateVars.GetUserByUsername?.length > 0
              ? stateVars.GetUserByUsername[0].id
              : null
            : this.state.GetUserByUsername?.length > 0
            ? this.state.GetUserByUsername[0].id
            : null
        ),
        "string"
      ),
      OnayNotu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "tarimsalsulamaonsurecler_961677_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "TarimsalSulamaOnSurecler/TarimsalSulamaOnSureclerComponent_320489_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.ON_SUREC_UY_ONAYLA = result?.data.oN_SUREC_UY_ONAYLA;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.TarimsalSulamaOnSureclerComponent_320489_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  TarimsalSulamaOnSureclerComponent_320489_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "7af991ef_3de1_965e_d0f9_b7c3c879d15d_notify",
        this.defaultML,
        "Proje başarıyla onaylandı !"
      ),
      ReactSystemFunctions.convertToTypeByName("success", "string"),
      ReactSystemFunctions.convertToTypeByName("center", "string"),
      3,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );
    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  TarimsalSulamaOnSureclerComponent_149112_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.isComp724523Visible =
      (ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "tarimsalsulamaonsurecler_149112_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "HP"
      ) ||
        ReactSystemFunctions.isEmpty(
          ReactSystemFunctions.toString(
            this,
            ReactSystemFunctions.value(
              this,
              "tarimsalsulamaonsurecler_149112_value",
              "value",
              "",
              "key",
              ""
            )
          ),
          true
        )) === true
        ? "visible"
        : "hidden";
    stateVars.isComp724523Visible =
      (ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "tarimsalsulamaonsurecler_149112_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "HP"
      ) ||
        ReactSystemFunctions.isEmpty(
          ReactSystemFunctions.toString(
            this,
            ReactSystemFunctions.value(
              this,
              "tarimsalsulamaonsurecler_149112_value",
              "value",
              "",
              "key",
              ""
            )
          ),
          true
        )) === true
        ? "visible"
        : "hidden";
    stateVars.isComp867312Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "tarimsalsulamaonsurecler_149112_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "kW"
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp987888Visible =
      (ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "tarimsalsulamaonsurecler_149112_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "HP"
      ) ||
        ReactSystemFunctions.isEmpty(
          ReactSystemFunctions.toString(
            this,
            ReactSystemFunctions.value(
              this,
              "tarimsalsulamaonsurecler_149112_value",
              "value",
              "",
              "key",
              ""
            )
          ),
          true
        )) === true
        ? "visible"
        : "hidden";
    stateVars.isComp987888Visible =
      (ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "tarimsalsulamaonsurecler_149112_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "HP"
      ) ||
        ReactSystemFunctions.isEmpty(
          ReactSystemFunctions.toString(
            this,
            ReactSystemFunctions.value(
              this,
              "tarimsalsulamaonsurecler_149112_value",
              "value",
              "",
              "key",
              ""
            )
          ),
          true
        )) === true
        ? "visible"
        : "hidden";
    stateVars.isComp564425Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "tarimsalsulamaonsurecler_149112_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "kW"
      ) === true
        ? "visible"
        : "hidden";

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.TarimsalSulamaOnSureclerPageInit();
    }
  }
}
